import { AISearch, AISearchToggle } from './ai-search.jsx';
const { useState, useEffect, useCallback, useRef, useLayoutEffect, useMemo } = React;
const API_BASE = '/api';

// ============ UTILS ============
function generateId(){return Date.now().toString(36)+Math.random().toString(36).slice(2,8)}
function getInitial(name){if(!name)return'?';return name.charAt(0).toUpperCase()}
function extractDomain(url){try{const u=new URL(url.startsWith('http')?url:'https://'+url);return u.hostname.replace('www.','')}catch{return url}}
function getFaviconUrl(url){try{const u=new URL(url.startsWith('http')?url:'https://'+url);return`https://favicon.im/${u.hostname}`}catch{return null}}


const SEARCH_ENGINES={
  baidu:{name:'百度',url:'https://www.baidu.com/s?wd='},
  bing:{name:'Bing',url:'https://www.bing.com/search?q='},
  google:{name:'Google',url:'https://www.google.com/search?q='}
};

const DEFAULT_WALLPAPER={id:'w1',type:'gradient',value:'linear-gradient(135deg, #d4c4a8 0%, #c4a882 100%)'};

// ===== 自定义时钟字体 (public/fonts) =====
const FONTS=[
  {key:'default',name:'默认',family:''},
  {key:'ds-digital',name:'DS 数码管',family:'Qomo-DS-Digital'},
  {key:'goodfon',name:'Goodfon 点阵',family:'Qomo-Goodfon'},
  {key:'hf-sharp',name:'HF Sharp',family:'Qomo-HF-Sharp'},
  {key:'ka1',name:'KA1 简约',family:'Qomo-KA1'},
  {key:'led',name:'LED 显示屏',family:'Qomo-LED'},
  {key:'neon',name:'霓虹 Neon',family:'Qomo-Neon'},
  {key:'prisma',name:'棱镜 Prisma',family:'Qomo-Prisma'},
  {key:'screen-matrix',name:'屏幕矩阵',family:'Qomo-ScreenMatrix'},
  {key:'seldom-scene',name:'Seldom 场景',family:'Qomo-SeldomScene'},
  {key:'sounso-king',name:'宋宋王',family:'Qomo-SounsoKing'},
];

// 时钟颜色预设
const CLOCK_COLORS=[
  {key:'default',name:'默认',value:''},
  {key:'white',name:'米白',value:'#f0ebe3'},
  {key:'black',name:'墨黑',value:'#1a1a1a'},
  {key:'amber',name:'琥珀',value:'#d97706'},
  {key:'red',name:'红',value:'#ef4444'},
  {key:'green',name:'绿',value:'#22c55e'},
  {key:'blue',name:'蓝',value:'#3b82f6'},
  {key:'purple',name:'紫',value:'#a855f7'},
  {key:'cyan',name:'青',value:'#06b6d4'},
];

// 画报信源列表(设置中可开关)
const NEWS_SOURCE_LIST=['中国新闻网','中新网要闻','极客公园','爱范儿','奇客Solidot'];
const AI_SOURCE_LIST=['TechCrunch AI','Ars Technica AI','MIT Tech Review','AI News'];
const LEAGUE_LIST=[
  {key:'nba',name:'NBA'},{key:'epl',name:'英超'},{key:'laliga',name:'西甲'},
  {key:'seriea',name:'意甲'},{key:'bundesliga',name:'德甲'},{key:'ligue1',name:'法甲'},{key:'ucl',name:'欧冠'},
];

// ===== 农历转换(1900-2100,经典算法) =====
const LUNAR_INFO=[0x04bd8,0x04ae0,0x0a570,0x054d5,0x0d260,0x0d950,0x16554,0x056a0,0x09ad0,0x055d2,0x04ae0,0x0a5b6,0x0a4d0,0x0d250,0x1d255,0x0b540,0x0d6a0,0x0ada2,0x095b0,0x14977,0x04970,0x0a4b0,0x0b4b5,0x06a50,0x06d40,0x1ab54,0x02b60,0x09570,0x052f2,0x04970,0x06566,0x0d4a0,0x0ea50,0x06e95,0x05ad0,0x02b60,0x186e3,0x092e0,0x1c8d7,0x0c950,0x0d4a0,0x1d8a6,0x0b550,0x056a0,0x1a5b4,0x025d0,0x092d0,0x0d2b2,0x0a950,0x0b557,0x06ca0,0x0b550,0x15355,0x04da0,0x0a5b0,0x14573,0x052b0,0x0a9a8,0x0e950,0x06aa0,0x0aea6,0x0ab50,0x04b60,0x0aae4,0x0a570,0x05260,0x0f263,0x0d950,0x05b57,0x056a0,0x096d0,0x04dd5,0x04ad0,0x0a4d0,0x0d4d4,0x0d250,0x0d558,0x0b540,0x0b6a0,0x195a6,0x095b0,0x049b0,0x0a974,0x0a4b0,0x0b27a,0x06a50,0x06d40,0x0af46,0x0ab60,0x09570,0x04af5,0x04970,0x064b0,0x074a3,0x0ea50,0x06b58,0x055c0,0x0ab60,0x096d5,0x092e0,0x0c960,0x0d954,0x0d4a0,0x0da50,0x07552,0x056a0,0x0abb7,0x025d0,0x092d0,0x0cab5,0x0a950,0x0b4a0,0x0baa4,0x0ad50,0x055d9,0x04ba0,0x0a5b0,0x15176,0x052b0,0x0a930,0x07954,0x06aa0,0x0ad50,0x05b52,0x04b60,0x0a6e6,0x0a4e0,0x0d260,0x0ea65,0x0d530,0x05aa0,0x076a3,0x096d0,0x04afb,0x04ad0,0x0a4d0,0x0d4b6,0x0d250,0x0d520,0x0dd45,0x0b5a0,0x056d0,0x055b2,0x049b0,0x0a577,0x0a4b0,0x0aa50,0x1b255,0x06d20,0x0ada0,0x14b63,0x09370,0x049f8,0x04970,0x064b0,0x168a6,0x0ea50,0x06b20,0x1a6c4,0x0aae0,0x0a2e0,0x0d2e3,0x0c960,0x0d557,0x0d4a0,0x0da50,0x05d55,0x056a0,0x0a6d0,0x055d4,0x052d0,0x0a9b8,0x0a950,0x0b4a0,0x0b6a6,0x0ad50,0x055a0,0x0aba4,0x0a5b0,0x052b0,0x0b273,0x06930,0x07337,0x06aa0,0x0ad50,0x14b55,0x04b60,0x0a570,0x054e4,0x0d160,0x0e968,0x0d520,0x0daa0,0x16aa6,0x056d0,0x04ae0,0x0a9d4,0x0a2d0,0x0d150,0x0f252,0x0d520];
const GAN=['甲','乙','丙','丁','戊','己','庚','辛','壬','癸'];
const ZHI=['子','丑','寅','卯','辰','巳','午','未','申','酉','戌','亥'];
const ANIMALS=['鼠','牛','虎','兔','龙','蛇','马','羊','猴','鸡','狗','猪'];
const LUNAR_MONTHS=['正','二','三','四','五','六','七','八','九','十','冬','腊'];
const LUNAR_DAYS=['初一','初二','初三','初四','初五','初六','初七','初八','初九','初十','十一','十二','十三','十四','十五','十六','十七','十八','十九','二十','廿一','廿二','廿三','廿四','廿五','廿六','廿七','廿八','廿九','三十'];
const lunarLeapMonth=y=>LUNAR_INFO[y-1900]&0xf;
const lunarLeapDays=y=>lunarLeapMonth(y)?((LUNAR_INFO[y-1900]&0x10000)?30:29):0;
const lunarMonthDays=(y,m)=>(LUNAR_INFO[y-1900]&(0x10000>>m))?30:29;
const lunarYearDays=y=>{
  let sum=348;
  for(let i=0x8000;i>0x8;i>>=1)sum+=(LUNAR_INFO[y-1900]&i)?1:0;
  return sum+lunarLeapDays(y);
};
function getLunar(date){
  let offset=Math.floor((date.getTime()-new Date(1900,0,31).getTime())/86400000);
  let y=1900,temp=0;
  for(;y<2101&&offset>0;y++){temp=lunarYearDays(y);offset-=temp;}
  if(offset<0){offset+=temp;y--;}
  const year=y;
  const leap=lunarLeapMonth(year);
  let isLeap=false,i;
  for(i=1;i<13&&offset>0;i++){
    if(leap>0&&i===(leap+1)&&!isLeap){--i;isLeap=true;temp=lunarLeapDays(year);}
    else{temp=lunarMonthDays(year,i);}
    if(isLeap&&i===(leap+1))isLeap=false;
    offset-=temp;
  }
  if(offset===0&&leap>0&&i===(leap+1)){
    if(isLeap){isLeap=false;}else{isLeap=true;--i;}
  }
  if(offset<0){offset+=temp;--i;}
  const month=i;
  const day=offset+1;
  return {
    ganZhi:GAN[(year-4)%10]+ZHI[(year-4)%12],
    animal:ANIMALS[(year-4)%12],
    label:(isLeap?'闰':'')+LUNAR_MONTHS[month-1]+'月'+LUNAR_DAYS[day-1],
  };
}

const DEFAULT_SHORTCUTS=[
  {id:'s1',name:'Qomo值日',url:'https://duty.qomotools.cn/',icon:''},
  {id:'s2',name:'Qomo文档',url:'https://doc.qomotools.cn/',icon:''},
  {id:'s3',name:'Qomo网盘',url:'https://drive.qomotools.cn/',icon:''},
];

// ============ API & STORAGE ============
async function uploadFile(path,formData){
  const res=await fetch(API_BASE+path,{method:'POST',body:formData});
  const data=await res.json();
  if(!res.ok)throw new Error(data.error||'上传失败');
  return data;
}

const LK='qomo_sp_local';
function loadLocal(){try{const r=localStorage.getItem(LK);return r?JSON.parse(r):{}}catch{return{}}}
function saveLocal(d){localStorage.setItem(LK,JSON.stringify(d))}

// IndexedDB 壁纸缓存（Bing 每日图：本地秒开 + 后台更新）
const IDB_NAME='qomo_wallpaper_cache';
const IDB_STORE='images';
function idbOpen(){return new Promise((res,rej)=>{try{const r=indexedDB.open(IDB_NAME,1);r.onupgradeneeded=()=>{r.result.createObjectStore(IDB_STORE)};r.onsuccess=()=>res(r.result);r.onerror=()=>rej(r.error)}catch(e){rej(e)}})}
async function idbGet(key){try{const db=await idbOpen();return await new Promise((res,rej)=>{const rq=db.transaction(IDB_STORE,'readonly').objectStore(IDB_STORE).get(key);rq.onsuccess=()=>res(rq.result||null);rq.onerror=()=>rej(rq.error)})}catch{return null}}
async function idbSet(key,val){try{const db=await idbOpen();await new Promise((res,rej)=>{const rq=db.transaction(IDB_STORE,'readwrite').objectStore(IDB_STORE).put(val,key);rq.onsuccess=()=>res();rq.onerror=()=>rej(rq.error)})}catch{}}
const todayStr=()=>{const d=new Date();return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0')};

// 清洗 localStorage 中的快捷方式数据：过滤异常字段（历史 bug 可能写入 name 为对象等脏数据，导致 React 崩溃）
function sanitizeShortcuts(list){
  if(!Array.isArray(list))return [];
  return list.filter(s=>s&&typeof s==='object').map(s=>{
    const isGroup=s.type==='group';
    return {
      id:typeof s.id==='string'&&s.id?s.id:generateId(),
      name:typeof s.name==='string'&&s.name?s.name:'未命名',
      url:isGroup?'':typeof s.url==='string'?s.url:'',
      icon:typeof s.icon==='string'?s.icon:'',
      type:isGroup?'group':undefined,
      groupId:typeof s.groupId==='string'?s.groupId:'',
    };
  }).filter(s=>s.type==='group'||s.url);
}

// ============ ICONS ============
const Icons={
  Search:()=>(<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>),
  Settings:()=>(<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/></svg>),
  ChevronDown:()=>(<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>),
  Plus:()=>(<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>),
  XSmall:()=>(<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>),
  // Weather icons (inline SVG)
  WeatherSunny:()=>(<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>),
  WeatherCloudy:()=>(<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/></svg>),
  WeatherPartlyCloudy:()=>(<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="8" r="4"/><line x1="8" y1="2" x2="8" y2="4"/><line x1="8" y1="12" x2="8" y2="14"/><line x1="1" y1="8" x2="3" y2="8"/><line x1="13" y1="8" x2="15" y2="8"/><path d="M14 16h4.5a3.5 3.5 0 1 0 0-7"/><path d="M6 16h8.5a3.5 3.5 0 1 0 0-7"/></svg>),
  WeatherOvercast:()=>(<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M6 10h12a4 4 0 0 1 0 8H6a5 5 0 0 1 0-10z"/><path d="M18 10a5 5 0 0 0-9.5-1.5"/></svg>),
  WeatherRain:()=>(<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M6 10h12a4 4 0 0 1 0 8H6a5 5 0 0 1 0-10z"/><line x1="8" y1="18" x2="8.01" y2="18"/><line x1="12" y1="18" x2="12.01" y2="18"/><line x1="16" y1="18" x2="16.01" y2="18"/><line x1="8" y1="21" x2="8.01" y2="21"/><line x1="12" y1="21" x2="12.01" y2="21"/><line x1="16" y1="21" x2="16.01" y2="21"/></svg>),
  WeatherSnow:()=>(<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M6 10h12a4 4 0 0 1 0 8H6a5 5 0 0 1 0-10z"/><line x1="8" y1="18" x2="8.01" y2="18"/><line x1="12" y1="18" x2="12.01" y2="18"/><line x1="16" y1="18" x2="16.01" y2="18"/></svg>),
  WeatherFog:()=>(<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="8" x2="21" y2="8"/><line x1="7" y1="12" x2="19" y2="12"/><line x1="5" y1="16" x2="17" y2="16"/></svg>),
};

// ============ TOAST ============
function useToast(){
  const [msg,setMsg]=useState('');
  const ref=useRef(null);
  const show=(m)=>{setMsg(m);clearTimeout(ref.current);ref.current=setTimeout(()=>setMsg(''),2500)};
  return [msg,show];
}

// ============ WEATHER ============
// QWeather icon codes → display component
function getWeatherIcon(code) {
  const c = parseInt(code);
  if (c === 100) return Icons.WeatherSunny;
  if (c === 101 || c === 102) return Icons.WeatherPartlyCloudy;
  if (c === 103 || c === 104) return Icons.WeatherOvercast;
  if (c >= 200 && c < 300) return Icons.WeatherCloudy; // wind
  if (c >= 300 && c < 400) return Icons.WeatherRain;
  if (c >= 400 && c < 500) return Icons.WeatherSnow;
  if (c >= 500 && c < 600) return Icons.WeatherFog;
  return Icons.WeatherCloudy;
}

function WeatherWidget({onChange}) {
  const [weather, setWeather] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [locPending, setLocPending] = useState(false);
  const timerRef = useRef(null);
  useLayoutEffect(()=>{onChange?.()},[weather,loading,error,locPending,onChange]);

  const fetchWeather = useCallback(async (lat, lon) => {
    try {
      const res = await fetch(`${API_BASE}/weather?location=${lon},${lat}`);
      const data = await res.json();
      if (data.code === '200' && data.now) {
        setWeather(data.now);
        setError(null);
      } else {
        // QWeather 错误体可能是对象 {status,type,title,detail} 或纯字符串
        const errObj = data.error;
        const errMsg = typeof errObj === 'string' ? errObj : (errObj?.detail || errObj?.title || JSON.stringify(errObj) || '天气服务不可用');
        setError(errMsg);
      }
    } catch (e) {
      setError('网络错误');
    }
    setLoading(false);
  }, []);

  const fetchIpLocation = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/location`);
      const data = await res.json();
      if (data.lat && data.lon) {
        localStorage.setItem('qomo_weather_loc', JSON.stringify({ lat: data.lat, lon: data.lon, ts: Date.now() }));
        setLocPending(false);
        fetchWeather(data.lat, data.lon);
        return;
      }
    } catch (e) {
      console.log('[天气] IP定位也失败:', e.message);
    }
    setLocPending(false);
    setError('无法获取位置');
    setLoading(false);
  }, [fetchWeather]);

  const requestLocation = useCallback(() => {
    setError(null);
    setLocPending(true);
    setLoading(true);
    if (!navigator.geolocation) {
      console.log('[天气] 浏览器不支持定位 → 尝试IP定位');
      fetchIpLocation();
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        // 用户允许访问
        const lat = pos.coords.latitude.toFixed(2);
        const lon = pos.coords.longitude.toFixed(2);
        console.log('[天气] 地理位置权限已获取', {lat, lon});
        localStorage.setItem('qomo_weather_loc', JSON.stringify({ lat, lon, ts: Date.now() }));
        setLocPending(false);
        fetchWeather(lat, lon);
      },
      (err) => {
        // 用户拒绝 / 定位失败，fallback 到 IP 定位
        console.warn('[天气] 获取地理位置权限失败:', err.message, '→ 尝试IP定位');
        fetchIpLocation();
      },
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 }
    );
  }, [fetchWeather, fetchIpLocation]);

  useEffect(() => {
    // Check cache first
    const saved = localStorage.getItem('qomo_weather_loc');
    if (saved) {
      try {
        const { lat, lon, ts } = JSON.parse(saved);
        if (ts && Date.now() - ts < 3600000) {
          fetchWeather(lat, lon);
          return;
        }
      } catch (e) {}
    }
    // Request fresh location
    requestLocation();
  }, []);

  // Auto refresh every 30 min
  useEffect(() => {
    timerRef.current = setInterval(() => {
      const saved = localStorage.getItem('qomo_weather_loc');
      if (saved) {
        try {
          const { lat, lon } = JSON.parse(saved);
          fetchWeather(lat, lon);
        } catch (e) {}
      }
    }, 1800000);
    return () => clearInterval(timerRef.current);
  }, [fetchWeather]);

  if (loading) {
    return (
      <div className="weather-widget" title="正在获取天气...">
        <div className="weather-loading-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="weather-widget" onClick={requestLocation} title={locPending ? '正在获取位置...' : '点击重新获取位置'}>
        <span className="weather-error-text">{locPending ? '定位中…' : error}</span>
      </div>
    );
  }

  if (!weather) return null;

  const WeatherIcon = getWeatherIcon(weather.icon);
  return (
    <div className="weather-widget" title={`体感 ${weather.feelsLike}°C · ${weather.windDir} ${weather.windScale}级 · 能见度 ${weather.vis}km`}>
      <div className="weather-icon-wrap"><WeatherIcon /></div>
      <span className="weather-temp">{weather.temp}°</span>
      <div className="weather-detail">
        <span className="weather-detail-sep" />
        <span>{weather.humidity}%</span>
        <span className="weather-detail-sep" />
        <span>{weather.text}</span>
      </div>
    </div>
  );
}

// ============ MODAL ============
function Modal({title,children,onClose}){
  const [closing,setClosing]=useState(false),closeTimer=useRef(0),closeCallback=useRef(onClose);
  closeCallback.current=onClose;
  const close=()=>{if(closeTimer.current)return;setClosing(true);closeTimer.current=setTimeout(()=>closeCallback.current(),matchMedia('(prefers-reduced-motion:reduce)').matches?0:200)};
  useEffect(()=>{
    const h=(e)=>{if(e.key==='Escape')close()};
    window.addEventListener('keydown',h);
    document.body.style.overflow='hidden';
    return()=>{window.removeEventListener('keydown',h);clearTimeout(closeTimer.current);document.body.style.overflow=''};
  },[]);
  return(
    <div className={"modal-overlay"+(closing?" closing":"")} onClick={e=>e.target===e.currentTarget&&close()}>
      <div className="modal-card">
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="modal-close" onClick={close}>✕</button>
        </div>
        <div className="modal-body">{typeof children==='function'?children(close):children}</div>
      </div>
    </div>
  );
}

// ============ SHORTCUT MODAL (添加/编辑) ============
function ShortcutModal({initial,groups,defaultGroupId,onClose,onSave}){
  const isEdit=!!initial;
  const [name,setName]=useState(initial?.name||'');
  const [url,setUrl]=useState(initial?.url||'');
  const [icon,setIcon]=useState(initial?.icon||'');
  const [groupId,setGroupId]=useState(initial?.groupId||defaultGroupId||'');
  const [err,setErr]=useState('');

  const autoFetchIcon=u=>{
    if(!u.trim()){setIcon('');return}
    const fav=getFaviconUrl(u);
    const img=new Image();img.crossOrigin='anonymous';
    img.onload=()=>setIcon(fav);
    img.onerror=()=>setIcon('');
    img.src=fav;
  };

  const handleSubmit=e=>{
    e.preventDefault();
    if(!name.trim()){setErr('请输入名称');return}
    if(!url.trim()){setErr('请输入网址');return}
    let finalUrl=url.trim();
    if(!finalUrl.startsWith('http'))finalUrl='https://'+finalUrl;
    onSave({id:initial?.id||generateId(),name:name.trim(),url:finalUrl,icon,groupId:groupId||''});
    onClose();
  };

  return(
    <Modal title={isEdit?'编辑快捷方式':'添加快捷方式'} onClose={onClose}>
      {close=><form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">名称</label>
          <input className="form-input" placeholder="例如：我的网站" value={name} onChange={e=>setName(e.target.value)} autoFocus/>
        </div>
        <div className="form-group">
          <label className="form-label">网址</label>
          <input className="form-input" placeholder="https://example.com" value={url} onChange={e=>{setUrl(e.target.value);autoFetchIcon(e.target.value)}} onBlur={()=>{if(!name&&url)setName(extractDomain(url))}}/>
        </div>
        {groups&&groups.length>0&&(
          <div className="form-group">
            <label className="form-label">所属分组</label>
            <select className="form-input" value={groupId} onChange={e=>setGroupId(e.target.value)}>
              <option value="">无（直接展示）</option>
              {groups.map(g=><option key={g.id} value={g.id}>{g.name}</option>)}
            </select>
          </div>
        )}
        {err&&<p style={{color:'#ef4444',fontSize:'13px',marginBottom:'10px'}}>{err}</p>}
        <div style={{display:'flex',gap:'10px',justifyContent:'flex-end'}}>
          <button type="button" className="btn btn-secondary" onClick={close}>取消</button>
          <button type="submit" className="btn btn-primary">{isEdit?'保存':'添加'}</button>
        </div>
      </form>}
    </Modal>
  );
}

// ============ GROUP MODAL (新建/编辑分组) ============
function GroupModal({initial,onClose,onSave}){
  const [name,setName]=useState(initial?.name||'');
  const [err,setErr]=useState('');
  const handleSubmit=e=>{
    e.preventDefault();
    if(!name.trim()){setErr('请输入组名');return}
    onSave({id:initial?.id||generateId(),name:name.trim()});
    onClose();
  };
  return(
    <Modal title={initial?'编辑分组':'新建分组'} onClose={onClose}>
      {close=><form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">组名</label>
          <input className="form-input" placeholder="例如：工作、学习" value={name} onChange={e=>setName(e.target.value)} autoFocus/>
        </div>
        {err&&<p style={{color:'#ef4444',fontSize:'13px',marginBottom:'10px'}}>{err}</p>}
        <div style={{display:'flex',gap:'10px',justifyContent:'flex-end'}}>
          <button type="button" className="btn btn-secondary" onClick={close}>取消</button>
          <button type="submit" className="btn btn-primary">{initial?'保存':'创建'}</button>
        </div>
      </form>}
    </Modal>
  );
}

// ============ FOLDER ICON (React Bits 风格 3D 文件夹) ============
function FolderIcon({items=[],open=false,size=0.52,onClick}){
  const count=Math.min(items.length,3);
  return (
    <div className={`rb-folder-wrap${open?' open':''}`} style={{transform:`scale(${size})`}} onClick={onClick}>
      <div className={`rb-folder${open?' open':''}`}>
        <div className="rb-folder__back">
          {[0,1,2].slice(0,count).map(i=>(
            <div key={i} className={`rb-paper rb-paper-${i+1}`}>
              {items[i]?<img className="rb-paper-icon" src={items[i]} alt="" onError={e=>{e.target.style.display='none'}}/>:null}
            </div>
          ))}
          <div className="rb-folder__front"/>
          <div className="rb-folder__front right"/>
        </div>
      </div>
    </div>
  );
}

// ============ 日报天气：分层 SVG 场景与轻量 CSS 动画 ============
function getWeatherMood(weather={}) {
  const text=weather.text||weather.textDay||'';
  const code=Number(weather.icon||weather.iconDay);
  let type='cloud';
  if(/雷/.test(text))type='storm';
  else if(/雨夹雪|雨雪|冻雨/.test(text))type='sleet';
  else if(/雪/.test(text))type='snow';
  else if(/雨/.test(text))type='rain';
  else if(/雾|霾|沙|尘/.test(text))type='fog';
  else if(/阴/.test(text))type='cloud';
  else if(/云/.test(text))type='cloud-sun';
  else if(/晴/.test(text))type='sun';
  else if(/风/.test(text))type='wind';
  else if([100,150].includes(code))type='sun';
  else if([101,102,103,151,152,153].includes(code))type='cloud-sun';
  else if([302,303,304].includes(code))type='storm';
  else if([404,405,406,456].includes(code))type='sleet';
  else if(code>=300&&code<400)type='rain';
  else if(code>=400&&code<500)type='snow';
  else if(code>=500&&code<600)type='fog';
  const night=[150,151,152,153,350,351,456,457].includes(code);
  return {type,night};
}
function WeatherGlyph({weather}) {
  const {type,night}=getWeatherMood(weather);
  return <svg className={`np-weather-glyph glyph-${type}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {type==='sun'?(night?<path d="M19 14A7 7 0 0 1 10 5a7 7 0 1 0 9 9Z"/>:<><circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5"/></>):type==='fog'||type==='wind'?<><path d="M4 8h13a2 2 0 1 0-2-2M2 12h18M5 16h12M8 20h8"/></>:<>
      {type==='cloud-sun'&&<><circle cx="16" cy="7" r="3"/><path d="M16 1v1m5 5h1M20 3l1-1"/></>}
      <path d="M6 16a4 4 0 1 1 1-7 5 5 0 0 1 9 2 3 3 0 1 1 1 5Z"/>
      {type==='rain'&&<path d="m8 19-1 2m6-2-1 2m6-2-1 2"/>}
      {type==='storm'&&<path d="m13 17-3 4h3l-2 3"/>}
      {(type==='snow'||type==='sleet')&&<path d="M8 19v4m-2-2h4m5-2v4m-2-2h4"/>}
    </>}
  </svg>;
}
let weatherSceneSequence=0;
function WeatherScene({weather}) {
  const {type,night}=getWeatherMood(weather);
  const idRef=useRef(null);
  if(idRef.current===null)idRef.current=`qomo-sky-${++weatherSceneSequence}`;
  const id=idRef.current;
  const wet=['rain','storm','sleet'].includes(type);
  const snowy=['snow','sleet'].includes(type);
  const cloudShape='M-43 16C-60 16-63-7-47-14C-44-37-15-43-1-25C15-36 37-21 35-6C60-7 66 24 42 26H-38C-50 26-55 18-43 16Z';
  return <div className={`np-sky-scene sky-${type}${night?' sky-night':''}`} aria-hidden="true">
    <svg viewBox="0 0 320 220" preserveAspectRatio="xMidYMid slice">
      <defs>
        <linearGradient id={`${id}-sky`} x2="0" y2="1"><stop stopColor="var(--wx-sky-top)"/><stop offset="1" stopColor="var(--wx-sky-bottom)"/></linearGradient>
        <linearGradient id={`${id}-cloud`} x2="0" y2="1"><stop stopColor="var(--wx-cloud-top)"/><stop offset="1" stopColor="var(--wx-cloud-bottom)"/></linearGradient>
        <radialGradient id={`${id}-glow`}><stop stopColor="#fff0b0" stopOpacity=".62"/><stop offset="1" stopColor="#fff0b0" stopOpacity="0"/></radialGradient>
        <radialGradient id={`${id}-sun`} cx="35%" cy="30%"><stop stopColor="#fff9d8"/><stop offset=".55" stopColor="#ffe18a"/><stop offset="1" stopColor="#ffbf50"/></radialGradient>
        <linearGradient id={`${id}-shade`} x1="0" y1="1" x2="1" y2="0"><stop stopColor="#102d50" stopOpacity=".48"/><stop offset=".55" stopColor="#102d50" stopOpacity=".12"/><stop offset="1" stopColor="#102d50" stopOpacity="0"/></linearGradient>
        <linearGradient id={`${id}-mist`}><stop stopColor="white" stopOpacity="0"/><stop offset=".5" stopColor="white" stopOpacity=".55"/><stop offset="1" stopColor="white" stopOpacity="0"/></linearGradient>
      </defs>
      <rect width="320" height="220" fill={`url(#${id}-sky)`}/>
      <ellipse className="sky-horizon" cx="110" cy="250" rx="280" ry="100" fill="white" opacity=".08"/>
      {night&&<g className="sky-stars" fill="#fff4d1">{Array.from({length:12},(_,i)=><circle key={i} className="sky-star" cx={22+(i*53)%280} cy={12+(i*31)%105} r={i%3===0?1.4:.8} style={{animationDelay:`-${i*.47}s`}}/>)}</g>}
      {(type==='sun'||type==='cloud-sun')&&<g className="sky-luminary">
        {night?<g className="sky-moon"><path d="M250 32a27 27 0 1 0 19 44 26 26 0 0 1-19-44Z" fill="#fff3ce"/><circle cx="234" cy="68" r="3" fill="#e5d9b3" opacity=".4"/></g>:<>
          <circle className="sky-sun-aura" cx="245" cy="66" r="70" fill={`url(#${id}-glow)`}/>
          <g className="sky-rays" stroke="#ffefb4" strokeWidth="2" strokeLinecap="round">{Array.from({length:12},(_,i)=><path key={i} d="M245 24v-7" transform={`rotate(${i*30} 245 66)`}/>)}</g>
          <circle className="sky-sun" cx="245" cy="66" r="27" fill={`url(#${id}-sun)`}/>
        </>}
      </g>}
      {type!=='sun'&&type!=='fog'&&<g fill={`url(#${id}-cloud)`}>
        <g transform="translate(215 77)"><g className="sky-cloud sky-cloud-main"><path d={cloudShape}/></g></g>
        <g transform="translate(307 45) scale(.65)"><g className="sky-cloud sky-cloud-far"><path d={cloudShape} opacity=".55"/></g></g>
        {type==='cloud'&&<g transform="translate(86 38) scale(.55)"><g className="sky-cloud sky-cloud-near"><path d={cloudShape} opacity=".55"/></g></g>}
      </g>}
      {wet&&<g className="sky-rain" stroke="var(--wx-particle)" strokeLinecap="round">{Array.from({length:type==='storm'?19:14},(_,i)=><path key={i} className="sky-raindrop" d={`M${155+(i*23)%153} ${-20+(i*29)%140}l-4 ${9+i%5}`} strokeWidth={i%3===0?1.5:1} style={{animationDuration:`${.8+(i%5)*.13}s`,animationDelay:`-${i*.19}s`}}/>)}</g>}
      {snowy&&<g fill="white" stroke="white">{Array.from({length:16},(_,i)=><g key={i} transform={`translate(${142+(i*29)%169} ${-30+(i*31)%160})`}><g className="sky-snowflake" style={{animationDuration:`${4+(i%5)*.7}s`,animationDelay:`-${i*.67}s`}}>{i%3===0?<path d="M-3 0h6M0-3v6m-2-2 4 4m0-4-4 4" strokeWidth="1" fill="none"/>:<circle r={1.2+(i%3)*.5} stroke="none"/>}</g></g>)}</g>}
      {type==='storm'&&<g className="sky-lightning"><path d="m238 91-16 28h13l-12 24 31-33h-15l11-19Z" fill="#fff1b8"/><ellipse cx="245" cy="120" rx="60" ry="85" fill={`url(#${id}-glow)`} opacity=".2"/></g>}
      {type==='fog'&&<g fill={`url(#${id}-mist)`}>{Array.from({length:5},(_,i)=><rect key={i} className="sky-mist" x={-60+i*15} y={28+i*30} width="370" height={12+i*2} rx="12" opacity={.3+i*.08} style={{animationDelay:`-${i*1.7}s`}}/>)}</g>}
      {type==='wind'&&<g fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" opacity=".65">{[0,1,2].map(i=><path key={i} className="sky-wind" d={`M${130+i*20} ${45+i*32}h90q20 0 20-12t-20-12`} style={{animationDelay:`-${i*1.2}s`}}/>)}</g>}
      <rect className="sky-text-shade" width="320" height="220" fill={`url(#${id}-shade)`}/>
    </svg>
  </div>;
}

// ============ 股票指数看板(迷你折线) ============
function MiniLine({data,up}) {
  const w=118,h=36;
  if(!data||data.length<2)return <span className="np-index-na">暂无走势</span>;
  const min=Math.min(...data),max=Math.max(...data);
  const range=(max-min)||1;
  const step=w/(data.length-1);
  const pts=data.map((v,i)=>`${(i*step).toFixed(1)},${(h-3-((v-min)/range)*(h-9)).toFixed(1)}`);
  const color=up?'#c0392b':'#0d8a4f';
  const lastY=pts.length?pts[pts.length-1].split(',')[1]:0;
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none">
      <polygon points={pts.join(' ')+` ${w},${h} 0,${h}`} fill={color} opacity=".08"/>
      <polyline points={pts.join(' ')} fill="none" stroke={color} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round"/>
      <circle cx={w} cy={lastY} r="2.4" fill={color}/>
    </svg>
  );
}
function IndicesBoard() {
  const [indices,setIndices]=useState([]);
  const [loading,setLoading]=useState(true);
  const stocks=useMemo(()=>{try{return JSON.parse(localStorage.getItem('qomo_stocks')||'[]')}catch(e){return []}},[loading]);
  useEffect(()=>{
    const s=(stocks||[]).join(',');
    fetch(API_BASE+'/indices'+(s?'?stocks='+s:''),{cache:'no-store'}).then(r=>r.json()).then(d=>{if(d&&d.indices)setIndices(d.indices)}).catch(()=>{}).finally(()=>setLoading(false));
  },[stocks]);
  if(loading)return <p className="np-loading">指数行情加载中…</p>;
  if(!indices.length)return <p className="np-loading">指数行情暂不可用</p>;
  return (
    <div className="np-indices">
      {indices.map(it=>{
        const up=it.changePct>=0;
        return (
          <div key={it.code} className={`np-index${up?' up':' down'}`}>
            <div className="np-index-head">
              <span className="np-index-name">{it.name}</span>
              <span className="np-index-pct">{up?'+':''}{it.changePct.toFixed(2)}%</span>
            </div>
            <div className="np-index-row">
              <span className="np-index-price">{it.price.toFixed(2)}</span>
              <MiniLine data={(it.trend||[]).map(t=>t.close)} up={up}/>
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ============ 体育赛事比分看板(订阅制) ============
function LeagueBoard({league}) {
  const [games,setGames]=useState([]);
  const [loading,setLoading]=useState(true);
  const [error,setError]=useState('');
  useEffect(()=>{
    let alive=true;
    setLoading(true);setError('');
    fetch(API_BASE+'/scores?league='+league,{cache:'no-store'}).then(r=>r.json()).then(d=>{
      if(!alive)return;
      if(d&&d.games)setGames(d.games);
      else if(d&&d.error)setError(d.error);
    }).catch(()=>{if(alive)setError('网络错误')}).finally(()=>{if(alive)setLoading(false)});
    return ()=>{alive=false};
  },[league]);
  const label=LEAGUE_LIST.find(l=>l.key===league)||{name:league};
  if(loading)return <div className="np-league"><div className="np-league-head">{label.name}</div><p className="np-loading">比分加载中…</p></div>;
  if(error||!games.length)return null;
  return (
    <div className="np-league">
      <div className="np-league-head">{label.name}</div>
      <div className="np-nba">
        {games.map((g,i)=>{
          const away=g.competitors.find(c=>!c.home)||{};
          const home=g.competitors.find(c=>c.home)||{};
          const st=g.state==='post'?'完场':(g.state==='live'?'LIVE':g.detail);
          return (
            <div key={i} className={`np-game${g.state==='live'?' live':''}`}>
              <div className="np-game-status">{st}</div>
              <div className="np-game-row">
                <div className="np-game-team">
                  {away.logo?<img src={away.logo} alt="" loading="lazy"/>:<span className="np-game-logo-fb">{(away.abbr||'?').slice(0,2)}</span>}
                  <span className="np-game-abbr">{away.abbr}</span>
                </div>
                <div className="np-game-score"><span>{away.score}</span><b>:</b><span>{home.score}</span></div>
                <div className="np-game-team home">
                  <span className="np-game-abbr">{home.abbr}</span>
                  {home.logo?<img src={home.logo} alt="" loading="lazy"/>:<span className="np-game-logo-fb">{(home.abbr||'?').slice(0,2)}</span>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
function SportsBoard() {
  const [leagues,setLeagues]=useState(readSubList('qomo_leagues',[]));
  useEffect(()=>{
    const sync=()=>{try{setLeagues(JSON.parse(localStorage.getItem('qomo_leagues')||'[]'))}catch(e){setLeagues([])}};
    window.addEventListener('qomo_leagues_change',sync);
    return ()=>window.removeEventListener('qomo_leagues_change',sync);
  },[]);
  if(!leagues.length)return <p className="np-subscribe-tip-sm">未订阅任何赛事 · 设置 → 报纸 手动启用比分订阅(本平台仅作为 RSS 阅读器提供服务)</p>;
  return <div className="np-sports">{leagues.map(l=><LeagueBoard key={l} league={l}/>)}</div>;
}

const readSubList=(key,def)=>()=>{try{const v=localStorage.getItem(key);if(v!==null)return JSON.parse(v);}catch(e){}return def;};
// ============ Qomo 日报：Apple 风格阅读面板 ============
function PaperIcon({name}) {
  const paths={
    news:<><rect x="4" y="3" width="16" height="18" rx="3"/><path d="M8 7h8M8 11h8M8 15h3M8 18h8"/></>,
    tech:<><rect x="6" y="6" width="12" height="12" rx="3"/><path d="M9 2v4m6-4v4M9 18v4m6-4v4M2 9h4m-4 6h4m12-6h4m-4 6h4"/></>,
    ai:<><path d="m12 3 2.4 6.6L21 12l-6.6 2.4L12 21l-2.4-6.6L3 12l6.6-2.4Z"/><path d="m20 2 .6 1.4L22 4l-1.4.6L20 6l-.6-1.4L18 4l1.4-.6Z"/></>,
    todo:<><rect x="4" y="3" width="16" height="18" rx="4"/><path d="m8 8 1 1 2-2m2 1h3M8 13h8M8 17h5"/></>,
    weather:<><circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5"/></>,
    market:<><path d="M4 4v16h16M8 14l4-5 4 3 4-6"/></>,
    sports:<><path d="M8 3h8v7a4 4 0 0 1-8 0Zm0 2H4v3a4 4 0 0 0 4 4m8-7h4v3a4 4 0 0 1-4 4m-4 2v5m-4 2h8"/></>,
    moon:<path d="M20.5 13.5A9 9 0 0 1 10.5 3.5a9 9 0 1 0 10 10Z"/>,
    close:<path d="m7 7 10 10M17 7 7 17"/>,
    back:<path d="m14 6-6 6 6 6"/>,
    settings:<><path d="M4 7h16M4 17h16"/><circle cx="9" cy="7" r="3"/><circle cx="15" cy="17" r="3"/></>
  };
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name]||paths.news}</svg>;
}
let newsModuleCache=null; // 模块级新闻缓存:打开画报秒开,后台静默更新
function NewspaperModal({onClose,onGoSettings}) {
  const [closing,setClosing]=useState(false);
  const [view,setView]=useState('home');
  const viewRef=useRef(null);
  const panelRef=useRef(null);
  const [appearance,setAppearance]=useState(()=>localStorage.getItem('qomo_newspaper_appearance')==='dark'?'dark':'light');
  useEffect(()=>{localStorage.setItem('qomo_newspaper_appearance',appearance)},[appearance]);
  useEffect(()=>{
    const scroll=viewRef.current&&viewRef.current.closest('.np-flip-scroll');
    if(scroll)scroll.scrollTop=0;
  },[view]);
  const backHome=()=>{setArticle(null);setArticleError('');setView('home');};
  const closeNewspaper=()=>{
    if(closing)return;
    setClosing(true);
    setTimeout(onClose,380);
  };
  const [news,setNews]=useState([]);
  const [aiNews,setAiNews]=useState([]);
  const [newsLoading,setNewsLoading]=useState(true);
  const [newsError,setNewsError]=useState('');
  const [todos,setTodos]=useState(()=>{try{return JSON.parse(localStorage.getItem('qomo_todo')||'[]')}catch(e){return []}});
  const [todoInput,setTodoInput]=useState('');
  const [weather,setWeather]=useState(null);
  const [zhMap,setZhMap]=useState({});
  const [article,setArticle]=useState(null);
  const [articleLoading,setArticleLoading]=useState(false);
  const [articleError,setArticleError]=useState('');
  const [previewImg,setPreviewImg]=useState(null);
  const [zoom,setZoom]=useState(1);
  const [pan,setPan]=useState({x:0,y:0});
  const dragRef=useRef(null);
  const pinchRef=useRef(null);
  const imgRef=useRef(null);
  const [dragging,setDragging]=useState(false);
  const resetZoom=()=>{setZoom(1);setPan({x:0,y:0})};
  // pan 边界:图片缩放后边缘不能拖出可视区域(像相册);zoom<=1 时居中回正
  const clampPan=(z,p)=>{
    if(z<=1)return {x:0,y:0};
    const img=imgRef.current;
    if(!img)return p;
    const dispW=img.offsetWidth*z, dispH=img.offsetHeight*z;
    const vw=window.innerWidth, vh=window.innerHeight;
    const maxX=Math.max(0,(dispW-vw)/2);
    const maxY=Math.max(0,(dispH-vh)/2);
    return {x:Math.max(-maxX,Math.min(maxX,p.x)), y:Math.max(-maxY,Math.min(maxY,p.y))};
  };
  // 统一缩放:缩到 1 自动回正居中,放大后 clamp 边界
  const applyZoom=delta=>{
    setZoom(z=>{
      const nz=Math.min(4,Math.max(1,z+delta));
      setPan(p=>clampPan(nz,p));
      return nz;
    });
  };
  // 触摸:单指拖拽(缩放>1) / 双指捏合缩放
  const handleTouchStart=e=>{
    if(e.touches.length===2){
      pinchRef.current=Math.hypot(e.touches[0].clientX-e.touches[1].clientX,e.touches[0].clientY-e.touches[1].clientY);
      dragRef.current=null;
    }else if(e.touches.length===1&&zoom>1){
      dragRef.current={sx:e.touches[0].clientX,sy:e.touches[0].clientY,px:pan.x,py:pan.y};
      setDragging(true);
    }
  };
  const handleTouchMove=e=>{
    if(e.touches.length===2&&pinchRef.current){
      const d=Math.hypot(e.touches[0].clientX-e.touches[1].clientX,e.touches[0].clientY-e.touches[1].clientY);
      const ratio=d/pinchRef.current;
      pinchRef.current=d;
      setZoom(z=>{
        const nz=Math.min(4,Math.max(1,z*ratio));
        setPan(p=>clampPan(nz,p));
        return nz;
      });
    }else if(e.touches.length===1&&dragRef.current){
      setPan(clampPan(zoom,{x:dragRef.current.px+e.touches[0].clientX-dragRef.current.sx,y:dragRef.current.py+e.touches[0].clientY-dragRef.current.sy}));
    }
  };
  const handleTouchEnd=()=>{dragRef.current=null;pinchRef.current=null;setDragging(false)};
  // 鼠标拖拽(缩放>1)
  const handleMouseDown=e=>{
    if(zoom>1){e.preventDefault();dragRef.current={sx:e.clientX,sy:e.clientY,px:pan.x,py:pan.y};setDragging(true);}
  };
  const handleMouseMove=e=>{
    if(dragRef.current){setPan(clampPan(zoom,{x:dragRef.current.px+e.clientX-dragRef.current.sx,y:dragRef.current.py+e.clientY-dragRef.current.sy}));}
  };
  const handleMouseUp=()=>{dragRef.current=null;setDragging(false)};
  const handleDoubleClick=()=>{
    setZoom(z=>{
      const nz=z>1?1:2;
      setPan(p=>clampPan(nz,p));
      return nz;
    });
  };
  const [translating,setTranslating]=useState(null);
  const [translatingAll,setTranslatingAll]=useState(false);
  // 菜园百科:点击标题翻转显示
  const [showWiki,setShowWiki]=useState(()=>{
    const pref=localStorage.getItem('qomo_newspaper_default');
    return pref==='wiki';
  });
  useEffect(()=>{
    const previous=document.activeElement;
    const panel=panelRef.current;
    if(panel)panel.focus();
    return ()=>{if(previous&&previous.isConnected)previous.focus()};
  },[]);
  const handlePanelKey=e=>{
    if(e.key==='Escape'){
      e.stopPropagation();
      if(previewImg){setPreviewImg(null);resetZoom()}
      else if(view==='article'&&!showWiki)backHome();
      else closeNewspaper();
    }
    if(e.key==='Tab'){
      const scope=previewImg?document.querySelector('.np-img-preview'):panelRef.current;
      if(!scope)return;
      const nodes=Array.from(scope.querySelectorAll('button,a[href],input,[tabindex="0"]')).filter(el=>!el.disabled&&!el.closest('[inert]')&&el.getClientRects().length);
      const first=nodes[0],last=nodes[nodes.length-1];
      if(e.shiftKey&&(document.activeElement===first||document.activeElement===panelRef.current||!scope.contains(document.activeElement))){e.preventDefault();if(last)last.focus()}
      else if(!e.shiftKey&&(document.activeElement===last||document.activeElement===panelRef.current||!scope.contains(document.activeElement))){e.preventDefault();if(first)first.focus()}
    }
  };
  useEffect(()=>{
    document.addEventListener('keydown',handlePanelKey);
    return ()=>document.removeEventListener('keydown',handlePanelKey);
  },[view,showWiki,previewImg,closing]);
  const [wiki,setWiki]=useState(null);
  const [wikiLoading,setWikiLoading]=useState(false);
  const [wikiSel,setWikiSel]=useState(0);
  const [wikiError,setWikiError]=useState(false);
  const wikiFetchedRef=useRef(false);

  const loadWiki=()=>{
    setWikiLoading(true);setWikiError(false);
    let pollCount=0;
    const MAX_POLL=40; // 最多轮询 40 次(约 3.5 分钟),覆盖首次全量抓取(约 2 分钟)
    const doFetch=()=>{
      const ctrl=new AbortController();
      const timer=setTimeout(()=>ctrl.abort(),10000); // 单次 10s 超时
      fetch(API_BASE+'/wiki',{cache:'no-store',signal:ctrl.signal}).then(r=>r.json()).then(d=>{
        if(d&&d.accounts){
          setWiki(d.accounts);
          const first=d.accounts.findIndex(a=>a.articles&&a.articles.length>0);
          if(first>=0)setWikiSel(first);
          setWikiLoading(false);
        }else if(d&&d.loading){
          // 后台仍在抓取,5s 后轮询(骨架屏保持显示)
          pollCount++;
          if(pollCount<MAX_POLL) setTimeout(doFetch,5000);
          else { setWikiError(true); setWikiLoading(false); }
        }else{
          setWikiError(true);
          setWikiLoading(false);
        }
      }).catch(()=>{setWikiError(true);setWikiLoading(false)}).finally(()=>clearTimeout(timer));
    };
    doFetch();
  };

  useEffect(()=>{
    if(wikiFetchedRef.current)return;
    wikiFetchedRef.current=true;
    loadWiki();
  },[]);

  // 信源开关(localStorage)
  const [enabledNews,setEnabledNews]=useState(readSubList('qomo_news_sources',[]));
  const [enabledAi,setEnabledAi]=useState(readSubList('qomo_ai_sources',[]));

  useEffect(()=>{
    // 秒开:有模块级缓存立即显示上次内容,后台静默更新
    if(newsModuleCache){
      setNews(newsModuleCache.news||[]);
      setAiNews(newsModuleCache.aiNews||[]);
      setNewsLoading(false);
    }
    fetch(API_BASE+'/news',{cache:'no-store'}).then(r=>r.json()).then(d=>{
      if(d&&d.news){
        newsModuleCache={news:d.news,aiNews:d.aiNews||[]};
        setNews(d.news);
        setAiNews(d.aiNews||[]);
      }
      if(d&&d.error&&!d.news)setNewsError(d.error);
    }).catch(()=>setNewsError('网络错误')).finally(()=>setNewsLoading(false));
  },[]);
  useEffect(()=>{localStorage.setItem('qomo_todo',JSON.stringify(todos))},[todos]);
  useEffect(()=>{
    try{
      const saved=localStorage.getItem('qomo_weather_loc');
      if(saved){
        const {lat,lon}=JSON.parse(saved);
        fetch(`${API_BASE}/weather?location=${lon},${lat}`).then(r=>r.json()).then(d=>{if(d&&d.code==='200'&&d.now)setWeather({...d.now,forecast:d.forecast||[]})}).catch(()=>{});
      }
    }catch(e){}
  },[]);

  const addTodo=()=>{
    const t=todoInput.trim();
    if(!t)return;
    setTodos(prev=>[{id:Date.now(),text:t,done:false,priority:1},...prev]);
    setTodoInput('');
  };
  const toggleTodo=id=>setTodos(prev=>prev.map(t=>t.id===id?{...t,done:!t.done}:t));
  const delTodo=id=>setTodos(prev=>prev.filter(t=>t.id!==id));
  const cyclePriority=id=>setTodos(prev=>prev.map(t=>{
    if(t.id!==id)return t;
    return {...t,priority:t.priority===3?1:t.priority+1};
  }));
  const clearDone=()=>setTodos(prev=>prev.filter(t=>!t.done));
  const translateTitle=async(it)=>{
    if(zhMap[it.link]){setZhMap(m=>{const n={...m};delete n[it.link];return n});return;}
    setTranslating(it.link);
    try{
      const res=await fetch(API_BASE+'/translate',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({texts:[it.title],targetLang:'zh'})});
      const data=await res.json();
      if(data&&data.translations&&data.translations[0])setZhMap(m=>({...m,[it.link]:data.translations[0]}));
    }catch(e){}
    finally{setTranslating(null)}
  };
  // 原生捕获监听:无论 React 事件系统状态如何,点击新闻链接一律阻止跳转并打开阅读器
  useEffect(()=>{
    const handler=e=>{
      const t=e.target;
      const a=t&&t.closest?t.closest('a.np-news-item,a.np-headline,a.np-ai-title-link'):null;
      if(!a)return;
      e.preventDefault();
      e.stopPropagation();
      const metaEl=a.querySelector('.np-news-meta');
      const src=metaEl?(metaEl.textContent||'').split('·')[0].trim():'';
      const titleEl=a.querySelector('.np-headline-title,.np-news-title');
      const title=((titleEl?titleEl.textContent:a.textContent)||'').replace(/\s+/g,' ').trim().slice(0,120)||a.getAttribute('href');
      openArticle({link:a.href,title,source:a.dataset.source||src});
    };
    document.addEventListener('click',handler,true);
    return ()=>document.removeEventListener('click',handler,true);
  },[]);
  const openArticle=(it,e)=>{
    if(e&&e.preventDefault)e.preventDefault();
    setArticle({link:it.link,title:it.title,source:it.source||''});
    setView('article');
    setArticleLoading(true);
    setArticleError('');
    fetch(API_BASE+'/article?url='+encodeURIComponent(it.link),{cache:'no-store'}).then(r=>r.json()).then(d=>{
      if(d&&d.body)setArticle(a=>({...a,title:(d.title||a.title).replace(/\s*[-|]\s*[^-|]*$/, ''),body:d.body}));
      else setArticleError(d.error||'未能加载正文');
    }).catch(()=>setArticleError('网络错误')).finally(()=>setArticleLoading(false));
  };
  const filteredNews=news.filter(it=>enabledNews.includes(it.source));
  const filteredAi=aiNews.filter(it=>enabledAi.includes(it.source));
  const translateAll=async()=>{
    const items=filteredAi.slice(0,6);
    if(!items.length)return;
    if(items.every(it=>zhMap[it.link])){setZhMap({});return;}
    setTranslatingAll(true);
    try{
      const res=await fetch(API_BASE+'/translate',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({texts:items.map(it=>it.title),targetLang:'zh'})});
      const data=await res.json();
      if(data&&data.translations){
        const m={};
        items.forEach((it,i)=>{if(data.translations[i])m[it.link]=data.translations[i]});
        setZhMap(m);
      }
    }catch(e){}
    finally{setTranslatingAll(false)}
  };
  const todoDoneCount=todos.filter(t=>t.done).length;
  const todoPercent=todos.length?Math.round(todoDoneCount/todos.length*100):0;
  const PRIORITY_LABEL={1:'普通',2:'重要',3:'紧急'};
  const PRIORITY_TIP={1:'普通 · 点击提升优先级',2:'重要 · 点击提升优先级',3:'紧急 · 点击回到普通'};

  const now=new Date();
  const dateStr=now.toLocaleDateString('zh-CN',{year:'numeric',month:'long',day:'numeric',weekday:'long'});
  const issueNo=Math.max(1,Math.floor((now.getTime()-new Date(2026,7,8).getTime())/86400000)+1);
  const weatherAdvice=w=>{
    if(!w)return '';
    const t=(w.text||'')+'';const temp=parseInt(w.temp)||25;
    if(t.includes('雷'))return '雷雨天气,尽量减少外出,注意防雷';
    if(t.includes('雨'))return '今日有雨,出门记得带伞';
    if(t.includes('雪'))return '路面湿滑,注意防滑保暖';
    if(t.includes('雾')||t.includes('霾'))return '能见度较低,注意出行安全,减少户外停留';
    if(temp>=30)return '天气炎热,注意防暑降温,多补充水分';
    if(temp<=0)return '天气寒冷,注意添衣保暖';
    return '天气适宜,适合外出活动';
  };
  const fmtTime=ts=>{
    if(!ts)return '';
    const d=new Date(ts);
    const diff=Date.now()-ts;
    if(diff<3600000)return Math.max(1,Math.round(diff/60000))+'分钟前';
    if(diff<86400000)return Math.round(diff/3600000)+'小时前';
    return (d.getMonth()+1)+'月'+d.getDate()+'日';
  };

  const compNews=filteredNews.filter(it=>['中国新闻网','中新网要闻'].includes(it.source));
  const techNews=filteredNews.filter(it=>['极客公园','爱范儿','奇客Solidot'].includes(it.source));
  const headline=compNews[0]||techNews[0]||filteredNews[0];
  const rest=compNews.filter(it=>it!==headline).slice(0,9);
  const fmtDesc=d=>d&&d.length>64?d.slice(0,64)+'…':d;
  const fmtDay=dstr=>{
    const d=new Date(dstr+'T00:00:00');
    const today=new Date();
    today.setHours(0,0,0,0);
    const diff=Math.round((d-today)/86400000);
    if(diff===0)return '今天';
    if(diff===1)return '明天';
    if(diff===2)return '后天';
    return '周'+'日一二三四五六'[d.getDay()];
  };
  const fmtWikiTime=ts=>{
    if(!ts)return '';
    const d=new Date(ts);
    const now=new Date();
    const diff=now-d;
    if(diff>=0&&diff<86400000)return '今天';
    if(diff>=0&&diff<172800000)return '昨天';
    return (d.getMonth()+1)+'月'+d.getDate()+'日';
  };

  return (
    <div className={`newspaper-overlay${closing?' closing':''}`} onClick={e=>{if(e.target===e.currentTarget)closeNewspaper()}}>
      <div className={`newspaper${closing?' closing':''}`} data-appearance={appearance} ref={panelRef} role="dialog" aria-modal="true" aria-label="Qomo 日报" tabIndex={-1}>
        <div className="np-topbar">
          <div className="np-brand"><span className="np-brand-mark"><PaperIcon name="news"/></span><span>Qomo<span className="np-brand-caption">每日，从容一点。</span></span></div>
          <div className="np-tabs" role="group" aria-label="阅读板块">
            <button className={!showWiki?'active':''} aria-pressed={!showWiki} onClick={()=>setShowWiki(false)}>日报</button>
            <button className={showWiki?'active':''} aria-pressed={showWiki} onClick={()=>setShowWiki(true)}>百科</button>
          </div>
          <div className="np-topbar-actions">
            <button className="np-tool-btn" onClick={()=>setAppearance(v=>v==='light'?'dark':'light')} title={appearance==='light'?'切换深色外观':'切换浅色外观'} aria-label={appearance==='light'?'切换深色外观':'切换浅色外观'}><PaperIcon name={appearance==='light'?'moon':'weather'}/></button>
            <button className="np-tool-btn" onClick={onGoSettings} title="订阅设置" aria-label="订阅设置"><PaperIcon name="settings"/></button>
            <button className="np-tool-btn np-close" onClick={closeNewspaper} title="关闭日报" aria-label="关闭日报"><PaperIcon name="close"/></button>
          </div>
        </div>
        <div className={`np-flipper${showWiki?' flipped':''}`}>
        <div className="np-flip-face np-flip-front" aria-hidden={showWiki} {...(showWiki?{inert:""}:{})}>
        <div className="np-flip-scroll">
        <div className={`np-view${view==='article'?' np-view-hidden':''}`} key="home" ref={viewRef}>

        <header className="np-masthead">
          <div className="np-title-wrap">
            <p className="np-eyebrow">YOUR DAILY EDITION <span>第 {issueNo} 期</span></p>
            <h1 className="np-title">Qomo <span>日报</span><i/></h1>
            <p className="np-subtitle">看见世界，也照顾好今天。</p>
          </div>
          <div className="np-edition-meta">
            <span className="np-edition-date">{dateStr}</span>
            <span className="np-edition-lunar">{getLunar(now).label} · {getLunar(now).ganZhi}{getLunar(now).animal}年</span>
            {weather&&<span className="np-edition-weather"><WeatherGlyph weather={weather}/>{weather.text} · {weather.temp}°</span>}
          </div>
        </header>

        <div className="np-body">
          {/* 左栏：新闻 + AI */}
          <section className="np-main">
            <section className="np-feed-card np-feed-news">
            <div className="np-feed-heading"><h2 className="np-section-title"><span className="np-section-icon"><PaperIcon name="news"/></span>今日要闻</h2><span className="np-section-caption">值得关注的此刻</span></div>
            {newsLoading?(
              <div className="np-skeleton">
                {[...Array(7)].map((_,i)=><div key={i} className="np-skeleton-line" style={{width:(92-i*7)+'%',animationDelay:(i*0.12)+'s'}}/>)}
              </div>
            ):newsError&&news.length===0?(<p className="np-loading">{newsError}</p>):compNews.length===0?(
              <div className="np-subscribe-tip">
                <p className="np-subscribe-tip-title">尚未订阅任何新闻信源</p>
                <p className="np-subscribe-tip-desc">本平台不提供内容分发,仅作为 RSS 阅读器提供工具服务。请前往 设置 → 报纸 手动启用需要订阅的新闻信源。</p>
                <button className="np-subscribe-tip-btn" onClick={onGoSettings}>去设置订阅</button>
              </div>
            ):(
              <>
                {headline&&(
                  <a className={`np-headline${headline.img?' has-img':''}`} href={headline.link} data-source={headline.source} target="_blank" rel="noopener noreferrer" onClick={e=>openArticle(headline,e)}>
                    <div className="np-headline-main">
                      <span className="np-headline-src"><b>头条</b> {headline.source} · {fmtTime(headline.ts)}</span>
                      <span className="np-headline-title">{headline.title}</span>
                      {headline.desc&&<span className="np-headline-desc">{headline.desc}{headline.desc.length>=160?'…':''}</span>}
                    </div>
                    {headline.img&&<div className="np-headline-img"><img src={headline.img} alt="" loading="lazy" onError={e=>{e.target.closest('.np-headline-img').style.display='none'}}/></div>}
                  </a>
                )}
                <ul className="np-news-list">
                  {rest.map((it,i)=>(
                    <li key={i}>
                      <a href={it.link} data-source={it.source} target="_blank" rel="noopener noreferrer" className="np-news-item" onClick={e=>openArticle(it,e)}>
                        <span className="np-news-no">{String(i+1).padStart(2,'0')}</span>
                        <span className="np-news-content">
                          <span className="np-news-title">{it.title}</span>
                          {it.desc&&<span className="np-news-desc">{fmtDesc(it.desc)}</span>}
                        </span>
                        <span className="np-news-meta">{it.source} · {fmtTime(it.ts)}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </>
            )}

            </section>

            <section className="np-feed-card np-feed-tech">
            <div className="np-feed-heading"><h2 className="np-section-title np-section-title-tech"><span className="np-section-icon"><PaperIcon name="tech"/></span>科技动态</h2><span className="np-section-caption">灵感正在发生</span></div>
            {!newsLoading&&techNews.length===0&&(
              <div className="np-subscribe-tip">
                <p className="np-subscribe-tip-title">尚未订阅科技类信源</p>
                <p className="np-subscribe-tip-desc">启用 极客公园 / 爱范儿 / 奇客Solidot 等科技信源后,"科技动态"板块将在此展示。</p>
                <button className="np-subscribe-tip-btn" onClick={onGoSettings}>去设置订阅</button>
              </div>
            )}

            {techNews.length>0&&(
              <>
                <ul className="np-news-list">
                  {techNews.slice(0,6).map((it,i)=>(
                    <li key={i}>
                      <a href={it.link} data-source={it.source} target="_blank" rel="noopener noreferrer" className="np-news-item" onClick={e=>openArticle(it,e)}>
                        <span className="np-news-no np-news-no-tech">{String(i+1).padStart(2,'0')}</span>
                        <span className="np-news-content">
                          <span className="np-news-title">{it.title}</span>
                          {it.desc&&<span className="np-news-desc">{fmtDesc(it.desc)}</span>}
                        </span>
                        <span className="np-news-meta np-news-meta-tech">{it.source} · {fmtTime(it.ts)}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </>
            )}

            </section>

            <section className="np-feed-card np-feed-ai">
            <div className="np-section-row">
              <h2 className="np-section-title np-section-title-ai"><span className="np-section-icon"><PaperIcon name="ai"/></span>AI 前线</h2>
              <button className={`np-ai-trans-all${translatingAll?' loading':''}${filteredAi.length>0&&filteredAi.slice(0,6).every(it=>zhMap[it.link])?' done':''}`}
                onClick={translateAll} disabled={translatingAll||!filteredAi.length}>
                {translatingAll?'翻译中…':(filteredAi.length>0&&filteredAi.slice(0,6).every(it=>zhMap[it.link])?'显示原文':'翻译全部')}
              </button>
            </div>
            {filteredAi.length===0&&newsLoading?(
              <div className="np-skeleton">
                {[...Array(5)].map((_,i)=><div key={i} className="np-skeleton-line" style={{width:(88-i*7)+'%',animationDelay:(i*0.12)+'s'}}/>)}
              </div>
            ):filteredAi.length===0&&enabledAi.length===0?(
              <div className="np-subscribe-tip">
                <p className="np-subscribe-tip-title">尚未订阅 AI 信源</p>
                <p className="np-subscribe-tip-desc">启用 TechCrunch / Ars Technica / MIT Tech Review / AI News 等海外 AI 媒体后,"AI 前线"板块将在此展示。</p>
                <button className="np-subscribe-tip-btn" onClick={onGoSettings}>去设置订阅</button>
              </div>
            ):filteredAi.length===0?(<p className="np-loading">AI 前沿动态加载中…</p>):(
              <ul className="np-news-list np-ai-list">
                {filteredAi.slice(0,6).map((it,i)=>(
                  <li key={i}>
                    <div className="np-news-item np-ai-item">
                      <div className="np-ai-content">
                        <a href={it.link} data-source={it.source} target="_blank" rel="noopener noreferrer" className="np-ai-title-link" onClick={e=>openArticle(it,e)}>{it.title}</a>
                        {zhMap[it.link]&&<span className="np-ai-zh">{zhMap[it.link]}</span>}
                        <span className="np-news-meta">{it.source} · {fmtTime(it.ts)}</span>
                      </div>
                      <button className={`np-ai-trans${translating===it.link?' loading':''}${zhMap[it.link]?' done':''}`}
                        onClick={()=>translateTitle(it)} title={zhMap[it.link]?'显示原文':'翻译为中文'}>
                        {translating===it.link?'…':(zhMap[it.link]?'原文':'译')}
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            )}
            </section>
          </section>

          {/* 右栏：待办 / 天气 / 行情 / 赛事 */}
          <aside className="np-side">
            <section className="np-card">
              <div className="np-card-head">
                <h2 className="np-section-title"><span className="np-section-icon"><PaperIcon name="todo"/></span>今日待办</h2>
                <span className="np-todo-stat">{todoDoneCount}/{todos.length} 已完成</span>
              </div>
              <div className="np-todo-input-row">
                <input className="np-todo-input" aria-label="添加待办" placeholder="今天想完成什么？" value={todoInput}
                  onChange={e=>setTodoInput(e.target.value)} onKeyDown={e=>{if(e.key==='Enter')addTodo()}}/>
                <button className="np-todo-add" aria-label="添加待办" onClick={addTodo}>＋</button>
              </div>
              {todos.length>0&&(
                <div className="np-todo-progress"><span style={{width:todoPercent+'%'}}/></div>
              )}
              {todos.length===0?(<p className="np-todo-empty">暂无待办,添加一件今天要做的事吧</p>):(
                <ul className="np-todo-list">
                  {todos.map(t=>(
                    <li key={t.id} className={`np-todo-item${t.done?' done':''} prio-${t.priority}`}>
                      <button className="np-todo-prio" aria-label={PRIORITY_TIP[t.priority]} title={PRIORITY_TIP[t.priority]} onClick={()=>cyclePriority(t.id)}>
                        <i/>
                      </button>
                      <button className="np-todo-check" aria-label={t.done?'标为未完成：'+t.text:'完成：'+t.text} aria-pressed={t.done} onClick={()=>toggleTodo(t.id)}>{t.done?'✓':''}</button>
                      <span className="np-todo-text">{t.text}</span>
                      <span className="np-todo-prio-tag">{t.done?'':PRIORITY_LABEL[t.priority]}</span>
                      <button className="np-todo-del" aria-label={'删除：'+t.text} onClick={()=>delTodo(t.id)}>✕</button>
                    </li>
                  ))}
                </ul>
              )}
              {todoDoneCount>0&&(
                <button className="np-todo-clear" onClick={clearDone}>清除已完成 ({todoDoneCount})</button>
              )}
            </section>

            <section className={`np-card np-weather-card-wrap weather-card-${getWeatherMood(weather||{}).type}`}>
              <h2 className="np-section-title"><span className="np-section-icon"><WeatherGlyph weather={weather||{text:'晴'}}/></span>天气预报</h2>
              {weather?(
                <div className="np-weather-card">
                  <div className={`np-weather-hero hero-${getWeatherMood(weather).type}${getWeatherMood(weather).night?' hero-night':''}`}>
                  <WeatherScene weather={weather}/>
                  <div className="np-weather-now">
                    <div className="np-weather-big">
                      <span className="np-weather-temp">{weather.temp}°</span>
                      <span className="np-weather-text">{weather.text}</span>
                    </div>
                    <div className="np-weather-feel">体感 {weather.feelsLike}℃</div>
                  </div>
                  <span className="np-weather-hero-label">此刻天气</span>
                  </div>
                  <p className="np-weather-advice">{weatherAdvice(weather)}</p>
                  <ul className="np-weather-meta">
                    <li><span>湿度</span><strong>{weather.humidity}<small>%</small></strong></li>
                    <li><span>{weather.windDir||'风力'}</span><strong>{weather.windScale}<small>级</small></strong></li>
                    <li><span>气压</span><strong>{weather.pressure}<small> hPa</small></strong></li>
                    <li><span>能见度</span><strong>{weather.vis}<small> km</small></strong></li>
                  </ul>
                  {weather.forecast&&weather.forecast.length>0&&(
                    <>
                      <div className="np-forecast-label-row">未来三天</div>
                      <div className="np-forecast">
                        {weather.forecast.map((f,i)=>(
                          <div key={i} className={`np-forecast-day${i===0?' today':''}`}>
                            <span className="np-forecast-label">{fmtDay(f.fxDate)}</span>
                            <WeatherGlyph weather={f}/>
                            <span className="np-forecast-text">{f.textDay}</span>
                            <span className="np-forecast-temp">{f.tempMin}°~{f.tempMax}°</span>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              ):(<div className="np-weather-empty"><span className="np-weather-empty-icon"><PaperIcon name="weather"/></span><p>等待此刻的天气</p><span>获取位置与天气数据后，在这里查看预报</span></div>)}
            </section>

            <section className="np-card">
              <div className="np-card-head">
                <h2 className="np-section-title"><span className="np-section-icon"><PaperIcon name="market"/></span>股票指数</h2>
                <span className="np-todo-stat">行情延时</span>
              </div>
              <IndicesBoard/>
            </section>

            <section className="np-card">
              <div className="np-card-head">
                <h2 className="np-section-title"><span className="np-section-icon"><PaperIcon name="sports"/></span>体育赛事</h2>
                <span className="np-todo-stat">ESPN · 设置可订阅</span>
              </div>
              <SportsBoard/>
            </section>
          </aside>
        </div>


        <footer className="np-footer">
          <span>QOMO 日报 · 新闻来源:中国新闻网 / 中新网要闻 / 极客公园 / 爱范儿 / 奇客Solidot · AI 来源:TechCrunch / Ars Technica / MIT Tech Review / AI News</span>
          <span>本平台不提供内容分发,仅作为 RSS 阅读器提供工具服务 · 内容版权归原作者所有</span>
        </footer>
        </div>
        {view==='article'&&(
        <div className="np-view np-article-view" key="article">
          <div className="np-article-toolbar">
            <button className="np-reader-back" onClick={backHome}><PaperIcon name="back"/>返回日报</button>
            <a className="np-reader-origin" href={article&&article.link} target="_blank" rel="noopener noreferrer">打开原文 ↗</a>
          </div>
          {articleLoading?(<div className="np-skeleton">
            {[...Array(8)].map((_,i)=><div key={i} className="np-skeleton-line" style={{width:(96-i*8)+'%',animationDelay:(i*0.12)+'s'}}/>)}
          </div>):articleError?(<p className="np-loading">{articleError}</p>):article?(
            <article className="np-reader-body" onClick={e=>{
              if(e.target.tagName==='IMG'&&e.target.closest('.np-reader-content')){
                setPreviewImg(e.target.src);
              }
            }}>
              <div className="np-reader-kicker">{article.source||'原文阅读'}</div>
              <h1 className="np-reader-title">{article.title}</h1>
              <div className="np-reader-rule"/>
              <div className="np-reader-content" dangerouslySetInnerHTML={{__html:article.body}}/>
              <div className="np-reader-end">
                <span>— 全文完 · QOMO 日报 —</span>
              </div>
            </article>
          ):null}
        </div>
        )}
        </div>
        </div>
        <div className="np-flip-face np-flip-back" aria-hidden={!showWiki} {...(!showWiki?{inert:""}:{})}>
        <div className="np-flip-scroll">
        <div className="np-view np-wiki-view">
          <header className="np-masthead np-wiki-masthead">
            <div className="np-title-wrap">
              <p className="np-eyebrow">EXPLORE & DISCOVER</p><h1 className="np-title">Qomo <span>百科</span><i/></h1>
              <p className="np-subtitle">菜园百科 · 浙财公众号聚合</p>
            </div>
          </header>
          <div className="np-rule np-rule-top"/>
          {wikiLoading?(
            <div className="np-skeleton">
              {[...Array(10)].map((_,i)=><div key={i} className="np-skeleton-line" style={{width:(92-i*6)+'%',animationDelay:(i*0.1)+'s'}}/>)}
            </div>
          ):!wiki?(
            <div className="np-wiki-empty-state">
              <p className="np-wiki-empty-tip">{wikiError?'百科加载超时或暂无数据':'暂无数据'}</p>
              <button className="np-wiki-retry-btn" onClick={loadWiki}>重新加载</button>
            </div>
          ):(
            <div className="np-wiki-layout">
              <aside className="np-wiki-sidebar">
                {wiki.map((acc,i)=>(
                  <button key={i} className={`np-wiki-acc-btn${wikiSel===i?' active':''}`} onClick={()=>setWikiSel(i)}>
                    <span className="np-wiki-avatar">{acc.name.slice(0,1)}</span>
                    <span className="np-wiki-acc-name">{acc.name}</span>
                    <span className="np-wiki-count">{acc.articles.length}</span>
                  </button>
                ))}
              </aside>
              <div className="np-wiki-content">
                {wiki[wikiSel]&&(
                  <>
                    <div className="np-wiki-content-head">
                      <h2 className="np-wiki-content-title">{wiki[wikiSel].name}</h2>
                      <p className="np-wiki-content-desc">{wiki[wikiSel].desc}</p>
                    </div>
                    {wiki[wikiSel].articles.length===0?(
                      <p className="np-wiki-empty">暂无更新内容</p>
                    ):(
                      <ul className="np-wiki-articles">
                        {wiki[wikiSel].articles.map((a,j)=>(
                          <li key={j}>
                            <a href={a.link} target="_blank" rel="noopener noreferrer">
                              <span className="np-wiki-art-title">{a.title}</span>
                              <span className="np-wiki-art-time">{fmtWikiTime(a.ts)}</span>
                            </a>
                            {a.summary&&<p className="np-wiki-art-summary">{a.summary}</p>}
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                )}
              </div>
            </div>
          )}
        </div>
        </div>
        </div>
      </div>
      </div>
      {previewImg&&(
        <div className="np-img-preview" role="dialog" aria-modal="true" aria-label="图片预览" onClick={e=>{if(e.target===e.currentTarget){setPreviewImg(null);resetZoom()}}}>
          <img ref={imgRef} src={previewImg} alt="预览" draggable="false"
            onClick={e=>e.stopPropagation()}
            onWheel={e=>{e.stopPropagation();e.preventDefault();applyZoom(e.deltaY<0?0.2:-0.2)}}
            onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}
            onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp} onMouseLeave={handleMouseUp}
            onDoubleClick={handleDoubleClick}
            style={{transform:`translate(${pan.x}px,${pan.y}px) scale(${zoom})`,cursor:zoom>1?'grab':'zoom-in',transition:dragging?'none':'transform .2s cubic-bezier(.22,1,.36,1)'}}/>
          <div className="np-img-zoom-controls" onClick={e=>e.stopPropagation()}>
            <button onClick={()=>applyZoom(-0.25)} title="缩小">−</button>
            <span className="np-img-zoom-level">{Math.round(zoom*100)}%</span>
            <button onClick={()=>applyZoom(0.25)} title="放大">+</button>
          </div>
          <button className="np-img-preview-close" onClick={()=>{setPreviewImg(null);resetZoom()}} title="关闭">✕</button>
        </div>
      )}
    </div>
  );
}

// ============ 微信公众号扫码登录(菜园百科数据源) ============
function WechatLogin(){
  const [state,setState]=useState('loading'); // loading | noconfig | logged | login(显示二维码)
  const [nickname,setNickname]=useState('');
  const [expire,setExpire]=useState('');
  const [scanMsg,setScanMsg]=useState('正在加载二维码…');
  const [qrcodeKey,setQrcodeKey]=useState(Date.now());
  const [qrReady,setQrReady]=useState(false);
  const timerRef=useRef(null);

  const checkStatus=async()=>{
    try{
      const r=await fetch(API_BASE+'/wechat/status');
      const d=await r.json();
      if(d&&d.error){setState('noconfig');return;}
      // 宽松解析登录态(兼容不同字段结构)
      const body=d&&d.data?d.data:d;
      // 凭证已过期 → 自动重新登录
      if(body&&body.isExpired){setState('login');startLogin();return;}
      const logged=body&&(body.loggedIn!==false&&(body.nickname||body.expireTime||body.isLoggedIn||body.token));
      if(logged){
        setNickname(body.nickname||'已登录');
        if(body.expireTime)setExpire(formatExpire(body.expireTime));
        setState('logged');
      }else{
        setState('login');
        startLogin(); // 自动建立会话 + 显示二维码 + 轮询,无需手动刷新
      }
    }catch(e){setState('noconfig');}
  };

  // expireTime 是毫秒时间戳(微信后台),兼容秒(10位)与毫秒(13位)
  const formatExpire=ts=>{
    const n=Number(ts);
    if(!n)return '';
    const ms=n>1e12?n:n*1000;
    return new Date(ms).toLocaleString();
  };

  const pollScan=async()=>{
    try{
      const r=await fetch(API_BASE+'/wechat/scan');
      const d=await r.json();
      if(d&&d.base_resp&&d.base_resp.ret!==0){setScanMsg('检查状态失败');timerRef.current=setTimeout(pollScan,3000);return;}
      const st=(d&&d.status)||0;
      if(st===1){setScanMsg('扫码成功,正在登录…');await bizlogin();}
      else if(st===4||st===6){setScanMsg('请在手机上确认登录');timerRef.current=setTimeout(pollScan,1500);}
      else if(st===2){setScanMsg('二维码已过期,正在自动刷新…');startLogin();}
      else if(st===3){setScanMsg('扫码失败,请重试');}
      else{timerRef.current=setTimeout(pollScan,3000);}
    }catch(e){timerRef.current=setTimeout(pollScan,3000);}
  };

  const bizlogin=async()=>{
    try{
      const r=await fetch(API_BASE+'/wechat/bizlogin',{method:'POST'});
      const d=await r.json();
      if(d&&d.success){setNickname((d.data&&d.data.nickname)||'已登录');setState('logged');setScanMsg('登录成功');}
      else{setScanMsg('登录失败:'+((d&&d.error)||'未知错误'));}
    }catch(e){setScanMsg('登录失败:'+e.message);}
  };

  const startLogin=async()=>{
    setState('login');
    setQrReady(false);
    setScanMsg('正在加载二维码…');
    try{
      const sid=Date.now()+''+Math.floor(Math.random()*1000);
      await fetch(API_BASE+'/wechat/session/'+sid,{method:'POST'}); // 建立会话(cookie)
      setQrcodeKey(Date.now());
      setQrReady(true); // 会话建立后再加载二维码
      if(timerRef.current)clearTimeout(timerRef.current);
      timerRef.current=setTimeout(pollScan,2000);
    }catch(e){setScanMsg('初始化失败:'+e.message);}
  };

  useEffect(()=>{checkStatus();return()=>{if(timerRef.current)clearTimeout(timerRef.current)}},[]);

  if(state==='loading')return <p className="np-wiki-empty">检测数据源…</p>;
  if(state==='noconfig')return (
    <div className="wechat-login-noconfig">
      <p className="np-wiki-empty">微信数据源未部署,当前使用搜狗微信备用源</p>
      <p className="wechat-login-tip">部署 wechat-download-api 并配置 WECHAT_API_BASE 后,可在此扫码登录获取更稳定的文章(详见 WEIXIN_API_DEPLOY.md)</p>
    </div>
  );
  if(state==='logged')return (
    <div className="wechat-login-done">
      <span className="wechat-login-ok">✓ 已登录</span>
      <span className="wechat-login-nick">{nickname}</span>
      {expire&&<span className="wechat-login-expire">到期:{expire}</span>}
      <button className="btn-sm" onClick={()=>{setState('login');startLogin()}}>重新登录</button>
    </div>
  );
  return (
    <div className="wechat-login">
      {qrReady
        ?<img className="wechat-qrcode" key={qrcodeKey} src={API_BASE+'/wechat/qrcode?rnd='+qrcodeKey} alt="扫码登录"/>
        :<div className="wechat-qrcode wechat-qrcode-loading"><span className="loading-spinner" style={{width:'28px',height:'28px'}}/></div>}
      <p className="wechat-login-msg">{scanMsg}</p>
      <p className="wechat-login-tip">用公众号管理员微信扫码登录,凭证约 4 天有效</p>
      <button className="btn-sm" onClick={startLogin}>刷新二维码</button>
    </div>
  );
}

// ============ WALLPAPER COLOR STUDIO ============
const WP_GRADIENTS=[
  {name:'暖沙',c1:'#d4c4a8',c2:'#c4a882',angle:135},
  {name:'暮霭',c1:'#4a5568',c2:'#2d3748',angle:160},
  {name:'晨雾',c1:'#e0eafc',c2:'#cfdef3',angle:135},
  {name:'蜜橙',c1:'#f6d365',c2:'#fda085',angle:135},
  {name:'青柠',c1:'#84fab0',c2:'#8fd3f4',angle:135},
  {name:'葡萄',c1:'#a18cd1',c2:'#fbc2eb',angle:135},
  {name:'海洋',c1:'#2bc0e4',c2:'#4568dc',angle:135},
  {name:'玫瑰',c1:'#f5576c',c2:'#ff9a9e',angle:135}
];
const WP_SOLIDS=[
  {name:'雾蓝',color:'#a9bfd7'},{name:'奶油',color:'#eee2cc'},
  {name:'鼠尾草',color:'#b2c4b3'},{name:'烟粉',color:'#d8b8bf'},
  {name:'深海',color:'#26364d'},{name:'石墨',color:'#34383f'},
  {name:'浅灰',color:'#dadde2'},{name:'暖沙',color:'#cdbda6'}
];
const wpClamp=(v,min,max)=>Math.min(max,Math.max(min,v));
function wpHex(value){
  const raw=String(value||'').trim().replace(/^#/,'');
  if(/^[a-f\d]{6}$/i.test(raw))return '#'+raw.toLowerCase();
  if(/^[a-f\d]{3}$/i.test(raw))return '#'+raw.split('').map(c=>c+c).join('').toLowerCase();
  return null;
}
function wpHSV(hex){
  const rgb=[1,3,5].map(i=>parseInt(hex.slice(i,i+2),16)/255);
  const [r,g,b]=rgb,max=Math.max(...rgb),min=Math.min(...rgb),d=max-min;
  let h=0;
  if(d)h=(max===r?(g-b)/d+(g<b?6:0):max===g?(b-r)/d+2:(r-g)/d+4)*60;
  return {h,s:max?d/max:0,v:max};
}
function wpFromHSV({h,s,v}){
  const c=v*s,x=c*(1-Math.abs((h/60)%2-1)),m=v-c;
  const rgb=h<60?[c,x,0]:h<120?[x,c,0]:h<180?[0,c,x]:h<240?[0,x,c]:h<300?[x,0,c]:[c,0,x];
  return '#'+rgb.map(n=>Math.round((n+m)*255).toString(16).padStart(2,'0')).join('');
}
function wpRead(wp){
  const colors=String(wp?.type==='gradient'?wp.value:'').match(/#[a-f\d]{6}/gi)||[];
  const angle=String(wp?.value||'').match(/(-?[\d.]+)deg/);
  const c1=wpHex(wp?.colors?.[0])||wpHex(colors[0])||'#a9bfd7';
  const c2=wpHex(wp?.colors?.[1])||wpHex(colors[1])||'#eee2cc';
  return {c1,c2,angle:((Math.round(Number(wp?.angle??angle?.[1]??135))%360)+360)%360,
    mode:wp?.colorMode==='solid'||(!wp?.colorMode&&colors.length>1&&colors[0].toLowerCase()===colors[1].toLowerCase())?'solid':'gradient'};
}

function WallpaperColorPicker({value,onChange}){
  const [hsv,setHSV]=useState(()=>wpHSV(value));
  const [draft,setDraft]=useState(value.toUpperCase());
  const [invalid,setInvalid]=useState(false);
  const current=useRef(hsv),lastHex=useRef(value),callback=useRef(onChange),drag=useRef(null),frame=useRef(0);
  callback.current=onChange;
  useEffect(()=>{
    if(lastHex.current===value)return;
    const next=wpHSV(value);if(!next.s)next.h=current.current.h;
    current.current=next;lastHex.current=value;setHSV(next);setDraft(value.toUpperCase());setInvalid(false);
  },[value]);
  const flush=()=>{
    cancelAnimationFrame(frame.current);frame.current=0;
    const next=current.current,hex=wpFromHSV(next);
    setHSV({...next});setDraft(hex.toUpperCase());setInvalid(false);
    if(hex!==lastHex.current){lastHex.current=hex;callback.current(hex)}
  };
  const update=patch=>{
    current.current={...current.current,...patch};
    if(!frame.current)frame.current=requestAnimationFrame(flush);
  };
  const move=e=>{
    const d=drag.current;if(!d||d.id!==e.pointerId)return;
    update({s:wpClamp((e.clientX-d.rect.left)/d.rect.width,0,1),v:1-wpClamp((e.clientY-d.rect.top)/d.rect.height,0,1)});
  };
  const start=e=>{
    if(e.button!==0)return;
    e.preventDefault();e.currentTarget.focus({preventScroll:true});
    drag.current={id:e.pointerId,rect:e.currentTarget.getBoundingClientRect()};
    e.currentTarget.setPointerCapture(e.pointerId);move(e);
  };
  const end=e=>{
    if(!drag.current||drag.current.id!==e.pointerId)return;
    if(e.type==='pointerup')move(e);
    flush();drag.current=null;
    if(e.currentTarget.hasPointerCapture(e.pointerId))e.currentTarget.releasePointerCapture(e.pointerId);
  };
  const accept=raw=>{
    const hex=wpHex(raw);
    if(!hex){setInvalid(true);return;}
    cancelAnimationFrame(frame.current);frame.current=0;
    const next=wpHSV(hex);if(!next.s)next.h=current.current.h;
    const changed=hex!==lastHex.current;
    current.current=next;lastHex.current=hex;setHSV(next);setDraft(hex.toUpperCase());setInvalid(false);
    if(changed)callback.current(hex);
  };
  useEffect(()=>()=>cancelAnimationFrame(frame.current),[]);
  return <div className="wp-color-picker">
    <div className="wp-sv" role="slider" tabIndex="0" aria-label="饱和度与亮度" aria-valuemin="0" aria-valuemax="100" aria-valuenow={Math.round(hsv.s*100)} aria-valuetext={`饱和度 ${Math.round(hsv.s*100)}%，亮度 ${Math.round(hsv.v*100)}%`} aria-describedby="wp-picker-help"
      style={{'--hue':hsv.h}} onPointerDown={start} onPointerMove={move} onPointerUp={end} onPointerCancel={end} onLostPointerCapture={end}
      onKeyDown={e=>{
        const step=e.shiftKey ? .05 : .01;let patch;
        if(e.key==='ArrowLeft')patch={s:wpClamp(current.current.s-step,0,1)};
        if(e.key==='ArrowRight')patch={s:wpClamp(current.current.s+step,0,1)};
        if(e.key==='ArrowUp')patch={v:wpClamp(current.current.v+step,0,1)};
        if(e.key==='ArrowDown')patch={v:wpClamp(current.current.v-step,0,1)};
        if(patch){e.preventDefault();update(patch)}
      }}>
      <span className="wp-sv-cursor" style={{left:(hsv.s*100)+'%',top:((1-hsv.v)*100)+'%',background:wpFromHSV(hsv)}}/>
    </div>
    <span id="wp-picker-help" className="wp-sr-only">左右方向键调整饱和度，上下方向键调整亮度，按住 Shift 加快调整。</span>
    <div className="wp-hue-row"><span>色相</span><input type="range" className="wp-hue" min="0" max="359" step="1" value={Math.round(hsv.h)%360} aria-label="色相" style={{'--hue':hsv.h}} onChange={e=>update({h:Number(e.target.value)})} onPointerUp={flush} onBlur={()=>{if(frame.current)flush()}}/></div>
    <div className="wp-color-fields">
      <label className={'wp-hex-field'+(invalid?' invalid':'')}><span>HEX</span><input value={draft} aria-label="颜色 HEX" aria-invalid={invalid} maxLength="7" spellCheck="false" autoComplete="off"
        onChange={e=>{setDraft(e.target.value);setInvalid(false);if(/^#?[a-f\d]{6}$/i.test(e.target.value))accept(e.target.value)}}
        onBlur={()=>accept(draft)} onKeyDown={e=>{if(e.key==='Enter'){e.preventDefault();accept(draft)}if(e.key==='Escape'){e.preventDefault();setDraft(value.toUpperCase());setInvalid(false)}}}/></label>
      <label className="wp-system-color" title="打开系统取色器"><span style={{background:value}}/><span>取色器</span><input type="color" value={value} aria-label="系统取色器" onChange={e=>accept(e.target.value)}/></label>
    </div>
    {invalid&&<p className="wp-color-error" role="alert">请输入 3 或 6 位十六进制色值。</p>}
  </div>;
}

function WallpaperColorStudio({wallpaper,onChange}){
  const [palette,setPalette]=useState(()=>wpRead(wallpaper));
  const [activeStop,setActiveStop]=useState(0);
  const current=useRef(palette),emitted=useRef(null),applied=useRef(wallpaper),callback=useRef(onChange),dial=useRef(null),drag=useRef(null),frame=useRef(0);
  callback.current=onChange;applied.current=wallpaper;
  useEffect(()=>{
    if(wallpaper===emitted.current||wallpaper?.type!=='gradient')return;
    const next=wpRead(wallpaper);current.current=next;setPalette(next);if(next.mode==='solid')setActiveStop(0);
  },[wallpaper]);
  const publish=()=>{
    cancelAnimationFrame(frame.current);frame.current=0;
    const next={...current.current};
    setPalette(prev=>Object.keys(next).every(k=>prev[k]===next[k])?prev:next);
    const wp={id:'solid_wp',type:'gradient',value:`linear-gradient(${next.angle}deg, ${next.c1} 0%, ${next.mode==='solid'?next.c1:next.c2} 100%)`,colorMode:next.mode,colors:[next.c1,next.c2],angle:next.angle};
    const previous=applied.current;
    if(previous?.id===wp.id&&previous.value===wp.value&&previous.colorMode===wp.colorMode&&previous.angle===wp.angle&&previous.colors?.[0]===wp.colors[0]&&previous.colors?.[1]===wp.colors[1])return;
    emitted.current=wp;applied.current=wp;callback.current(wp);
  };
  const change=(patch,defer=false)=>{
    current.current={...current.current,...patch};
    if(defer){if(!frame.current)frame.current=requestAnimationFrame(publish)}else publish();
  };
  const dialMove=e=>{
    const d=drag.current;if(!d||d.id!==e.pointerId)return;
    const a=Math.round(Math.atan2(e.clientY-d.cy,e.clientX-d.cx)*180/Math.PI+90);
    change({angle:(a+360)%360},true);
  };
  const dialStart=e=>{
    if(e.button!==0)return;e.preventDefault();e.currentTarget.focus({preventScroll:true});
    const r=e.currentTarget.getBoundingClientRect();drag.current={id:e.pointerId,cx:r.left+r.width/2,cy:r.top+r.height/2};
    e.currentTarget.setPointerCapture(e.pointerId);dialMove(e);
  };
  const dialEnd=e=>{
    if(!drag.current||drag.current.id!==e.pointerId)return;
    if(e.type==='pointerup')dialMove(e);publish();drag.current=null;
    if(e.currentTarget.hasPointerCapture(e.pointerId))e.currentTarget.releasePointerCapture(e.pointerId);
  };
  useEffect(()=>()=>cancelAnimationFrame(frame.current),[]);
  const {c1,c2,angle,mode}=palette,isApplied=wallpaper?.type==='gradient';
  const background=mode==='solid'?c1:`linear-gradient(${angle}deg, ${c1}, ${c2})`;
  const previewLight=[c1,mode==='solid'?c1:c2].map(c=>{const rgb=[1,3,5].map(i=>parseInt(c.slice(i,i+2),16));return rgb[0]*.2126+rgb[1]*.7152+rgb[2]*.0722}).reduce((a,b)=>a+b)/2>160;
  return <div className={'wp-card wp-color-studio'+(isApplied?' active':'')}>
    <button type="button" className="wp-card-header wp-studio-header" onClick={()=>change({})}>
      <span className="wp-card-preview" style={{background}}/><span className="wp-card-info"><span className="wp-card-title">纯色与渐变</span><span className="wp-card-desc">为主页调一抹喜欢的颜色</span></span>
      <span className={'wp-applied'+(isApplied?' on':'')}>{isApplied?'已应用':'应用'}</span>
    </button>
    <div className="wp-studio-body">
      <div className="wp-mode" role="group" aria-label="壁纸颜色模式">
        <button aria-pressed={mode==='solid'} className={mode==='solid'?'active':''} onClick={()=>{setActiveStop(0);change({mode:'solid'})}}>纯色</button>
        <button aria-pressed={mode==='gradient'} className={mode==='gradient'?'active':''} onClick={()=>change({mode:'gradient'})}>渐变</button>
      </div>
      <div className={'wp-live-preview'+(previewLight?' light':'')} style={{background}} role="img" aria-label={mode==='solid'?'纯色壁纸预览':'渐变壁纸预览'}>
        <span className="wp-preview-time" aria-hidden="true">09:41</span><span className="wp-preview-search" aria-hidden="true"><Icons.Search/>搜索互联网…</span><span className="wp-preview-caption">实时预览</span>
      </div>
      <div className={'wp-color-stops'+(mode==='solid'?' solid':'')}>
        {[c1,...(mode==='gradient'?[c2]:[])].map((color,i)=><button key={i} className={'wp-color-stop'+(activeStop===i?' active':'')} aria-pressed={activeStop===i} aria-label={mode==='solid'?'编辑背景色':i===0?'编辑起始色':'编辑结束色'} onClick={()=>setActiveStop(i)}><span className="wp-stop-swatch" style={{background:color}}/><span><strong>{mode==='solid'?'背景色':i===0?'起始色':'结束色'}</strong><small>{color.toUpperCase()}</small></span></button>)}
        {mode==='gradient'&&<button className="wp-swap" title="交换渐变颜色" aria-label="交换渐变颜色" onClick={()=>change({c1:c2,c2:c1})}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 8h15m-4-4 4 4-4 4M20 16H5m4-4-4 4 4 4"/></svg></button>}
      </div>
      <WallpaperColorPicker key={activeStop} value={activeStop===1?c2:c1} onChange={color=>change(activeStop===1?{c2:color}:{c1:color})}/>
      {mode==='gradient'&&<div className="wp-angle-control">
        <svg ref={dial} className="gradient-dial" viewBox="0 0 100 100" role="slider" tabIndex="0" aria-label="渐变方向波轮" aria-valuemin="0" aria-valuemax="359" aria-valuenow={angle} aria-valuetext={angle+' 度'}
          onPointerDown={dialStart} onPointerMove={dialMove} onPointerUp={dialEnd} onPointerCancel={dialEnd} onLostPointerCapture={dialEnd}
          onKeyDown={e=>{let a;if(['ArrowRight','ArrowUp'].includes(e.key))a=(angle+(e.shiftKey?15:1))%360;if(['ArrowLeft','ArrowDown'].includes(e.key))a=(angle-(e.shiftKey?15:1)+360)%360;if(e.key==='Home')a=0;if(e.key==='End')a=359;if(a!==undefined){e.preventDefault();change({angle:a})}}}>
          <circle cx="50" cy="50" r="45" className="wp-dial-bg"/>
          {[0,45,90,135,180,225,270,315].map(a=><line key={a} x1={50+37*Math.sin(a*Math.PI/180)} y1={50-37*Math.cos(a*Math.PI/180)} x2={50+41*Math.sin(a*Math.PI/180)} y2={50-41*Math.cos(a*Math.PI/180)} className="wp-dial-tick"/>)}
          <line x1="50" y1="50" x2={50+29*Math.sin(angle*Math.PI/180)} y2={50-29*Math.cos(angle*Math.PI/180)} className="wp-dial-line"/>
          <circle cx={50+35*Math.sin(angle*Math.PI/180)} cy={50-35*Math.cos(angle*Math.PI/180)} r="4" className="wp-dial-dot"/>
          <circle cx="50" cy="50" r="3" className="wp-dial-dot"/>
        </svg>
        <div className="wp-angle-fields"><div className="wp-angle-head"><label htmlFor="wp-angle-range">渐变方向</label><label className="wp-angle-number"><input type="number" min="0" max="359" value={angle} aria-label="渐变角度数值" onChange={e=>{if(e.target.value!=='')change({angle:wpClamp(Math.round(Number(e.target.value)),0,359)})}}/><span>°</span></label></div>
          <input id="wp-angle-range" type="range" min="0" max="359" value={angle} aria-label="渐变角度" onChange={e=>change({angle:Number(e.target.value)},true)} onPointerUp={()=>{if(frame.current)publish()}} onBlur={()=>{if(frame.current)publish()}}/>
          <div className="wp-angle-labels"><span>0°</span><span>180°</span><span>359°</span></div>
        </div>
      </div>}
      <div className="wp-presets-head"><span>{mode==='solid'?'精选色彩':'灵感配色'}</span><span>点击即应用</span></div>
      <div className="wp-preset-grid">
        {(mode==='solid'?WP_SOLIDS:WP_GRADIENTS).map(p=>{
          const selected=mode==='solid'?c1===p.color:c1===p.c1&&c2===p.c2&&angle===p.angle;
          return <button key={p.name} className={'wp-preset'+(selected?' active':'')} aria-label={'应用'+p.name+(mode==='solid'?'纯色':'渐变')} aria-pressed={selected} onClick={()=>change(mode==='solid'?{c1:p.color}:{c1:p.c1,c2:p.c2,angle:p.angle})}>
            <span className="wp-preset-color" style={{background:mode==='solid'?p.color:`linear-gradient(${p.angle}deg, ${p.c1}, ${p.c2})`}}>{selected&&<span>✓</span>}</span><span>{p.name}</span>
          </button>;
        })}
      </div>
    </div>
  </div>;
}

// ============ SETTINGS PANEL (两列布局 · 手机设置风格) ============
function SettingsPanel({initialCat,wallpaper,shortcuts,searchEngine,closing,onClose,onWallpaperChange,onSearchEngineChange,targetLang,onTargetLangChange,showSearchSuggest,onShowSuggestChange,showSearchHistory,onShowHistoryChange,compactSuggestions,onCompactSuggestionsChange,searchRefresh,onSearchRefreshChange,searchHistory,onDelSearchHistory,onClearSearchHistory,onAddShortcut,onDeleteShortcut,onUpdateShortcut,onMoveShortcut,dockAlways,onDockAlwaysChange,dockTransparent,onDockTransparentChange,onAddGroup,onRenameGroup,onDeleteGroup,onRemoveFromGroup,onMoveToGroup,onBingCacheShow,onBingFetch,fontKey,onFontChange,clockSize,clockX,clockY,onClockSizeChange,onClockXChange,onClockYChange,clockColor,onClockColorChange,clockSat,onClockSatChange,clockOpacity,onClockOpacityChange,clockWeight,onClockWeightChange}){
  const [activeCat,setActiveCat]=useState(initialCat||'wallpaper');
  // 懒加载：仅渲染已访问过的类别（首次只渲染"外观"），点击哪个加载哪个
  const [renderedCats,setRenderedCats]=useState(()=>new Set(['wallpaper',initialCat||'wallpaper']));
  const switchCat=k=>{
    setActiveCat(k);
    const content=document.querySelector('.settings-panel-v2 .settings-content');if(content)content.scrollTop=0;
    setRenderedCats(prev=>{
      if(prev.has(k))return prev;
      const next=new Set(prev);next.add(k);return next;
    });
  };
  const [showShortcutModal,setShowShortcutModal]=useState(false);
  const [editTarget,setEditTarget]=useState(null);
  const [showGroupModal,setShowGroupModal]=useState(false);
  const [groupEditTarget,setGroupEditTarget]=useState(null);
  const [expandedGroup,setExpandedGroup]=useState(null);
  const [shortcutInGroup,setShortcutInGroup]=useState('');
  const [dragItemId,setDragItemId]=useState(null);
  const [dropGroupId,setDropGroupId]=useState(null);
  const [enabledNews,setEnabledNews]=useState(readSubList('qomo_news_sources',[]));
  const [enabledAi,setEnabledAi]=useState(readSubList('qomo_ai_sources',[]));
  const toggleSource=(list,set,key,item)=>{
    const next=list.includes(item)?list.filter(s=>s!==item):[...list,item];
    set(next);
    localStorage.setItem(key,JSON.stringify(next));
  };
  const [enabledLeagues,setEnabledLeagues]=useState(readSubList('qomo_leagues',[]));
  const [stocks,setStocks]=useState(()=>{try{return JSON.parse(localStorage.getItem('qomo_stocks')||'[]')}catch(e){return []}});
  const [npDefault,setNpDefault]=useState(()=>localStorage.getItem('qomo_newspaper_default')||'news');
  const [stockInput,setStockInput]=useState('');
  const [histPage,setHistPage]=useState(0);
  const HIST_PAGE_SIZE=5;
  const histPageItems=searchHistory.slice(histPage*HIST_PAGE_SIZE,(histPage+1)*HIST_PAGE_SIZE);
  const histTotalPages=Math.max(1,Math.ceil(searchHistory.length/HIST_PAGE_SIZE));
  const toggleLeague=item=>{
    const next=enabledLeagues.includes(item)?enabledLeagues.filter(s=>s!==item):[...enabledLeagues,item];
    setEnabledLeagues(next);
    localStorage.setItem('qomo_leagues',JSON.stringify(next));
    window.dispatchEvent(new Event('qomo_leagues_change'));
  };
  const addStock=()=>{
    const c=stockInput.trim().toLowerCase();
    if(!c)return;
    const next=stocks.includes(c)?stocks:[...stocks,c];
    setStocks(next);setStockInput('');
    localStorage.setItem('qomo_stocks',JSON.stringify(next));
  };
  const delStock=c=>{
    const next=stocks.filter(s=>s!==c);
    setStocks(next);
    localStorage.setItem('qomo_stocks',JSON.stringify(next));
  };
  const [wallImages,setWallImages]=useState([]);
  const [bingArchive,setBingArchive]=useState([]);
  const [bingArchiveLoading,setBingArchiveLoading]=useState(false);

  // 进入外观页才加载图墙；两个独立请求并行，重复切换不重复下载。
  const wallsLoaded=useRef(false);
  const wallsRequest=useRef(null);
  useEffect(()=>()=>{wallsRequest.current?.abort()},[]);
  useEffect(()=>{
    if(activeCat!=='wallpaper'||wallsLoaded.current)return;
    wallsLoaded.current=true;
    const ctrl=new AbortController();
    wallsRequest.current=ctrl;
    setBingArchiveLoading(true);
    const load=async(path,set)=>{
      try{
        const res=await fetch(API_BASE+path,{signal:ctrl.signal});
        const data=await res.json();
        if(!ctrl.signal.aborted)set(data.images||[]);
      }catch(e){}
    };
    Promise.all([load('/wallpapers',setWallImages),load('/bing-archive',setBingArchive)])
      .finally(()=>{if(!ctrl.signal.aborted)setBingArchiveLoading(false)});
  },[activeCat]);

  // 分类的状态属于面板本身；在绘制前测量，避免依赖父组件的一秒时钟刷新。
  useLayoutEffect(()=>{
    if(!LG_OK||!searchRefresh||window.innerWidth<=600)return;
    lgSyncSettings(true);
    let frame=0;
    const changed=new Set();
    const ro=new ResizeObserver(entries=>{
      entries.forEach(entry=>changed.add(entry.target));
      cancelAnimationFrame(frame);
      frame=requestAnimationFrame(()=>{lgSyncSettings(true,changed);changed.clear()});
    });
    ['.settings-panel-v2','.settings-panel-v2 .toggle-knob,.settings-panel-v2 .source-toggle i','.settings-panel-v2 .slider-glass b']
      .forEach(s=>{const el=document.querySelector(s);if(el)ro.observe(el,{box:'border-box'})});
    document.querySelectorAll('.settings-panel-v2 .engine-pills').forEach(el=>ro.observe(el,{box:'border-box'}));
    return()=>{ro.disconnect();cancelAnimationFrame(frame)};
  },[activeCat,searchRefresh,compactSuggestions]);
  const [customUrl,setCustomUrl]=useState(wallpaper?.type==='image'?wallpaper.value:'');
  const [toastMsg,showToast]=useToast();
  const [uploading,setUploading]=useState(false);
  const [bingLoading,setBingLoading]=useState(false);

  const fileInputRef=useRef(null);
  const handleCustomUrl=()=>{if(!customUrl.trim())return;onWallpaperChange({id:'custom',type:'image',value:customUrl.trim()});showToast('壁纸已更新')};

  const handleBingWallpaper=async()=>{
    setBingLoading(true);
    try{
      const cached=await onBingCacheShow();
      if(cached)showToast('Bing 每日图已应用（缓存）');
      try{
        const online=await onBingFetch();
        persistLocal({id:'bing_default',type:'image',value:online},shortcuts,searchEngine,'dark');
        showToast('Bing 每日图已更新');
      }catch(e){
        if(!cached)showToast('获取失败: '+(e.message||'网络错误'));
      }
    }catch(e){showToast('获取失败: '+e.message)}
    finally{setBingLoading(false)}
  };

  const handleFileUpload=async(e)=>{
    const file=e.target.files?.[0];
    if(!file)return;
    if(!file.type.startsWith('image/')){showToast('请选择图片文件');return}
    if(file.size>10*1024*1024){showToast('图片不能超过10MB');return}
    setUploading(true);
    try{const formData=new FormData();formData.append('wallpaper',file);const result=await uploadFile('/upload/wallpaper',formData);onWallpaperChange({id:'uploaded',type:'image',value:result.url});setCustomUrl(result.url);showToast('壁纸上传成功！');try{const res=await fetch(API_BASE+'/wallpapers');const data=await res.json();setWallImages(data.images||[])}catch(e){}}
    catch(err){showToast('上传失败: '+err.message)}
    finally{setUploading(false);if(fileInputRef.current)fileInputRef.current.value=''}
  };


  return(<>
    <div className={`settings-panel settings-panel-v2${compactSuggestions?' compact-suggestions':''}${closing?' closing':''}`}>
      <div className="settings-header">
        <div className="frosted-layer frosted-layer-1" aria-hidden="true"/>
        <div className="settings-header-inner">
          <span className="settings-title">设置</span>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
      </div>
      <div className="settings-layout">
        <nav className="settings-nav">
          {[
            {key:'wallpaper',label:'外观',icon:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>},
            {key:'search',label:'搜索',icon:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>},
            {key:'shortcuts',label:'快捷方式',icon:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>},
            {key:'font',label:'时钟',icon:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 7V4h16v3"/><path d="M9 20h6"/><path d="M12 4v16"/></svg>},
            {key:'sources',label:'报纸',icon:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0V8"/><path d="M18 14h-8"/><path d="M15 18h-5"/><path d="M10 6h8v4h-8V6z"/></svg>},
            {key:'about',label:'关于',icon:<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>},
          ].map(it=>(
            <button key={it.key} className={`settings-nav-item${activeCat===it.key?' active':''}`} onClick={()=>switchCat(it.key)}>
              <span className="nav-icon">{it.icon}</span>
              <span className="nav-label">{it.label}</span>
            </button>
          ))}
        </nav>
        <div className="settings-content">
          {activeCat==='wallpaper'&&renderedCats.has('wallpaper')&&(
        <div className="setting-section">
          <label className="setting-label">壁纸</label>

          <WallpaperColorStudio wallpaper={wallpaper} onChange={onWallpaperChange}/>

          {/* Bing 每日壁纸 */}
          <div className={`wp-card${wallpaper?.id==='bing_default'?' active':''}`}>
            <div className="wp-card-header" onClick={handleBingWallpaper}>
              <div className="wp-card-preview bing-preview">
                {bingLoading?<span className="loading-spinner" style={{width:'14px',height:'14px'}}/>:<img src="icons/bing.svg" alt="Bing" style={{width:'18px',height:'18px',filter:'brightness(10)'}}/>}
              </div>
              <div className="wp-card-info">
                <span className="wp-card-title">Bing 每日壁纸</span>
                <span className="wp-card-desc">每日自动同步新图</span>
              </div>
              {wallpaper?.id==='bing_default'&&<span className="wp-card-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" width="14" height="14"><polyline points="20 6 9 17 4 12"/></svg></span>}
            </div>
          </div>

          {/* 我的图片（图墙） */}
          <div className="wp-card">
            <div className="wp-card-header" style={{cursor:'default'}}>
              <div className="wp-card-preview" style={{background:'rgba(255,255,255,0.06)'}}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="16" height="16" style={{color:'rgba(255,255,255,0.3)'}}><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
              </div>
              <div className="wp-card-info">
                <span className="wp-card-title">我的图片</span>
                <span className="wp-card-desc">上传的图片自动入库，点击即可应用</span>
              </div>
            </div>
            <div className="custom-img-row">
              <input className="custom-url-input" placeholder="粘贴图片URL" value={customUrl} onChange={e=>setCustomUrl(e.target.value)} onKeyDown={e=>e.key==='Enter'&&handleCustomUrl()}/>
              <button className="btn btn-primary btn-sm" onClick={handleCustomUrl}>应用</button>
            </div>
            <input type="file" ref={fileInputRef} accept="image/*" style={{display:'none'}} onChange={handleFileUpload}/>
            <button className="btn btn-secondary btn-sm btn-block" onClick={()=>fileInputRef.current?.click()} disabled={uploading}>
              {uploading?<><span className="loading-spinner" style={{width:'10px',height:'10px',marginRight:'4px'}}/>上传中...</>:'上传图片到图墙'}
            </button>
            {wallImages.length>0?(
              <div className="wall-grid">
                {wallImages.map(img=>(
                  <div key={img.filename} className={`wall-thumb${wallpaper?.value===img.url?' active':''}`}
                    title={img.filename}
                    onClick={()=>{onWallpaperChange({id:'uploaded',type:'image',value:img.url});setCustomUrl(img.url);showToast('壁纸已应用')}}>
                    <img src={img.url} alt="" loading="lazy"/>
                  </div>
                ))}
              </div>
            ):(
              <p className="wall-empty">还没有上传的图片，点击上方按钮上传</p>
            )}
          </div>

          {/* 往期每日壁纸（Bing 近 30 天） */}
          <div className="wp-card">
            <div className="wp-card-header" style={{cursor:'default'}}>
              <div className="wp-card-preview bing-preview">
                <img src="icons/bing.svg" alt="Bing" style={{width:'18px',height:'18px',filter:'brightness(10)'}}/>
              </div>
              <div className="wp-card-info">
                <span className="wp-card-title">往期每日壁纸</span>
                <span className="wp-card-desc">Bing 近 30 天原图，点击即可应用</span>
              </div>
            </div>
            {bingArchiveLoading?(
              <div style={{display:'flex',alignItems:'center',justifyContent:'center',padding:'18px 0',gap:'8px',color:'var(--text-muted)',fontSize:'12px'}}>
                <span className="loading-spinner" style={{width:'14px',height:'14px'}}/>加载往期壁纸...
              </div>
            ):bingArchive.length>0?(
              <div className="wall-grid">
                {bingArchive.map(b=>(
                  <div key={b.date} className={`wall-thumb${wallpaper?.value===b.url?' active':''}`}
                    title={(b.copyright||'')+' · '+b.date}
                    onClick={()=>{onWallpaperChange({id:'bing_archive',type:'image',value:b.url});showToast('已应用 '+b.date+' 的壁纸')}}>
                    <img src={b.url} alt={b.date} loading="lazy"/>
                    <span className="wall-thumb-date">{b.date.slice(5)}</span>
                  </div>
                ))}
              </div>
            ):(
              <p className="wall-empty">往期壁纸加载失败或不可用</p>
            )}
          </div>
        </div>
          )}
          {activeCat==='search'&&renderedCats.has('search')&&(
        <>
        <div className="setting-section">
          <label className="setting-label">搜索引擎</label>
          <div className="engine-pills">
            {Object.entries(SEARCH_ENGINES).map(([key,eng])=>
              <button key={key} className={`engine-pill${searchEngine===key?' active':''}`} onClick={()=>onSearchEngineChange(key)}>
                <img src={`icons/${key==='google'?'logo-google':key==='bing'?'bing':'百度'}.svg?v=120`} alt={eng.name}/>
                <span>{eng.name}</span>
              </button>
            )}
          </div>
        </div>

        <div className="setting-section">
          <div className="toggle-row">
            <span className="toggle-row-label">显示搜索推荐</span>
            <Toggle on={showSearchSuggest} onChange={onShowSuggestChange}/>
          </div>
          <div className="toggle-row">
            <span className="toggle-row-label">显示搜索历史（最多 8 条）</span>
            <Toggle on={showSearchHistory} onChange={onShowHistoryChange}/>
          </div>
          <div className="toggle-row">
            <span className="toggle-row-label">候选词与历史记录更紧凑</span>
            <Toggle on={compactSuggestions} onChange={onCompactSuggestionsChange}/>
          </div>
          <div className="toggle-row">
            <span className="toggle-row-label">搜索焕新视觉</span>
            <Toggle on={searchRefresh} onChange={onSearchRefreshChange}/>
          </div>
          <div className="history-manage">
            <div className="history-manage-head">
              <span className="history-manage-title">搜索历史记录</span>
              {searchHistory.length>0&&<button className="history-manage-clear" onClick={onClearSearchHistory}>清空全部</button>}
            </div>
            {searchHistory.length===0?(<p className="np-todo-empty">暂无搜索历史</p>):(
              <>
              <div className="history-manage-list">
                {histPageItems.map((h,i)=>(
                  <div key={i} className="history-manage-item">
                    <span className="history-manage-text">{h}</span>
                    <button className="history-manage-del" onClick={()=>onDelSearchHistory(h)}>✕</button>
                  </div>
                ))}
              </div>
              {searchHistory.length>HIST_PAGE_SIZE&&(
                <div className="history-manage-pager">
                  <button className="history-manage-page-btn" disabled={histPage===0} onClick={()=>setHistPage(p=>Math.max(0,p-1))}>上一页</button>
                  <span className="history-manage-page-info">{histPage+1} / {histTotalPages}</span>
                  <button className="history-manage-page-btn" disabled={histPage>=histTotalPages-1} onClick={()=>setHistPage(p=>Math.min(histTotalPages-1,p+1))}>下一页</button>
                </div>
              )}
              </>
            )}
          </div>
        </div>

        <div className="setting-section">
          <label className="setting-label">翻译目标语言</label>
          <div className="engine-pills" data-lg-pills="lang">
            <button className={`engine-pill lang-pill${targetLang==='en'?' active':''}`} onClick={()=>onTargetLangChange('en')}>
              <span className="lang-badge">EN</span>
              <span>英语</span>
            </button>
            <button className={`engine-pill lang-pill${targetLang==='ja'?' active':''}`} onClick={()=>onTargetLangChange('ja')}>
              <span className="lang-badge">日</span>
              <span>日语</span>
            </button>
          </div>
        </div>
        </>
          )}
          {activeCat==='shortcuts'&&renderedCats.has('shortcuts')&&(
        <div className="setting-section">
          <div className="sc-manage-head">
            <label className="setting-label">快捷方式管理</label>
          </div>

          <div className="toggle-row">
            <span className="toggle-row-label">快捷方式始终展示</span>
            <Toggle on={dockAlways} onChange={onDockAlwaysChange}/>
          </div>

          <div className="toggle-row">
            <span className="toggle-row-label">隐藏快捷方式底色</span>
            <Toggle on={dockTransparent} onChange={onDockTransparentChange}/>
          </div>

          <div className="sc-add-row">
            <button className="btn btn-primary btn-sm" onClick={()=>{setEditTarget(null);setShortcutInGroup('');setShowShortcutModal(true)}}>
              <Icons.Plus/> 快捷方式
            </button>
            <button className="btn btn-secondary btn-sm" onClick={()=>{setGroupEditTarget(null);setShowGroupModal(true)}}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>
              新建分组
            </button>
          </div>

          {shortcuts.length===0&&<p className="sc-empty">还没有快捷方式，点击上方按钮添加</p>}
          {shortcuts.filter(s=>!s.groupId).map((sc,i)=>{
            const filtered=shortcuts.filter(s=>!s.groupId);
            if(sc.type==='group'){
              const members=shortcuts.filter(s=>s.groupId===sc.id&&s.type!=='group');
              const isOpen=expandedGroup===sc.id;
              return (
                <div key={sc.id} className="sc-group-item">
                  <div className={`sc-manage-item sc-group-head${dropGroupId===sc.id?' drop-target':''}`}
                    onClick={()=>setExpandedGroup(isOpen?null:sc.id)}
                    onDragOver={e=>{e.preventDefault();if(dragItemId)setDropGroupId(sc.id)}}
                    onDrop={e=>{e.preventDefault();if(dragItemId)onMoveToGroup(dragItemId,sc.id);setDragItemId(null);setDropGroupId(null)}}>
                    <div className="sc-manage-icon sc-group-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="20" height="20"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>
                    </div>
                    <div className="sc-manage-info">
                      <span className="sc-manage-name">{sc.name}</span>
                      <span className="sc-manage-url">{members.length} 个快捷方式</span>
                    </div>
                    <div className="sc-manage-actions" onClick={e=>e.stopPropagation()}>
                      <button className="sc-manage-btn" title={isOpen?'收起':'展开'} onClick={()=>setExpandedGroup(isOpen?null:sc.id)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`sc-chevron${isOpen?' rot':''}`}><polyline points="6 9 12 15 18 9"/></svg>
                      </button>
                      <button className="sc-manage-btn" title="编辑分组" onClick={()=>{setGroupEditTarget(sc);setShowGroupModal(true)}}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></svg>
                      </button>
                      <button className="sc-manage-btn danger" title="删除分组" onClick={()=>{if(confirm(`删除分组「${sc.name}」？组内 ${members.length} 个快捷方式将移出分组`))onDeleteGroup(sc.id)}}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                      </button>
                    </div>
                  </div>
                  {isOpen&&(
                    <div className="sc-group-members">
                      {members.length===0&&<p className="sc-group-empty">分组为空，点击下方按钮添加成员</p>}
                      {members.map(m=>(
                        <div key={m.id} className="sc-manage-item sc-member-item">
                          <div className="sc-manage-icon">{m.icon?<img src={m.icon} alt=""/>:<span>{getInitial(m.name)}</span>}</div>
                          <div className="sc-manage-info">
                            <span className="sc-manage-name">{m.name}</span>
                            <span className="sc-manage-url">{extractDomain(m.url)}</span>
                          </div>
                          <div className="sc-manage-actions">
                            <button className="sc-manage-btn" title="移出分组" onClick={()=>onRemoveFromGroup(m.id)}>
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                            </button>
                            <button className="sc-manage-btn" title="编辑" onClick={()=>{setEditTarget(m);setShowShortcutModal(true)}}>
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></svg>
                            </button>
                            <button className="sc-manage-btn danger" title="删除" onClick={()=>onDeleteShortcut(m.id)}>
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                            </button>
                          </div>
                        </div>
                      ))}
                      <button className="sc-member-add" onClick={()=>{setEditTarget(null);setShortcutInGroup(sc.id);setShowShortcutModal(true)}}>
                        <Icons.Plus/> 添加成员到「{sc.name}」
                      </button>
                    </div>
                  )}
                </div>
              );
            }
            return (
              <div key={sc.id} className="sc-manage-item" draggable={true}
                onDragStart={e=>{setDragItemId(sc.id);e.dataTransfer.effectAllowed='move';e.dataTransfer.setData('text/plain','')}}
                onDragEnd={()=>{setDragItemId(null);setDropGroupId(null)}}>
                <div className="sc-manage-icon">
                  {sc.icon?<img src={sc.icon} alt=""/>:<span>{getInitial(sc.name)}</span>}
                </div>
                <div className="sc-manage-info">
                  <span className="sc-manage-name">{sc.name}</span>
                  <span className="sc-manage-url">{extractDomain(sc.url)}</span>
                </div>
                <div className="sc-manage-actions">
                  <button className="sc-manage-btn" title="上移" disabled={i===0} onClick={()=>onMoveShortcut(sc.id,-1)}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="18 15 12 9 6 15"/></svg></button>
                  <button className="sc-manage-btn" title="下移" disabled={i===filtered.length-1} onClick={()=>onMoveShortcut(sc.id,1)}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg></button>
                  <button className="sc-manage-btn" title="编辑" onClick={()=>{setEditTarget(sc);setShowShortcutModal(true)}}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></svg></button>
                  <button className="sc-manage-btn danger" title="删除" onClick={()=>onDeleteShortcut(sc.id)}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg></button>
                </div>
              </div>
            );
          })}
        </div>
          )}
          {activeCat==='font'&&renderedCats.has('font')&&(
        <>
        <div className="setting-section">
          <label className="setting-label">时钟字体</label>
          <p style={{fontSize:'12px',color:'var(--text-muted)',marginBottom:'12px',lineHeight:'1.5'}}>选择主时钟数字的显示字体，点击预览即可应用。</p>
          <div className="font-grid">
            {FONTS.map(f=>(
              <div key={f.key} className={`font-card${fontKey===f.key?' active':''}`} onClick={()=>onFontChange(f.key)}>
                <div className="font-preview" style={{fontFamily:f.family?f.family+", 'Noto Serif SC', Georgia, serif":"'Noto Serif SC', Georgia, serif"}}>0123456789</div>
                <span className="font-name">{f.name}</span>
                {fontKey===f.key&&<span className="font-check">✓</span>}
              </div>
            ))}
          </div>
        </div>

        <div className="setting-section">
          <label className="setting-label">时钟颜色</label>
          <div className="color-swatches">
            {CLOCK_COLORS.map(c=>(
              <div key={c.key} className={`color-swatch${clockColor===c.key?' active':''}`}
                style={c.value?{background:c.value}:{background:'linear-gradient(135deg,#f0ebe3 0 50%,#1a1a1a 50% 100%)'}}
                onClick={()=>onClockColorChange(c.key)} title={c.name}/>
            ))}
          </div>
          <div className="slider-row">
            <span className="slider-label">饱和度</span>
            <div className="slider-field" style={{'--pv':String(clockSat/200)}}>
              <span className="slider-glass"><i/><b/></span>
              <input type="range" min="0" max="200" step="5" value={clockSat} style={{'--p':(clockSat/200*100)+'%'}} onChange={e=>onClockSatChange(e.target.value)}/>
            </div>
            <span className="slider-value">{clockSat}%</span>
          </div>
          <div className="slider-row">
            <span className="slider-label">透明度</span>
            <div className="slider-field" style={{'--pv':String((clockOpacity-20)/80)}}>
              <span className="slider-glass"><i/><b/></span>
              <input type="range" min="20" max="100" step="5" value={clockOpacity} style={{'--p':((clockOpacity-20)/80*100)+'%'}} onChange={e=>onClockOpacityChange(e.target.value)}/>
            </div>
            <span className="slider-value">{clockOpacity}%</span>
          </div>
        </div>

        <div className="setting-section">
          <label className="setting-label">时钟调整</label>          <div className="slider-row">
            <span className="slider-label">字重</span>
            <div className="slider-field" style={{'--pv':String((clockWeight-300)/600)}}>
              <span className="slider-glass"><i/><b/></span>
              <input type="range" min="300" max="900" step="100" value={clockWeight} style={{'--p':((clockWeight-300)/600*100)+'%'}} onChange={e=>onClockWeightChange(e.target.value)}/>
            </div>
            <span className="slider-value">{clockWeight}</span>
          </div>
          <div className="slider-row">
            <span className="slider-label">字号</span>
            <div className="slider-field" style={{'--pv':String(((clockSize||56)-40)/100)}}>
              <span className="slider-glass"><i/><b/></span>
              <input type="range" min="40" max="140" step="2" value={clockSize||56} style={{'--p':(((clockSize||56)-40)/100*100)+'%'}} onChange={e=>onClockSizeChange(e.target.value)}/>
            </div>
            <span className="slider-value">{clockSize?clockSize+'px':'自动'}</span>
          </div>
          <div className="slider-row">
            <span className="slider-label">水平位置</span>
            <div className="slider-field" style={{'--pv':String((clockX+200)/400)}}>
              <span className="slider-glass"><i/><b/></span>
              <input type="range" min="-200" max="200" step="5" value={clockX} style={{'--p':((clockX+200)/400*100)+'%'}} onChange={e=>onClockXChange(e.target.value)}/>
            </div>
            <span className="slider-value">{clockX>0?'右移 '+(clockX)+'px':clockX<0?'左移 '+(-clockX)+'px':'居中'}</span>
          </div>
          <div className="slider-row">
            <span className="slider-label">垂直位置</span>
            <div className="slider-field" style={{'--pv':String((clockY+150)/300)}}>
              <span className="slider-glass"><i/><b/></span>
              <input type="range" min="-150" max="150" step="5" value={clockY} style={{'--p':((clockY+150)/300*100)+'%'}} onChange={e=>onClockYChange(e.target.value)}/>
            </div>
            <span className="slider-value">{clockY>0?'下移 '+(clockY)+'px':clockY<0?'上移 '+(-clockY)+'px':'默认'}</span>
          </div>
        </div>
        </>
          )}
          {activeCat==='sources'&&renderedCats.has('sources')&&(
        <>
        <div className="setting-section">
          <label className="setting-label">默认打开</label>
          <p className="sources-desc">打开画报时优先显示日报还是菜园百科</p>
          <div className="engine-pills">
            <button className={`engine-pill${npDefault!=='wiki'?' active':''}`} onClick={()=>{setNpDefault('news');localStorage.setItem('qomo_newspaper_default','news')}}>日报</button>
            <button className={`engine-pill${npDefault==='wiki'?' active':''}`} onClick={()=>{setNpDefault('wiki');localStorage.setItem('qomo_newspaper_default','wiki')}}>菜园百科</button>
          </div>
        </div>
        <div className="setting-section">
          <label className="setting-label">菜园百科数据源</label>
          <p className="sources-desc">扫码登录微信数据源,获取更稳定的公众号文章(未部署则自动使用搜狗微信)</p>
          <WechatLogin/>
        </div>
        <div className="setting-section">
          <label className="setting-label">新闻信源</label>
          <p className="sources-desc">选择全屏画报"今日要闻"展示的信源,可随时开关</p>
          <div className="source-list">
            {NEWS_SOURCE_LIST.map(s=>(
              <div key={s} className={`source-item${enabledNews.includes(s)?' on':''}`} onClick={()=>toggleSource(enabledNews,setEnabledNews,'qomo_news_sources',s)}>
                <span className="source-name">{s}</span>
                <span className="source-toggle"><i/></span>
              </div>
            ))}
          </div>
        </div>
        <div className="setting-section">
          <label className="setting-label">AI 信源（海外媒体）</label>
          <p className="sources-desc">选择"AI 前线"展示的海外科技媒体信源</p>
          <div className="source-list">
            {AI_SOURCE_LIST.map(s=>(
              <div key={s} className={`source-item${enabledAi.includes(s)?' on':''}`} onClick={()=>toggleSource(enabledAi,setEnabledAi,'qomo_ai_sources',s)}>
                <span className="source-name">{s}</span>
                <span className="source-toggle"><i/></span>
              </div>
            ))}
          </div>
        </div>
        <div className="setting-section">
          <label className="setting-label">赛事比分订阅</label>
          <p className="sources-desc">选择画报"体育赛事"板块展示的赛事,可多选</p>
          <div className="source-list">
            {LEAGUE_LIST.map(l=>(
              <div key={l.key} className={`source-item${enabledLeagues.includes(l.key)?' on':''}`} onClick={()=>toggleLeague(l.key)}>
                <span className="source-name">{l.name}</span>
                <span className="source-toggle"><i/></span>
              </div>
            ))}
          </div>
        </div>
        <div className="setting-section">
          <label className="setting-label">自选股</label>
          <p className="sources-desc">添加股票代码(如 sh600519、sz000001、hk00700),画报指数看板将一并展示</p>
          <div className="stock-input-row">
            <input className="np-todo-input" placeholder="输入代码,如 sh600519" value={stockInput}
              onChange={e=>setStockInput(e.target.value)} onKeyDown={e=>{if(e.key==='Enter')addStock()}}/>
            <button className="stock-add-btn" onClick={addStock}>添加</button>
          </div>
          {stocks.length===0?(<p className="np-todo-empty">暂无自选股</p>):(
            <div className="stock-list">
              {stocks.map(c=>(
                <div key={c} className="stock-chip">
                  <span className="stock-code">{c}</span>
                  <button className="stock-del" onClick={()=>delStock(c)}>✕</button>
                </div>
              ))}
            </div>
          )}
        </div>
        </>
          )}
          {activeCat==='about'&&renderedCats.has('about')&&(
        <div className="setting-section">
          <div className="agreement-box">
            <h3>Qomo 起始页使用协议</h3>
            <p className="agreement-update">更新日期：2026 年 8 月 10 日 &nbsp;·&nbsp; 生效日期：2026 年 8 月 10 日</p>

            <h5>一、协议的接受</h5>
            <p>欢迎使用 Qomo 起始页（以下简称"本服务"）。本服务由 Qomo 团队（以下简称"我们"）提供，用于帮助用户在新标签页中快速搜索、管理快捷方式与个性化壁纸。使用本服务前，请您仔细阅读并充分理解本协议全部条款，特别是以粗体标注或加下划线提示的与您的权益、责任相关的条款。您点击同意、实际使用本服务或继续使用本服务的任何功能，即视为您已阅读、理解并同意接受本协议全部内容。</p>

            <h5>二、服务说明</h5>
            <p>本服务提供以下核心功能，并可能根据运营需要适时调整：</p>
            <ol>
              <li>互联网搜索入口与多引擎切换；</li>
              <li>快捷方式与分组管理（含本地存储）；</li>
              <li>个性化壁纸：渐变、自定义图片上传、图墙、Bing 每日壁纸及往期壁纸；</li>
              <li>天气展示、时钟字体/颜色/大小自定义、翻译等辅助功能；</li>
              <li>账户注册与云端设置同步（如开放）。</li>
            </ol>
            <p>本服务的部分设置仅保存在您的浏览器本地（localStorage / IndexedDB），清除浏览器数据可能导致相关设置丢失，请您知悉并自行做好备份。</p>

            <h5>三、RSS 阅读服务说明</h5>
            <p>本服务的"QOMO 日报"画报板块为 <b>RSS 阅读器工具</b>：所展示的新闻、AI 资讯、体育比分等内容均由用户<b>手动订阅的第三方 RSS 信源</b>提供。请您知悉并同意：</p>
            <ol>
              <li><b>默认关闭、手动启用</b>：所有 RSS 订阅服务（新闻信源、AI 信源、赛事比分订阅）默认处于关闭状态，需您主动前往"设置 → 报纸"逐项启用；</li>
              <li><b>工具属性</b>：本平台<b>不生产、不编辑、不存储、不分发任何内容</b>，仅作为 RSS 阅读器提供抓取、排版与展示的工具服务；</li>
              <li><b>内容责任</b>：所有内容的版权归相应信源与原作者所有，内容的真实性、准确性与合法性由各信源自行负责，本平台不对第三方信源内容承担任何保证或连带责任；</li>
              <li><b>抓取限制</b>：受各信源反爬策略与网络环境影响，内容抓取可能失败、延迟或不完整，本平台不保证订阅内容的完整性、及时性与可用性。</li>
            </ol>

            <h5>四、账号与数据</h5>
            <p>当本服务开放账号功能时，您应使用真实、合法、有效的个人信息注册，并对账号下的一切行为负责。您应妥善保管账号与密码，因您保管不善导致的损失由您自行承担。您的账号数据仅用于本服务的正常运营，未经您授权，我们不会向任何第三方提供您的个人数据，法律法规另有规定的除外。</p>

            <h5>六、用户行为规范</h5>
            <p>您承诺在使用本服务过程中遵守法律法规及社会公序良俗，不得从事以下行为：</p>
            <ol>
              <li>利用本服务从事任何违法、违规或侵犯他人合法权益的活动；</li>
              <li>上传、发布含有暴力、色情、赌博、恐怖、仇恨、歧视、诽谤等违法违规内容；</li>
              <li>上传含有病毒、木马、恶意程序或可能损害系统安全的内容；</li>
              <li>以任何方式干扰、破坏本服务的正常运行或安全性；</li>
              <li>擅自抓取、复制、转售本服务的数据或功能。</li>
            </ol>
            <p>若您违反上述规范，我们有权不经通知删除相关内容、限制或终止向您提供服务，并保留追究法律责任的权利。</p>

            <h5>五、上传内容规范</h5>
            <p>您上传至图墙的图片应当满足以下要求：</p>
            <ol>
              <li>您对所上传图片拥有合法权利（包括著作权或合法授权），或该图片为无版权/可自由使用的内容；</li>
              <li>图片内容合法、健康，不含有任何违法或侵权内容；</li>
              <li>单张图片大小不超过 10MB，格式支持 jpg/png/gif/webp/bmp。</li>
            </ol>
            <p>您授权我们在本服务范围内使用、展示您上传的图片。如因您上传的图片引发任何第三方权利主张，由您自行负责解决并承担相应责任，与我们无关。</p>

            <h5>六、第三方内容与版权声明</h5>
            <p>本服务中展示的 Bing 每日壁纸及往期壁纸，其图片素材与相关版权归微软公司及 Bing 服务所有，我们仅通过公开接口提供浏览与展示，不对其内容负责，亦不主张相关版权。壁纸版权信息以页面展示的"版权说明"为准。如您认为相关内容侵犯您的合法权益，请与我们联系，我们将在核实后依法处理。</p>
            <p>本服务内置的时钟字体文件仅供在本服务范围内个人使用，不得用于任何商业用途或对外分发。本服务所用的全部字体素材均收集自公开渠道，版权归各字体权利人所有。如您为相关字体的权利人或其授权代表，认为本服务对字体素材的使用构成了侵权，请通过本协议第十一条载明的联系方式告知我们，并附上您的权利人身份证明及侵权情况说明，我们将在核实后及时对相关字体进行下架处理，并对此给您带来的不便深表歉意。</p>

            <h5>七、隐私保护</h5>
            <p>我们重视您的隐私。本服务在本地存储您的个性化设置，在提供服务过程中可能获取以下信息：</p>
            <ol>
              <li>您的位置信息（用于天气展示，仅在您主动授权时获取）；</li>
              <li>您的 IP 地址（用于天气定位兜底）；</li>
              <li>您上传的图片文件（用于图墙展示）。</li>
            </ol>
            <p>我们不会将这些信息用于本服务之外的目的，不会向无关第三方出售或披露您的个人信息。有关数据安全的更多细节，可随时向我们咨询。</p>

            <h5>八、免责声明</h5>
            <p>本服务按"现状"提供，我们不对服务的可用性、连续性、准确性作任何明示或默示的保证。作为 RSS 阅读器工具，本平台不对第三方信源内容的真实性、准确性与合法性负责，订阅内容出现缺漏、延迟或无法展示的，不属于平台违约。因下列情形导致服务中断或数据丢失的，我们不承担责任：</p>
            <ol>
              <li>不可抗力（自然灾害、战争、政府行为等）；</li>
              <li>网络、电力、设备故障或第三方服务（如 Bing、天气服务商）异常；</li>
              <li>您操作不当、浏览器兼容性问题或清除本地数据；</li>
              <li>其他无法预见、无法避免且无法克服的事件。</li>
            </ol>

            <h5>九、协议修改与终止</h5>
            <p>我们可能根据法律法规变化、业务发展或功能调整适时修订本协议，修订后的协议将在本页面公布并自公布之日起生效。如您继续使用本服务，即视为接受修订后的协议。我们有权在必要时终止本服务的全部或部分功能，并将在合理范围内提前公告。</p>

            <h5>十、法律适用与争议解决</h5>
            <p>本协议的订立、效力、解释、履行与争议解决均适用中华人民共和国法律。因本协议引起的或与本协议有关的争议，双方应友好协商解决；协商不成的，任何一方均可向本服务运营方所在地有管辖权的人民法院提起诉讼。</p>

            <h5>十一、联系我们</h5>
            <p>如您对本协议或本服务有任何疑问、意见或建议，欢迎通过以下方式与我们联系：</p>
            <p>邮箱：zhangjingchengzjc@outlook.com &nbsp;·&nbsp; 官网：www.home.qomotools.cn</p>
            <p className="agreement-end">感谢您使用 Qomo 起始页，祝您使用愉快。</p>
          </div>
        </div>
          )}
        </div>
      </div>
      {showShortcutModal&&<ShortcutModal initial={editTarget} defaultGroupId={shortcutInGroup} groups={shortcuts.filter(s=>s.type==='group')} onClose={()=>setShowShortcutModal(false)} onSave={editTarget?sc=>onUpdateShortcut(editTarget.id,sc):sc=>onAddShortcut({...sc,groupId:sc.groupId||shortcutInGroup})}/>}
      {showGroupModal&&<GroupModal initial={groupEditTarget} onClose={()=>setShowGroupModal(false)} onSave={groupEditTarget?g=>onRenameGroup(groupEditTarget.id,g.name):g=>onAddGroup(g.name)}/>}
    </div>
    <div className={`toast ${toastMsg?'show':''}`}>{toastMsg}</div>
  </>);
}

// ============ MAIN APP ============
/* ============================================================
   液态玻璃 · 真折射
   复刻自 https://liunian.js.org/posts/liquid-glass/（作者：刘念）
   Canvas 现算「位移贴图 / 镜面高光贴图」→ 拼成 SVG <filter> →
   元素用 backdrop-filter:url(#id) 把背后的真实画面送进滤镜做折射。
   仅桌面版新版 Chromium 支持；Safari / Firefox / 移动端自动回退到原有磨砂玻璃。
   ============================================================ */
const LG_OK=(function(){
  try{
    if(!window.LiquidGlass)return false;
    if(/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent))return false;
    if(!/(Chrome|Chromium|Edg|OPR)\//.test(navigator.userAgent))return false;
    // 窄屏断点交给 build() 判断：它每次 build / 窗口变化都会重判，
    // 这样把窗口从窄拉宽也能自动启用（放这里会变成「只在加载时判一次」，拉宽也回不来）
    const s=window.CSS&&CSS.supports;
    return !!(s&&(s('backdrop-filter','url(#lg0)')||s('-webkit-backdrop-filter','url(#lg0)')));
  }catch(e){return false}
})();

/* 三套参数。
   搜索框那套照抄原站 searchbox 实例（bezel 27 / 厚 70 / IOR 1.5），
   只把 blur 归零（不要磨砂感），折射倍率 0.7→0.8 补偿更长的框体。 */
const LG_P={
  // blur 不是 0：留一点点磨砂（可读性）。实测这一档对折射的边缘扭曲几乎无感，
  // 但能把壁纸的高频细节压掉一档，文字压在上面更稳。
  bar:{bezelWidth:27,glassThickness:70,refractiveIndex:1.5,specularOpacity:.25,specularSaturation:5,blur:2,scaleRatio:.8},
  btn:{bezelWidth:18,glassThickness:80,refractiveIndex:1.45,specularOpacity:.34,specularSaturation:6,blur:2,scaleRatio:.75},
  // 面板文字最密，给到 4
  panel:{bezelWidth:18,glassThickness:80,refractiveIndex:1.4,specularOpacity:.28,specularSaturation:5,blur:4,scaleRatio:.62},
  // 顶栏（图标按钮 / 天气胶囊）：只有 42px 高，倒角与折射倍率都要等比收小，
  // 否则位移会把 42px 的控件整个糊掉（峰值位移 ≈ maxOffset×0.498×scaleRatio）
  topbar:{bezelWidth:12,glassThickness:60,refractiveIndex:1.4,specularOpacity:.34,specularSaturation:6,blur:0,scaleRatio:.6},
  // 快捷栏图标（46px 方）：比顶栏还小一圈，倒角 9、厚 45，峰值位移 ≈13px（约高度的 28%）
  shortcut:{bezelWidth:9,glassThickness:45,refractiveIndex:1.4,specularOpacity:.34,specularSaturation:6,blur:0,scaleRatio:.6},
  // 设置面板（700x500）：面积大，倒角 20、厚 90，峰值位移 ≈24px
  settings:{bezelWidth:20,glassThickness:90,refractiveIndex:1.4,specularOpacity:.30,specularSaturation:5,blur:14,scaleRatio:.55},
  // 分段控制条（454x45）：倒角 12、厚 60，峰值位移 ≈12px
  pills:{bezelWidth:12,glassThickness:60,refractiveIndex:1.4,specularOpacity:.32,specularSaturation:6,blur:0,scaleRatio:.41},
  // 开关滑柄（34x28 r14）：玻璃从轨道挪到滑柄（原站结构），倒角 7、厚 30，峰值位移 ≈4.5px
  knob:{bezelWidth:7,glassThickness:30,refractiveIndex:1.45,specularOpacity:.40,specularSaturation:6,blur:0,scaleRatio:.29},
  // 滑动条拖柄（34x24 r12）：倒角 6、厚 26，峰值位移 ≈4px
  sliderKnob:{bezelWidth:6,glassThickness:26,refractiveIndex:1.45,specularOpacity:.40,specularSaturation:6,blur:0,scaleRatio:.29}
};

/* 材质由 CSS（body.lg-glass 作用域）精确接管，这里只借 mount() 把 <filter>
   挂进共享 <defs>，并拿到 refresh() 用于重建。占位元素是脱离文档的 div，不产生任何样式副作用。 */
const lgHandles={barIdle:null,barFocus:null,btnTranslate:null,btnEngine:null,panel:null,icon:null,weather:null,shortcut:null,settings:null,toggle:null,sourceToggle:null,pills:null};
const lgKeys={bar:'',btn:'',panel:'',icon:'',weather:'',shortcut:'',settings:'',toggle:'',sourceToggle:'',pills:''};

function lgNewHandle(id,w,h,r,params){
  if(typeof LiquidGlass==='undefined')return null;
  return LiquidGlass.mount(document.createElement('div'),Object.assign({id:id,width:w,height:h,radius:r},params));
}
/* 重建：refresh() 会用同一个 id 原子替换 <filter>，CSS 里的 url(#id) 全程有效 */
function lgResize(handle,id,w,h,r,params){
  if(!handle)return lgNewHandle(id,w,h,r,params);
  handle.refresh(Object.assign({width:w,height:h,radius:r},params));
  return handle;
}

/* 搜索框：容器宽（静止）与收缩后（聚焦）各建一张。
   倒角是烘焙在具体尺寸上的，复用宽的贴图会让右侧圆头丢掉折射，所以两个静止态各用各的。 */
function lgMountBar(w,h){
  const key=Math.round(w)+'x'+Math.round(h);
  if(lgKeys.bar===key&&lgHandles.barIdle&&lgHandles.barFocus)return true;
  const r=Math.round(h/2);
  lgHandles.barIdle=lgResize(lgHandles.barIdle,'lg-bar-idle',Math.round(w),Math.round(h),r,LG_P.bar);
  lgHandles.barFocus=lgResize(lgHandles.barFocus,'lg-bar-focus',Math.max(80,Math.round(w-169)),Math.round(h),r,LG_P.bar);
  if(!lgHandles.barIdle||!lgHandles.barFocus)return false;
  lgKeys.bar=key;
  return true;
}
function lgMountButtons(s){
  if(lgKeys.btn===s&&lgHandles.btnTranslate&&lgHandles.btnEngine)return true;
  const r=Math.round(s/2);
  lgHandles.btnTranslate=lgResize(lgHandles.btnTranslate,'lg-btn-translate',s,s,r,LG_P.btn);
  lgHandles.btnEngine=lgResize(lgHandles.btnEngine,'lg-btn-engine',s,s,r,LG_P.btn);
  if(!lgHandles.btnTranslate||!lgHandles.btnEngine)return false;
  lgKeys.btn=s;
  return true;
}
/* 顶栏图标按钮：尺寸固定，只在窗口/断点变化时重建 */
function lgMountIcon(w,h,r,cornerShape){
  const key=Math.round(w)+'x'+Math.round(h)+'x'+Math.round(r)+'x'+cornerShape;
  if(lgKeys.icon===key&&lgHandles.icon)return true;
  lgHandles.icon=lgResize(lgHandles.icon,'lg-icon',Math.round(w),Math.round(h),Math.round(r),{...LG_P.topbar,cornerShape});
  if(!lgHandles.icon)return false;
  lgKeys.icon=key;
  return true;
}
/* 天气胶囊：宽度随天气数据到达而变，必须按当前宽度重建（倒角是烘焙在具体尺寸里的） */
function lgMountWeather(w,h,r,cornerShape){
  const key=Math.round(w)+'x'+Math.round(h)+'x'+Math.round(r)+'x'+cornerShape;
  if(lgKeys.weather===key&&lgHandles.weather)return true;
  lgHandles.weather=lgResize(lgHandles.weather,'lg-weather',Math.round(w),Math.round(h),Math.round(r),{...LG_P.topbar,cornerShape});
  if(!lgHandles.weather)return false;
  lgKeys.weather=key;
  return true;
}
/* 通用：一个 id 一张贴图，按尺寸键去重（顶栏 / 快捷栏 / 设置里的固定尺寸控件都走这条） */
function lgMountAt(slot,id,w,h,r,params){
  const key=Math.round(w)+'x'+Math.round(h)+'x'+r+'x'+(params.cornerShape||'round');
  if(lgKeys[slot]===key&&lgHandles[slot])return true;
  lgHandles[slot]=lgResize(lgHandles[slot],id,Math.round(w),Math.round(h),r,params);
  if(!lgHandles[slot])return false;
  lgKeys[slot]=key;
  return true;
}
/* Geometry reads are cached per live element. Transform-only changes do not
   affect the baked maps. A category with no control keeps its existing filter. */
const lgSettingsMeasurements=new WeakMap();
function lgSettingsSurface(el,slot,id,params,inner=false){
  const w=inner?el.clientWidth:el.offsetWidth,h=inner?el.clientHeight:el.offsetHeight;
  if(!w||!h)return;
  const previous=lgSettingsMeasurements.get(el);
  let r=previous?.radius,cornerShape=previous?.cornerShape;
  if(!previous||previous.width!==w||previous.height!==h){
    const style=getComputedStyle(el,inner?'::before':null);
    // CSS scales uniform radii when the corner pairs exceed the box.
    r=Math.min(parseFloat(style.borderTopLeftRadius)||0,w/2,h/2);
    cornerShape=style.cornerShape==='superellipse(1.25)'?'continuous':style.cornerShape==='superellipse(2)'?'squircle':null;
    lgSettingsMeasurements.set(el,{width:w,height:h,radius:r,cornerShape});
  }
  lgMountAt(slot,id,w,h,r,Object.assign({},params,{cornerShape}));
}
function lgSyncSettings(measured,changed){
  if(measured){
    if(window.innerWidth<=600||!document.body.classList.contains('lg-glass'))return;
    const sync=(selector,slot,id,params,inner=false)=>{
      const el=document.querySelector(selector);
      if(el&&(!changed||changed.has(el)))lgSettingsSurface(el,slot,id,params,inner);
    };
    sync('.settings-panel-v2','settings','lg-settings',LG_P.settings,true);
    sync('.settings-panel-v2 .toggle-knob,.settings-panel-v2 .source-toggle i','knob','lg-knob',LG_P.knob);
    sync('.settings-panel-v2 .slider-glass b','sliderKnob','lg-slider',LG_P.sliderKnob);
    sync('.settings-panel-v2 .engine-pills:not([data-lg-pills="lang"])','pills','lg-pills',LG_P.pills);
    sync('.settings-panel-v2 .engine-pills[data-lg-pills="lang"]','pillsLang','lg-pills-lang',LG_P.pills);
    return;
  }
  // Prepare only the panel before opening; live controls mount before paint.
  const vw=window.innerWidth,vh=window.innerHeight;
  const w=vw<=800?vw-40:Math.min(800,vw-64);
  const radius=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--q-radius-window'))||36;
  lgMountAt('settings','lg-settings',Math.max(1,w-2),Math.max(1,Math.min(760,vh-80)-2),radius-1,Object.assign({},LG_P.settings,{cornerShape:getComputedStyle(document.documentElement).getPropertyValue('--q-corner').trim()==='superellipse(1.25)'?'continuous':null}));
}
/* 快捷栏图标 / 添加快捷方式方块：46×46，两者同尺寸同圆角，共用一张贴图 */
function lgMountShortcut(w,h,r,cornerShape){
  const key=Math.round(w)+'x'+Math.round(h)+'x'+Math.round(r)+'x'+cornerShape;
  if(lgKeys.shortcut===key&&lgHandles.shortcut)return true;
  lgHandles.shortcut=lgResize(lgHandles.shortcut,'lg-shortcut',Math.round(w),Math.round(h),Math.round(r),{...LG_P.shortcut,cornerShape});
  if(!lgHandles.shortcut)return false;
  lgKeys.shortcut=key;
  return true;
}
/* 面板高度随内容变，按尺寸重建；先建一个默认尺寸占位，保证 CSS 引用永远有效 */
function lgMountPanel(w,h,r,cornerShape){
  const key=Math.round(w)+'x'+Math.round(h)+'x'+Math.round(r)+'x'+cornerShape;
  if(lgKeys.panel===key&&lgHandles.panel)return;
  lgHandles.panel=lgResize(lgHandles.panel,'lg-panel',Math.round(w),Math.round(h),Math.round(r),{...LG_P.panel,cornerShape});
  lgKeys.panel=key;
}




/* ============================================================
   开关（Toggle）：支持「按住拖动」
   照 skill 里原站 Switch 的手感 —— 按下后滑柄跟手，松手按落点决定状态，
   位移 < 4px 仍按点击处理（翻转）。
   实现要点：
     · 进度统一用 CSS 变量 --kn-drag（0..1）表达，滑柄位置与轨道颜色都由它算，
       拖动时逐帧写 inline 值（inline 优先于类名，所以拖动期间不受 on/off 类影响）；
     · 松手先把 inline 值钉到目标态再移除，否则会先弹回旧位置再弹到新位置（闪两下）；
     · 拖完要吃掉紧随其后的 click（React 17+ 把 onClick 挂在根容器上，
       在元素上挂一个捕获阶段监听并 stopPropagation 即可拦下）。
   ============================================================ */
function Toggle({on,onChange}){
  const ref=useRef(null);
  const drag=useRef(null);
  const onDown=e=>{
    const el=ref.current; if(!el)return;
    drag.current={x0:e.clientX,y0:e.clientY,moved:false,on:!!on};
    try{el.setPointerCapture(e.pointerId)}catch(_){}
  };
  const onMove=e=>{
    const d=drag.current, el=ref.current; if(!d||!el)return;
    if(!d.moved){
      if(Math.abs(e.clientX-d.x0)<=4&&Math.abs(e.clientY-d.y0)<=4)return;
      d.moved=true; el.classList.add('kn-dragging');
    }
    const cs=getComputedStyle(el), r=el.getBoundingClientRect();
    const gap=parseFloat(cs.getPropertyValue('--sw-gap'))||3;
    const knw=parseFloat(cs.getPropertyValue('--kn-w'))||34;
    const rest=parseFloat(cs.getPropertyValue('--kn-rest'))||.68;
    const vis=knw*rest, span=r.width-gap*2-vis;
    // 用滑柄【视觉中心】反推进度：缩放不改变中心，所以指针位置与滑柄严格对应
    const p=span>0?Math.min(1,Math.max(0,(e.clientX-r.left-gap-vis/2)/span)):0;
    el.style.setProperty('--kn-drag',p.toFixed(4));
  };
  const onUp=e=>{
    const d=drag.current, el=ref.current; drag.current=null;
    if(!d||!el)return;
    try{el.releasePointerCapture(e.pointerId)}catch(_){}
    el.classList.remove('kn-dragging');
    if(!d.moved)return;                                  // 没移动 → 交给原生 click 翻转
    const p=parseFloat(el.style.getPropertyValue('--kn-drag'))||0;
    const want=p>=.5;
    if(want!==d.on){
      el.style.setProperty('--kn-drag',want?1:0);        // 先钉到目标态，避免松手回弹
      setTimeout(()=>el.style.removeProperty('--kn-drag'),700);
      onChange(want);
    }else{
      el.style.removeProperty('--kn-drag');              // 原地弹回
    }
    const block=ev=>{ev.stopPropagation();ev.preventDefault();el.removeEventListener('click',block,true)};
    el.addEventListener('click',block,true);
  };
  return <span ref={ref} className={'toggle-switch'+(on?' on':'')}
    onPointerDown={onDown} onPointerMove={onMove} onPointerUp={onUp} onPointerCancel={onUp}
    onClick={()=>onChange(!on)}>
    <span className="toggle-knob"/>
  </span>;
}

function Clock({onChange}){
  const [text,setText]=useState(()=>new Date().toLocaleTimeString('zh-CN',{hour:'2-digit',minute:'2-digit'}));
  useEffect(()=>{
    let timer=0;
    const tick=()=>{
      clearTimeout(timer);
      if(document.hidden)return;
      setText(new Date().toLocaleTimeString('zh-CN',{hour:'2-digit',minute:'2-digit'}));
      timer=setTimeout(tick,60000-Date.now()%60000+10);
    };
    tick();document.addEventListener('visibilitychange',tick);
    return()=>{clearTimeout(timer);document.removeEventListener('visibilitychange',tick)};
  },[]);
  useLayoutEffect(()=>{onChange()},[text,onChange]);
  return <div className="greeting-time">{text}</div>;
}

function App({onOpenAI}){
  const [wallpaper,setWallpaper]=useState(DEFAULT_WALLPAPER);
  const [shortcuts,setShortcuts]=useState(DEFAULT_SHORTCUTS);
  const [searchEngine,setSearchEngine]=useState('baidu');
  const [showSettings,setShowSettings]=useState(false);
  const [showNewspaper,setShowNewspaper]=useState(false);
  const [settingsCat,setSettingsCat]=useState('wallpaper');
  const goSettingsFromPaper=()=>{
    setShowNewspaper(false);
    setSettingsCat('sources');
    setShowSettings(true);
  };
  const [settingsClosing,setSettingsClosing]=useState(false);
  const [showAddShortcut,setShowAddShortcut]=useState(false);
  const [dockAlwaysExpanded,setDockAlwaysExpanded]=useState(()=>localStorage.getItem('qomo_dock_expanded')==='1');
  const [dockExpanded,setDockExpanded]=useState(()=>localStorage.getItem('qomo_dock_expanded')==='1');
  const [searchQuery,setSearchQuery]=useState('');
  const [searchSuggestions,setSearchSuggestions]=useState([]);
  const [showSuggestions,setShowSuggestions]=useState(false);
  const [suggestionsClosing,setSuggestionsClosing]=useState(false);
  const [searchHistory,setSearchHistory]=useState(()=>{try{return JSON.parse(localStorage.getItem('qomo_search_history')||'[]')}catch(e){return []}});
  const [showSearchHistory,setShowSearchHistory]=useState(()=>localStorage.getItem('qomo_show_history')!=='0');
  const [suggestIndex,setSuggestIndex]=useState(-1);
  const suggestTimerRef=useRef(null);
  const suggestCloseTimerRef=useRef(null);
  const suggestionRequestRef=useRef(0);
  const fetchSuggestionsRef=useRef(null);
  const searchInputRef=useRef(null);
    const [showSearchSuggest,setShowSearchSuggest]=useState(()=>localStorage.getItem('qomo_show_suggest')!=='0');
  const [searchRefresh,setSearchRefresh]=useState(()=>localStorage.getItem('qomo_search_refresh')==='1');
  const [compactSuggestions,setCompactSuggestions]=useState(()=>localStorage.getItem('qomo_compact_suggestions')==='1');

  /* ---- 液态玻璃 · 真折射：挂载与尺寸维护 ----
     只在「桌面 Chromium + 焕新视觉开启」时把 body.lg-glass 打开，
     其余情况一个字都不改，原有的磨砂玻璃照旧。
     注意：effect 首次执行时应用可能还在 loading 态、搜索框尚未进 DOM，
     所以不能在这里一次性判定失败 —— 用 MutationObserver 等到 DOM 就位再建。 */
  useLayoutEffect(()=>{
    const off=()=>document.body.classList.remove('lg-glass');
    if(!LG_OK||!searchRefresh){off();return;}
    let dead=false,built=false,mo=null,timer=0,rt=0,rtb=0,ro=null;

    /* 顶栏两个玻璃面：圆角从计算样式读，CSS 一改这里就跟着变 */
    const topbarMeasurements=new WeakMap(),topbarChanged=new Set();
    const radiusFor=el=>{
      const w=el.offsetWidth,h=el.offsetHeight,old=topbarMeasurements.get(el);
      if(old&&old.w===w&&old.h===h)return old;
      const style=getComputedStyle(el);
      const value={w,h,r:Math.min(parseFloat(style.borderTopLeftRadius)||0,w/2,h/2),cornerShape:style.cornerShape==='superellipse(1.25)'?'continuous':style.cornerShape==='superellipse(2)'?'squircle':null};
      topbarMeasurements.set(el,value);return value;
    };
    const syncTopbar=changed=>{
      const ib=document.querySelector('.top-bar .icon-btn');
      if(ib&&(!changed||changed.has(ib))){
        const {w,h,r,cornerShape}=radiusFor(ib);
        lgMountIcon(w,h,r,cornerShape);
      }
      const wx=document.querySelector('.weather-widget');
      if(wx&&(!changed||changed.has(wx))){
        const {w,h,r,cornerShape}=radiusFor(wx);
        lgMountWeather(w,h,r,cornerShape);
      }
      /* 快捷栏图标（有快捷方式时才有 .shortcut-icon-wrap，空快捷栏时退回"添加"方块） */
      const si=document.querySelector('.shortcut-icon-wrap')||document.querySelector('.add-shortcut-icon');
      if(si&&(!changed||changed.has(si))){
        const {w,h,r,cornerShape}=radiusFor(si);
        lgMountShortcut(w,h,r,cornerShape);
      }
    };

    const build=()=>{
      if(dead||built)return;
      const container=document.querySelector('.search-bar-container');
      const bar=document.querySelector('.search-bar');
      if(!container||!bar)return;                 // 还没渲染出来，交给 observer
      if(window.innerWidth<=600){if(ro)ro.disconnect();off();built=true;return;}
      const badge=document.querySelector('.search-engine-badge');
      const bs=badge&&badge.offsetWidth?badge.offsetWidth:64;
      if(!lgMountBar(container.offsetWidth||620,bar.offsetHeight||64))return;
      lgMountButtons(bs);
      if(!lgHandles.panel)lgMountPanel(607,300,28,getComputedStyle(document.documentElement).getPropertyValue('--q-corner').trim()==='superellipse(1.25)'?'continuous':null); // Live geometry replaces this placeholder before paint.

      /* 顶栏：左上「画报」图标按钮、右上「设置」图标按钮与天气胶囊 */
      syncTopbar();
      /* 设置面板：维护态先建兜底尺寸，面板打开后会再按实测校正 */
      if(!lgHandles.settings)lgSyncSettings(false);
      if(ro)ro.disconnect();
      if(!ro)ro=new ResizeObserver(entries=>{           // 天气数据到达会改变胶囊宽度 → 重建贴图
        cancelAnimationFrame(rtb);
        entries.forEach(entry=>topbarChanged.add(entry.target));
        rtb=requestAnimationFrame(()=>{if(!dead)syncTopbar(topbarChanged);topbarChanged.clear()});
      });
      const wxEl=document.querySelector('.weather-widget'); if(wxEl)ro.observe(wxEl);
      const ibEl=document.querySelector('.top-bar .icon-btn'); if(ibEl)ro.observe(ibEl);
      const siEl=document.querySelector('.shortcut-icon-wrap')||document.querySelector('.add-shortcut-icon'); if(siEl)ro.observe(siEl);

      const enabling=!document.body.classList.contains('lg-glass');
      document.body.classList.add('lg-glass');
      if(enabling&&document.querySelector('.settings-panel-v2'))lgSyncSettings(true);
      built=true;
      if(mo){mo.disconnect();mo=null;}
      clearTimeout(timer);
    };

    build();
    if(!built){
      mo=new MutationObserver(build);
      mo.observe(document.body,{childList:true,subtree:true});
      timer=setTimeout(()=>{if(mo){mo.disconnect();mo=null}},20000);   // 兜底：一直没就位就别再守着
    }

    /* 窗口变化：容器宽度决定贴图尺寸，必须重建（贴图是烘焙在具体尺寸上的） */
    const onResize=()=>{
      clearTimeout(rt);
      rt=setTimeout(()=>{
        if(dead)return;
        built=false;
        build();

      },180);
    };
    window.addEventListener('resize',onResize);
    return ()=>{
      dead=true;
      clearTimeout(rt);clearTimeout(timer);cancelAnimationFrame(rtb);
      if(mo)mo.disconnect();
      if(ro)ro.disconnect();
      window.removeEventListener('resize',onResize);
      off();
    };
  },[searchRefresh]);

  /* ---- 搜索框贴图切换：宽度过渡结束后才换成收缩尺寸的那张 ----
     中途换会在框体中间留下一条假倒角（贴图的倒角位置是烘焙死的）。
     全部挂在 document 上做委托 —— 这样不必关心搜索框何时渲染出来。 */
  useEffect(()=>{
    if(!LG_OK||!searchRefresh)return;
    let fallback=0;
    const bar=()=>document.querySelector('.search-bar');
    const focused=()=>!!document.querySelector('.app-container.search-focused');
    const settle=()=>{if(!focused())return;const b=bar();if(b)b.classList.add('lg-focus')};
    const onFocusIn=e=>{if(!e.target.closest('.search-bar'))return;clearTimeout(fallback);fallback=setTimeout(settle,700)};
    const onFocusOut=e=>{if(!e.target.closest('.search-bar'))return;clearTimeout(fallback);const b=bar();if(b)b.classList.remove('lg-focus')};
    /* transitionend 会为 width / box-shadow / border-radius 各触发一次，只认 width；
       blur 途中被取消的 transitioncancel 不是"落定"，靠 focused() 判断挡掉。 */
    const onEnd=e=>{
      if(e.propertyName!=='width')return;
      const b=bar();
      if(!b||e.target!==b)return;
      clearTimeout(fallback);
      settle();
    };
    document.addEventListener('transitionend',onEnd,true);
    document.addEventListener('transitioncancel',onEnd,true);
    document.addEventListener('focusin',onFocusIn,true);
    document.addEventListener('focusout',onFocusOut,true);
    return ()=>{
      clearTimeout(fallback);
      document.removeEventListener('transitionend',onEnd,true);
      document.removeEventListener('transitioncancel',onEnd,true);
      document.removeEventListener('focusin',onFocusIn,true);
      document.removeEventListener('focusout',onFocusOut,true);
      const b=bar();
      if(b)b.classList.remove('lg-focus');
    };
  },[searchRefresh]);

  /* ---- 面板贴图尺寸跟随内容：绘制前同步重建，避免第一帧看到错位的倒角 ---- */
  useLayoutEffect(()=>{
    if(!LG_OK||!searchRefresh)return;
    if(!showSuggestions)return;
    const p=document.querySelector('.search-suggestions');
    if(!p)return;
    const w=p.offsetWidth,h=p.offsetHeight;
    if(!w||!h)return;
    const style=getComputedStyle(p),r=parseFloat(style.borderTopLeftRadius)||28;
    lgMountPanel(w,h,r,style.cornerShape==='superellipse(1.25)'?'continuous':style.cornerShape==='superellipse(2)'?'squircle':null);
  },[searchRefresh,showSuggestions,searchQuery,searchHistory,searchSuggestions,compactSuggestions]);
  const [engineMenuOpen,setEngineMenuOpen]=useState(false);
  const [toastMsg,showToast]=useToast();
  const [loading,setLoading]=useState(true);
  const [dragIndex,setDragIndex]=useState(null);
  const [dropGroupId,setDropGroupId]=useState(null);
  const wasDragged=useRef(false);
  const [newShortcutId,setNewShortcutId]=useState(null);
  const [dockAlways,setDockAlways]=useState(()=>localStorage.getItem('qomo_dock_always')!=='0');
  const [dockTransparent,setDockTransparent]=useState(()=>localStorage.getItem('qomo_dock_transparent')!=='0');
  const [fontKey,setFontKey]=useState(()=>localStorage.getItem('qomo_font')||'goodfon');
  const [clockSize,setClockSize]=useState(()=>Number(localStorage.getItem('qomo_clock_size'))||110);
  const [clockWeight,setClockWeight]=useState(()=>Number(localStorage.getItem('qomo_clock_weight'))||500);
  const [clockX,setClockX]=useState(()=>Number(localStorage.getItem('qomo_clock_x'))||0);
  const [clockY,setClockY]=useState(()=>Number(localStorage.getItem('qomo_clock_y'))||0);
  const [clockColor,setClockColor]=useState(()=>localStorage.getItem('qomo_clock_color')||'default');
  const [clockSat,setClockSat]=useState(()=>Number(localStorage.getItem('qomo_clock_sat'))||100);
  const [clockOpacity,setClockOpacity]=useState(()=>Number(localStorage.getItem('qomo_clock_opacity'))||80);
  const [openGroup,setOpenGroup]=useState(null);
  const [groupPos,setGroupPos]=useState(null);
  const groupPosRef=useRef(null);
  const popDragIdRef=useRef(null);
  const popDragDoneRef=useRef(false);
  // 壁纸亮度采样（用于快捷方式文字黑白自适应）
  const wallCanvasRef=useRef(null);
  const nameElsRef=useRef(new Map());
  const topBarRef=useRef(null);

  // 将壁纸绘制到低分辨率 canvas 供采样（image 类型 / gradient 类型模拟）
  useEffect(()=>{
    wallCanvasRef.current=null;
    const wp=wallpaper;
    if(!wp)return;
    if(wp.type==='image'&&wp.value){
      const img=new Image();img.crossOrigin='anonymous';
      img.onload=()=>{
        try{
          // 缩略图按视口宽高比生成，保证与屏幕等比对应（否则采样位置会偏移）
          const c=document.createElement('canvas');
          c.width=128;c.height=Math.max(8,Math.round(128*(window.innerHeight||800)/(window.innerWidth||1280)));
          const ctx=c.getContext('2d');
          // 模拟 background-size:cover —— 等比缩放后居中裁剪
          const rz=Math.max(c.width/img.width,c.height/img.height);
          ctx.drawImage(img,(c.width-img.width*rz)/2,(c.height-img.height*rz)/2,img.width*rz,img.height*rz);
          wallCanvasRef.current={c,ctx};
        }catch(e){}
        applyNameColors();applySearchTextColors();applySuggestTextColors();
      };
      img.onerror=()=>{applyNameColors();applySearchTextColors();applySuggestTextColors()};
      img.src=wp.value;
      return()=>{img.onload=null;img.onerror=null};
    }else if(wp.type==='gradient'){
      try{
        const c=document.createElement('canvas');
        c.width=128;c.height=Math.max(8,Math.round(128*(window.innerHeight||800)/(window.innerWidth||1280)));
        const ctx=c.getContext('2d');
        const m=String(wp.value||'').match(/#[A-Fa-f0-9]{6}/g);
        const c1=m&&m[0]||'#d4c4a8',c2=m&&m[1]||'#c4a882';
        // 按 CSS 渐变角度复现真实方向（原先硬编码为垂直，与实际 135deg 等有偏差）
        const am=String(wp.value||'').match(/(-?[\d.]+)deg/);
        const rad=(am?Number(am[1]):180)*Math.PI/180, dx=Math.sin(rad), dy=-Math.cos(rad);
        const LL=Math.abs(c.width*dx)+Math.abs(c.height*dy);
        const g=ctx.createLinearGradient(c.width/2-dx*LL/2,c.height/2-dy*LL/2,c.width/2+dx*LL/2,c.height/2+dy*LL/2);
        g.addColorStop(0,c1);g.addColorStop(1,c2);
        ctx.fillStyle=g;ctx.fillRect(0,0,c.width,c.height);
        wallCanvasRef.current={c,ctx};
      }catch(e){}
      applyNameColors();
    }
  },[wallpaper]);

  // 根据文字所在位置的壁纸亮度切换文字颜色（偏白→深色文字，偏黑→浅色文字）
  const applyNameColors=useCallback(()=>{
    const wc=wallCanvasRef.current;
    const vw=window.innerWidth||1280,vh=window.innerHeight||800;
    nameElsRef.current.forEach(el=>{
      // 文件夹名称在展开行中下移（内联样式，绕开 CSS 缓存，保证生效）
      const isFolderInGroup=!!el.closest('.shortcuts-container.group-open .folder-item');
      el.style.marginTop=isFolderInGroup?'24px':(el.closest('.folder-item')?'7px':'');
      if(!wc){return}
      const r=el.getBoundingClientRect();
      if(r.width===0&&r.height===0)return;
      const x=Math.min(1,Math.max(0,(r.left+r.width/2)/vw));
      const y=Math.min(1,Math.max(0,(r.top+r.height/2)/vh));
      try{
        const d=wc.ctx.getImageData(Math.round(x*(wc.c.width-1)),Math.round(y*(wc.c.height-1)),1,1).data;
        const b=(d[0]+d[1]+d[2])/3;
        el.style.color=b>140?'rgba(20,18,14,0.92)':'rgba(245,240,232,0.96)';
      }catch(e){/* 跨域壁纸等无法采样时保持默认 */}
    });
    // 时钟颜色:默认(未自定义)时按背景亮度自适应,暗背景→米白,亮背景→墨黑
    if((localStorage.getItem('qomo_clock_color')||'default')==='default'&&wc){
      const clk=document.querySelector('.greeting-time');
      if(clk){
        const r=clk.getBoundingClientRect();
        if(r.width>0&&r.height>0){
          try{
            const x=Math.min(1,Math.max(0,(r.left+r.width/2)/vw));
            const y=Math.min(1,Math.max(0,(r.top+r.height/2)/vh));
            const d=wc.ctx.getImageData(Math.round(x*(wc.c.width-1)),Math.round(y*(wc.c.height-1)),1,1).data;
            const b=(d[0]+d[1]+d[2])/3;
            document.documentElement.style.setProperty('--clock-color',b>140?'#1a1a1a':'#f0ebe3');
          }catch(e){}
        }
      }
    }
    // 右上角：天气 + 设置按钮，同样按背景亮度切换颜色
    const tb=topBarRef.current;
    if(tb){
      tb.querySelectorAll('.weather-widget,.icon-btn,.ai-entry').forEach(el=>{
        const r=el.getBoundingClientRect();
        if(r.width===0&&r.height===0)return;
        const x=Math.min(1,Math.max(0,(r.left+r.width/2)/vw));
        const y=Math.min(1,Math.max(0,(r.top+r.height/2)/vh));
        let c='rgba(245,240,232,0.96)';
        if(wc){
          try{
            const d=wc.ctx.getImageData(Math.round(x*(wc.c.width-1)),Math.round(y*(wc.c.height-1)),1,1).data;
            const b=(d[0]+d[1]+d[2])/3;
            c=b>140?'rgba(20,18,14,0.92)':'rgba(245,240,232,0.96)';
          }catch(e){}
        }
        el.style.color=c;
        if(el.classList.contains('weather-widget')){
          el.querySelectorAll('.weather-temp,.weather-detail,.weather-error-text').forEach(x=>{x.style.color=c});
        }
      });
    }
  },[]);

                    const QCLAMP=v=>v<0?0:v>255?255:v;
  const QPARSE=s=>{s=String(s).trim();
    const m=s.match(/rgba?\(([^)]+)\)/);
    if(m){const p=m[1].split(/[,/\s]+/).filter(Boolean).map(Number);return{r:p[0],g:p[1],b:p[2],a:p.length>3?p[3]:1}}
    const h=s.replace('#','');
    if(/^[0-9a-f]{3}$/i.test(h)||/^[0-9a-f]{6}$/i.test(h)){const x=h.length===3?h[0]+h[0]+h[1]+h[1]+h[2]+h[2]:h;
      return{r:parseInt(x.slice(0,2),16),g:parseInt(x.slice(2,4),16),b:parseInt(x.slice(4,6),16),a:1}}
    return{r:0,g:0,b:0,a:1}};
  const QBRIGHT=f=>{const m=String(f||'').match(/brightness\(\s*([\d.]+)\s*\)/);return m?Number(m[1]):1};
  const QLIN=c=>{c=c/255;return c<=.04045?c/12.92:Math.pow((c+.055)/1.055,2.4)};
  const QLUM=(r,g,b)=>.2126*QLIN(r)+.7152*QLIN(g)+.0722*QLIN(b);
  const QRATIO=(a,b)=>{const x=a>b?a:b,y=a>b?b:a;return (x+.05)/(y+.05)};

  // ══════ 搜索框文字可读性：按背景实测亮度求解文字色 ══════
  // 实际可见背景 = 壁纸像素 ──brightness滤镜──▶ ──与玻璃底色 alpha 合成──▶ 结果
  // 可读性由区域内「最不利的那个亮度」决定，故以亮度极值为约束；
  // 再用 WCAG 对比度反解一个恰好达标、且尽量贴近原设计色的颜色。
  /* ============================================================
     文字可读性自适应：可复用的三段
       QPIPE  —— 单点合成（壁纸采样值 → 真实管线亮度）
       QSAMPLE—— 把一个屏幕矩形映射到壁纸缩略图，统计亮度极值
       QSOLVE —— 由亮度区间反解「恰好达标且改动最小」的文字色
     搜索框（占位文字 / 输入文字）与候选词面板共用这三段，保证同一套算法、同一套手感。
     ============================================================ */

  /* 像素级合成模型：壁纸层 filter → backdrop-filter(saturate → brightness) → 与玻璃底色按 alpha 合成
     d 为 ImageData.data，q 为像素起始下标；k = 1 - 玻璃底色 alpha */
  function QPIPE(d,q,bright,bsat,bbri,glass,k){
    let wr=QCLAMP(d[q]*bright), wg=QCLAMP(d[q+1]*bright), wb=QCLAMP(d[q+2]*bright);
    if(bsat!==1){
      const r2=(0.213+0.787*bsat)*wr+(0.715-0.715*bsat)*wg+(0.072-0.072*bsat)*wb;
      const g2=(0.213-0.213*bsat)*wr+(0.715+0.285*bsat)*wg+(0.072-0.072*bsat)*wb;
      const b2=(0.213-0.213*bsat)*wr+(0.715-0.715*bsat)*wg+(0.072+0.928*bsat)*wb;
      wr=QCLAMP(r2); wg=QCLAMP(g2); wb=QCLAMP(b2);
    }
    return QLUM(QCLAMP(wr*bbri)*k+glass.r*glass.a,
                QCLAMP(wg*bbri)*k+glass.g*glass.a,
                QCLAMP(wb*bbri)*k+glass.b*glass.a);
  }

  /* 采样：rect 为屏幕坐标（已扣掉 padding），splitX 传入时额外统计 left→splitX 这一段
     返回 {has, mn, mx, smn, smx}；未传 splitX 时 s* 与 mn/mx 相同 */
  function QSAMPLE(opt){
    const wcv=opt.wcv;
    if(!wcv)return {has:0,mn:1,mx:0,smn:1,smx:0};
    const R=opt.rect, glass=opt.glass, bright=opt.bright, bsat=opt.bsat, bbri=opt.bbri;
    const cw=wcv.c.width, ch=wcv.c.height, vw=opt.vw||1280, vh=opt.vh||800;
    const x0=Math.max(0,Math.floor(R.left/vw*cw)), y0=Math.max(0,Math.floor(R.top/vh*ch));
    const x1=Math.min(cw,Math.ceil(R.right/vw*cw)), y1=Math.min(ch,Math.ceil(R.bottom/vh*ch));
    const splitX=opt.splitX;
    const sX1=(splitX==null)?null:Math.max(x0+1,Math.min(x1,Math.ceil(splitX/vw*cw)));
    const w=x1-x0, h=y1-y0;
    if(w<=0||h<=0)return {has:0,mn:1,mx:0,smn:1,smx:0,bins:null,cnt:0};
    const st=Math.max(1,Math.ceil(Math.sqrt(w*h/900)));
    let smp=wcv.ctx;
    if(opt.brad>0.5){
      try{
        const tc=document.createElement('canvas'); tc.width=cw; tc.height=ch;
        const tx=tc.getContext('2d'); tx.filter='blur('+opt.brad+'px)'; tx.drawImage(wcv.c,0,0);
        smp=tx;
      }catch(e){}
    }
    let has=0,mn=1,mx=0,smn=1,smx=0;
    // 同时统计中位亮度（16 格直方图）：区域"整体偏亮还是偏暗"决定文字优先往哪边取。
    // 只看 mn/mx 会被极值带偏 —— 面板很透明时整块背景可能横跨亮暗两侧，
    // 区间太宽会让"两侧都不达标"，最后只能按端点比值随机倒向一边（实测踩过）。
    const NB2=32;
    const hist=new Array(NB2).fill(0);
    let cnt=0;
    try{
      const d=smp.getImageData(x0,y0,w,h).data, k=1-glass.a;
      for(let y=0;y<h;y+=st)for(let x=0;x<w;x+=st){
        const L=QPIPE(d,(y*w+x)*4,bright,bsat,bbri,glass,k);
        if(L<mn)mn=L; if(L>mx)mx=L; has=1; cnt++;
        hist[Math.min(NB2-1,Math.max(0,L*NB2|0))]++;
        if(sX1!=null&&x0+x<sX1){ if(L<smn)smn=L; if(L>smx)smx=L; }
      }
    }catch(e){ return {has:0,mn:1,mx:0,md:.5,smn:1,smx:0,bins:null,cnt:0}; }   // 跨域壁纸等无法采样 → 保持主题原色
    let acc=0,md=.5;
    for(let i=0;i<NB2;i++){ acc+=hist[i]; if(acc>=cnt/2){ md=(i+.5)/NB2; break; } }
    return {has,mn,mx,md,smn,smx,bins:hist,cnt};
  }

  /* 求最优文字色：优先保留设计色，不足则双向插值取「恰好达标且改动最小」者。
     安全边际按玻璃是否带高光渐变区分（合成模型没建模 background-image 渐变）。 */
  /* side: 1=优先浅色、0=优先深色、null=按设计色所在侧（搜索框传 null，行为与重构前一致） */
  function QSOLVE(base,mn,mx,hasBI,side){
    const TGT=4.55;
    mn=Math.max(0,mn*(hasBI?0.68:0.90)-(hasBI?0.01:0.006));
    mx=Math.min(1,mx*(hasBI?1.32:1.10)+(hasBI?0.01:0.006));
    const score=rgb=>{const L=QLUM(rgb[0],rgb[1],rgb[2]);
      if(L>=mn&&L<=mx)return 1;
      return Math.min(QRATIO(L,mn),QRATIO(L,mx));};
    if(score(base)>=TGT)return{color:base,glow:0};
    const bl=QLUM(base[0],base[1],base[2]), mid=(mn+mx)/2;
    const near=(side==null)?(bl>=mid?[255,255,255]:[0,0,0]):(side?[255,255,255]:[0,0,0]);
    const far=near[0]?[0,0,0]:[255,255,255];
    const dir=ext=>{
      const at=t=>[0,1,2].map(i=>Math.round(base[i]+(ext[i]-base[i])*t));
      if(score(at(1))<TGT)return{ok:0,t:1,ratio:score(at(1)),color:at(1)};
      let lo=0,hi=1;
      for(let i=0;i<20;i++){const m=(lo+hi)/2; if(score(at(m))>=TGT)hi=m; else lo=m}
      let c=at(hi);
      for(let g=0;g<24&&score(c)<TGT;g++){hi=Math.min(1,hi+0.02); c=at(hi);}
      const rr=score(c);
      return{ok:rr>=TGT?1:0,t:hi,ratio:rr,color:c};
    };
    const A=dir(near),B=dir(far);
    let pick;
    if(A.ok&&B.ok)pick=A.t<=B.t?A:B;
    else if(A.ok)pick=A;
    else if(B.ok)pick=B;
    // 两侧都不可达：搜索框（side=null）沿用原来的端点比值取优；指定了 side 时按区域
    // 整体明暗倾向取 —— 背景横跨亮暗两侧时，端点比值会挑到"只有少数像素好看"的那侧
    else pick=(side==null)?(A.ratio>=B.ratio?A:B):A;
    return{color:pick.color,glow:pick.ok?0:1};
  }
  /* 极端亮度跨度下无解时用细描边兜底（取与文字相反的一侧） */
  function QGLOWC(c){ return QLUM(c[0],c[1],c[2])>.5?'rgba(0,0,0,.55)':'rgba(255,255,255,.85)'; }
  function QRGB(c){ return [c.r,c.g,c.b]; }
  function QHEX(c){ return '#'+c.map(v=>QCLAMP(Math.round(v)).toString(16).padStart(2,'0')).join(''); }

  const applySearchTextColors=useCallback(()=>{
    const inp=document.querySelector('.search-input');
    if(!inp)return;
    const bar=inp.closest('.search-bar')||inp;
    const csm=getComputedStyle(inp);
    const barStyle=getComputedStyle(bar);
    const glass=QPARSE(barStyle.backgroundColor);
    const wlay=document.querySelector('.wallpaper-layer');
    const bright=wlay?QBRIGHT(getComputedStyle(wlay).filter):1;
    // 玻璃自身的 backdrop-filter 也要算：saturate/brightness 作用在被采样的背景上
    const bfd=barStyle.backdropFilter||barStyle.webkitBackdropFilter||'';
    const bsM=bfd.match(/saturate\(\s*([\d.]+)\s*\)/), bbM=bfd.match(/brightness\(\s*([\d.]+)\s*\)/);
    const bsat=bsM?Number(bsM[1]):1, bbri=bbM?Number(bbM[1]):1;
    // 焕新玻璃另有一层 background-image 高光渐变会再提亮背景，而合成模型只算了
    // background-color；逐像素建模 CSS 渐变不现实，故对这类玻璃用更大的安全边际
    const hasBI=(barStyle.backgroundImage||'none')!=='none';
    const R=inp.getBoundingClientRect();
    if(!R.width||!R.height)return;

    const wcv=wallCanvasRef.current;
    // 场景键：位置 / 玻璃材质 / 壁纸滤镜任一变化都要重算。
    // 壁纸换图时会新建 canvas，所以额外比对 canvas 引用（否则换了壁纸却因键相同而跳过）
    const ck=R.left+'|'+R.top+'|'+R.width+'|'+glass.r+','+glass.g+','+glass.b+','+glass.a+'|'+bright+'|'+bfd+'|'+(hasBI?1:0);
    if(inp.__qck===ck&&inp.__qcw===wcv)return;
    inp.__qck=ck;
    inp.__qcw=wcv;

    const padL=parseFloat(csm.paddingLeft)||0, padR=parseFloat(csm.paddingRight)||0;
    const vw=window.innerWidth||1280, vh=window.innerHeight||800;
    // backdrop 的 blur 半径换算到 canvas 像素：模糊会把输入框之外的背景也混进来
    const blM=bfd.match(/blur\(\s*([\d.]+)px\s*\)/);
    const brad=(wcv&&blM)?Math.min(40,Number(blM[1])*wcv.c.width/vw):0;
    // 输入文字可能铺满内容区；placeholder 只占左侧一段，按实测文字宽度单独圈定
    let tw=0;
    try{
      wcv.ctx.font=(csm.fontStyle||'normal')+' '+(csm.fontWeight||'400')+' '+csm.fontSize+' '+csm.fontFamily;
      tw=wcv.ctx.measureText(inp.placeholder||'').width;
    }catch(e){}
    const innerW=Math.max(1,R.width-padL-padR);
    const phW=tw>0?Math.min(innerW,tw):innerW;    // 量不出文字宽度则退回整个内容区

    const smp=QSAMPLE({wcv,rect:{left:R.left+padL,right:R.right-padR,top:R.top,bottom:R.bottom},
      glass,bright,bsat,bbri,brad,vw,vh,splitX:R.left+padL+phW});
    if(!smp.has)return;
    let fgMn=smp.mn,fgMx=smp.mx,phMn=smp.smn,phMx=smp.smx;
    if(phMx<phMn){phMn=fgMn;phMx=fgMx}   // placeholder 区未采到则退回内容区

    const rc=getComputedStyle(document.documentElement);
    const fg=QSOLVE(QRGB(QPARSE(rc.getPropertyValue('--text-primary'))),fgMn,fgMx,hasBI);
    const ph=QSOLVE(QRGB(QPARSE(rc.getPropertyValue('--text-muted'))),phMn,phMx,hasBI);
    const fh=QHEX(fg.color), phh=QHEX(ph.color);
    const rs=document.documentElement.style;
    if(rs.getPropertyValue('--search-fg').trim()===fh&&rs.getPropertyValue('--search-ph').trim()===phh)return;
    rs.setProperty('--search-fg',fh);
    rs.setProperty('--search-ph',phh);
    // 不加描边光晕：深色字旁边那圈白雾就是「发虚」的来源（与候选词面板同一条规则）
    rs.setProperty('--search-fg-glow','none');
    rs.setProperty('--search-ph-glow','none');
  },[]);

  /* ---- 候选词 / 历史词条的文字色：与搜索框【同一套】采样与求解 ----
     词条原本写死 --text-primary，但焕新模式下面板的色调层只有 5.5% 白（几乎全透明），
     浅色文字压在照片壁纸的亮部就看不清了。这里把面板当成第二块玻璃量一遍：
     玻璃底色取材质层 ::before 的 background-color，它带高光渐变 → hasBI 走大安全边际。 */
  /* ---- 候选词 / 历史词条的文字色：与搜索框【同一套】采样与求解，逐条应用 ----
     词条原本写死 --text-primary，但焕新模式下面板的色调层只有 5.5% 白（几乎全透明），
     浅色文字压在照片壁纸的亮部就看不清了。
     关键取舍：**不能拿整块面板去取亮度极值**。面板背后照片的亮度跨度可能横跨亮暗两侧，
     区间太宽会让求解器"两侧都不达标"，最后按端点比值随机倒向一边
     （实测就是这样倒向了深色，而文字其实压在照片暗部，对比度只剩 1.82）。
     所以按每条词条各自的背景带求解：亮带用深字、暗带用浅字 —— 这才是这套算法的正确用法，
     也与项目里"快捷方式名称自适应"那套一致。 */
  const applySuggestTextColors=useCallback(()=>{
    const panel=document.querySelector('.search-suggestions');
    if(!panel)return;
    const list=panel.querySelectorAll('.suggestion-item, .history-clear-row');
    if(!list.length)return;
    const R=panel.getBoundingClientRect();
    if(!R.width||!R.height)return;
    const cs=getComputedStyle(panel);
    const bcs=getComputedStyle(panel,'::before');
    const glass=QPARSE(bcs.backgroundColor);
    const hasBI=(bcs.backgroundImage||'none')!=='none';
    const wlay=document.querySelector('.wallpaper-layer');
    const bright=wlay?QBRIGHT(getComputedStyle(wlay).filter):1;
    const bfd=cs.backdropFilter||cs.webkitBackdropFilter||'';
    const bsM=bfd.match(/saturate\(\s*([\d.]+)\s*\)/), bbM=bfd.match(/brightness\(\s*([\d.]+)\s*\)/);
    const bsat=bsM?Number(bsM[1]):1, bbri=bbM?Number(bbM[1]):1;
    const wcv=wallCanvasRef.current;
    const ck='sug2|'+Math.round(R.width)+'x'+Math.round(R.height)+'|'+list.length+'|'+
             (list[0].textContent||'').slice(0,16)+'|'+glass.r+','+glass.g+','+glass.b+','+glass.a+'|'+
             bright+'|'+bfd+'|'+(hasBI?1:0);
    if(panel.__qck===ck&&panel.__qcw===wcv)return;
    panel.__qck=ck; panel.__qcw=wcv;

    const vw=window.innerWidth||1280, vh=window.innerHeight||800;
    const blM=bfd.match(/blur\(\s*([\d.]+)px\s*\)/);
    const brad=(wcv&&blM)?Math.min(40,Number(blM[1])*wcv.c.width/vw):0;

    /* ---- 1) 逐条采样，但只汇总成【整块一份】亮度分布 ----
       ★ 核心取舍：**整块只用一种文字色**。
       逐条各自求解会让同一个面板出现「上面白字、下面黑字」（壁纸明暗跨度一大就必然发生），
       同一个面板里的正文出现两种颜色，看起来就是坏的。
       所以逐条采样只用来「测清楚这块玻璃背后的明暗分布」，求解只做一次，
       结果写到面板元素本身，由 .suggestion-item 继承（不再逐条写行内变量）。 */
    const NB=32, pool=new Array(NB).fill(0); let tot=0;
    list.forEach(el=>{
      // 清掉可能残留的逐条行内值：颜色只允许由「面板」这一处决定
      el.style.removeProperty('--sug-fg'); el.style.removeProperty('--sug-muted');
      el.style.removeProperty('--sug-fg-glow'); el.style.removeProperty('--sug-muted-glow');
      const r=el.getBoundingClientRect();
      if(!r.width||!r.height)return;
      const smp=QSAMPLE({wcv,rect:{left:r.left+7,right:r.right-7,top:r.top+2,bottom:r.bottom-2},
        glass,bright,bsat,bbri,brad,vw,vh});
      if(!smp.has||!smp.bins)return;
      for(let k=0;k<NB;k++)pool[k]+=smp.bins[k];
      tot+=smp.cnt;
    });
    if(!tot)return;

    /* ---- 2) 用稳健分位带求解，而不是真实极值 ----
       面板背后可能有一小撮极亮/极暗的像素（高光、阴影），用极值会把区间拉到两端，
       于是「深字、浅字都不达标」，求解器只能凭端点比值乱猜（实测就猜反过）。
       取 p8~p92：这一色保证在**九成面积**上达标，剩下一成兜不住 —— 这是刻意的取舍：
       宁可边缘少数几条略淡，也不要同一块里出现两种颜色的正文。
       （极端壁纸想要 100% 达标只能加底色，那会把折射洗掉，不做。） */
    const q=p=>{let acc=0;for(let k=0;k<NB;k++){acc+=pool[k];if(acc>=tot*p)return (k+.5)/NB}return 1};
    const md=q(0.5), side=md>=0.179?0:1;   // 0.179 = WCAG 黑/白对比度交叉点（见搜索框那段）
    let mn=q(0.08), mx=q(0.92);
    if(mx<=mn){mn=Math.max(0,md-0.05);mx=Math.min(1,md+0.05)}   // 纯色/均匀壁纸兜底
    const rc=getComputedStyle(document.documentElement);
    const fg=QSOLVE(QRGB(QPARSE(rc.getPropertyValue('--text-primary'))),mn,mx,hasBI,side);
    const mu=QSOLVE(QRGB(QPARSE(rc.getPropertyValue('--text-muted'))),mn,mx,hasBI,side);
    panel.style.setProperty('--sug-fg',QHEX(fg.color));
    panel.style.setProperty('--sug-muted',QHEX(mu.color));
    /* 不给文字加描边光晕：0 0 2px 的那种「光晕」落在深色字周围就是一圈白雾，
       肉眼看到的是「字发虚」—— 比对比度略低更难受。对比度不够就让颜色更极端一点。 */
    panel.style.setProperty('--sug-fg-glow','none');
    panel.style.setProperty('--sug-muted-glow','none');
  },[]);
  // 文本自适应按实际场景变化触发，输入搜索词时不再重采样整页快捷方式和时钟。
  useEffect(()=>{applyNameColors()},[
    loading,wallpaper,shortcuts,openGroup,dockAlways,dockExpanded,dockAlwaysExpanded,dockTransparent,
    dragIndex,dropGroupId,newShortcutId,showSettings,showNewspaper,searchRefresh,compactSuggestions,
    fontKey,clockSize,clockWeight,clockX,clockY,clockColor,clockSat,clockOpacity,applyNameColors
  ]);
  useEffect(()=>{applySearchTextColors()},[
    loading,wallpaper,searchRefresh,compactSuggestions,showSuggestions,suggestionsClosing,
    showSettings,showNewspaper,engineMenuOpen,searchQuery,applySearchTextColors
  ]);
  useEffect(()=>{applySuggestTextColors()},[
    loading,wallpaper,searchRefresh,compactSuggestions,searchSuggestions,showSuggestions,suggestionsClosing,
    searchHistory,showSearchHistory,showSearchSuggest,showSettings,showNewspaper,applySuggestTextColors
  ]);
  useEffect(()=>{
    let frame=0;
    const schedule=()=>{
      if(frame)return;
      frame=requestAnimationFrame(()=>{
        frame=0;applyNameColors();applySearchTextColors();applySuggestTextColors();
      });
    };
    const onTransition=e=>{
      if(e.target.matches?.('.search-bar,.search-suggestions,.wallpaper-layer,.shortcuts-dock-wrapper,.shortcuts-container,.shortcut-item,.greeting,.greeting-time,.search-wrapper,.search-bar-container'))schedule();
    };
    window.addEventListener('resize',schedule);
    document.addEventListener('transitionend',onTransition);
    document.addEventListener('animationend',onTransition);
    document.fonts?.addEventListener('loadingdone',schedule);
    return()=>{
      cancelAnimationFrame(frame);window.removeEventListener('resize',schedule);
      document.removeEventListener('transitionend',onTransition);
      document.removeEventListener('animationend',onTransition);
      document.fonts?.removeEventListener('loadingdone',schedule);
    };
  },[applyNameColors,applySearchTextColors,applySuggestTextColors]);

  // Translate state
  const [targetLang,setTargetLang]=useState(()=>localStorage.getItem('qomo_target_lang')||'en');
  const [isTranslated,setIsTranslated]=useState(false);
  const [translating,setTranslating]=useState(false);
  const originalQueryRef=useRef('');

  // ============ 翻译功能：仅翻译搜索框文字 ============
  const doTranslate=useCallback(async()=>{
    const text=searchQuery.trim();
    if(!text)return;
    setTranslating(true);
    try{
      const res=await fetch(`${API_BASE}/translate`,{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({texts:[text],targetLang})
      });
      if(!res.ok){
        const errText=await res.text();
        throw new Error(`服务器错误 ${res.status}: ${errText.slice(0,80)}`);
      }
      const data=await res.json();
      if(data.error)throw new Error(data.error);
      const translated=data.translations?.[0];
      if(translated&&translated!==text){
        originalQueryRef.current=searchQuery; // 保留原始输入（含前后空格）
        setSearchQuery(translated);
        setIsTranslated(true);
        setSuggestIndex(-1);
        setShowSuggestions(false);
        requestAnimationFrame(()=>fetchSuggestionsRef.current?.(translated));
        showToast(`已翻译为${targetLang==='ja'?'日语':'英语'}`);
      }else{
        showToast('翻译结果无变化');
      }
    }catch(e){
      console.error('[翻译] 失败:',e);
      showToast('翻译失败: '+e.message);
    }
    setTranslating(false);
  },[searchQuery,targetLang]);

  const doRevert=useCallback(()=>{
    const original=originalQueryRef.current;
    if(!original)return;
    setSearchQuery(original);
    originalQueryRef.current='';
    setIsTranslated(false);
    showToast('已恢复原文');
  },[]);

  const toggleTranslate=useCallback(()=>{
    if(translating)return;
    if(isTranslated){
      doRevert();
    }else{
      doTranslate();
    }
  },[isTranslated,translating,doTranslate,doRevert]);

  const handleTargetLangChange=useCallback((lang)=>{
    if(isTranslated){doRevert()}
    setTargetLang(lang);
    localStorage.setItem('qomo_target_lang',lang);
  },[isTranslated,doRevert]);

  // 壁纸柔和替换：触发淡入动画后再更新
  const applyWallpaperFade=wp=>{
    const layer=document.querySelector('.wallpaper-layer');
    if(layer){layer.classList.remove('wallpaper-fade');void layer.offsetWidth;layer.classList.add('wallpaper-fade')}
    setWallpaper(wp);
  };

  // 从缓存显示 Bing 图（objectURL），无缓存返回 false
  const applyBingCache=async()=>{
    try{
      const cached=await idbGet('daily');
      if(cached&&cached.blob){
        applyWallpaperFade({id:'bing_default',type:'image',value:URL.createObjectURL(cached.blob)});
        return true;
      }
    }catch(e){}
    return false;
  };

  // 下载当日 Bing 图并写入缓存，柔和替换
  const fetchAndCacheBing=async()=>{
    const res=await fetch(API_BASE+'/bing-wallpaper');
    const data=await res.json();
    if(!data.url)throw new Error('无图片地址');
    // 通过同源代理下载图片（避免跨域限制），转 Blob 缓存
    const imgRes=await fetch(API_BASE+'/bing-wallpaper/image');
    const imgData=await imgRes.json();
    if(!imgData.ok||!imgData.data)throw new Error('图片下载失败');
    const blob=await (await fetch(imgData.data)).blob();
    await idbSet('daily',{date:todayStr(),url:data.url,blob});
    applyWallpaperFade({id:'bing_default',type:'image',value:URL.createObjectURL(blob)});
    return data.url;
  };

  // Bing 每日壁纸:运行期间定时自动同步(每 30 分钟检查,缓存非当日则更新)
  useEffect(()=>{
    const syncTick=async()=>{
      try{
        const wp=JSON.parse(localStorage.getItem('qomo_wp')||'null');
        if(!wp||wp.id!=='bing_default')return;
        const cached=await idbGet('daily');
        if(cached&&cached.date===todayStr())return;
        await fetchAndCacheBing();
      }catch(e){/* 静默:有缓存则保持 */}
    };
    syncTick();
    const timer=setInterval(syncTick,1800000);
    return()=>clearInterval(timer);
  },[]);

  // 始终暗色模式
  useEffect(()=>{
    document.documentElement.setAttribute('data-theme','dark');
  },[]);

  // Load data on mount
  useEffect(()=>{
    async function init(){
      // Local settings
      const local=loadLocal();
      if(local.wp&&local.wp.id!=='bing_default')setWallpaper(local.wp);
      if(local.sc){
        const cleanSc=sanitizeShortcuts(local.sc);
        setShortcuts(cleanSc);
        if(JSON.stringify(cleanSc)!==JSON.stringify(local.sc)){
          saveLocal({wp:local.wp,sc:cleanSc,se:local.se,th:local.th});
        }
      }
      if(local.se)setSearchEngine(local.se);
      setLoading(false);

      // 应用已保存的时钟字体
      const savedFont=FONTS.find(f=>f.key===(localStorage.getItem('qomo_font')||'goodfon'));
      if(savedFont&&savedFont.family){
        document.documentElement.style.setProperty('--clock-font',savedFont.family+", 'Noto Serif SC', Georgia, serif");
      }
      // 应用已保存的时钟字号与位置微调
      const sz=Number(localStorage.getItem('qomo_clock_size'))||110;
      const wg=Number(localStorage.getItem('qomo_clock_weight'))||500;
      const cx=Number(localStorage.getItem('qomo_clock_x'))||0;
      const cy=Number(localStorage.getItem('qomo_clock_y'))||0;
      if(sz)document.documentElement.style.setProperty('--clock-size',sz+'px');
      if(wg!==500)document.documentElement.style.setProperty('--clock-weight',String(wg));
      if(cx)document.documentElement.style.setProperty('--clock-x',cx+'px');
      if(cy)document.documentElement.style.setProperty('--clock-y',cy+'px');
      // 应用已保存的时钟颜色
      const savedColor=CLOCK_COLORS.find(c=>c.key===(localStorage.getItem('qomo_clock_color')||'default'));
      if(savedColor&&savedColor.value)document.documentElement.style.setProperty('--clock-color',savedColor.value);
      // 应用已保存的时钟饱和度
      const sat=Number(localStorage.getItem('qomo_clock_sat'))||100;
      if(sat!==100)document.documentElement.style.setProperty('--clock-sat',String(sat/100));
      // 应用已保存的时钟透明度
      const opa=Number(localStorage.getItem('qomo_clock_opacity'))||80;
      if(opa!==100)document.documentElement.style.setProperty('--clock-opacity',String(opa/100));

      // Bing 壁纸：优先本地缓存秒开，后台下载当日图后柔和替换；每天仅首次打开时更新缓存
      const needBing=!local.wp||local.wp.id==='bing_default';
      if(needBing){
        // 1) 本地缓存立即显示（秒开，不等待网络）
        const cached=await idbGet('daily');
        if(cached&&cached.blob){
          setWallpaper({id:'bing_default',type:'image',value:URL.createObjectURL(cached.blob)});
        }else if(local.wp&&local.wp.value&&!String(local.wp.value).startsWith('blob:')){
          // 无缓存但有旧在线地址（升级场景兜底）
          setWallpaper(local.wp);
        }
        // 2) 需要下载：无缓存，或（同步开启 且 缓存不是今天）
        const shouldFetch=!cached||!cached.blob||cached.date!==todayStr();
        if(shouldFetch){
          try{
            const online=await fetchAndCacheBing();
            persistLocal({id:'bing_default',type:'image',value:online},local.sc,local.se||'baidu',local.th||'dark');
          }catch(e){/* 静默失败：有缓存则保持缓存图 */}
        }
      }
    }
    init();
  },[]);


  // Esc 关闭文件夹弹出层
  useEffect(()=>{
    const h=e=>{if(e.key==='Escape')setOpenGroup(null)};
    window.addEventListener('keydown',h);
    return()=>window.removeEventListener('keydown',h);
  },[]);

  // Persist helpers
  const persistLocal=useCallback((wp,sc,se,th)=>{
    saveLocal({wp,sc,se,th});
  },[]);

  // Handlers
  const handleWallpaperChange=wp=>{
    setWallpaper(wp);
    persistLocal(wp,shortcuts,searchEngine,'dark');
  };
  const handleSearchEngineChange=se=>{setSearchEngine(se);persistLocal(wallpaper,shortcuts,se,'dark');setEngineMenuOpen(false)};

  useEffect(()=>{
    if(!engineMenuOpen)return;
    const onPointerDown=e=>{if(!e.target.closest('.search-engine-picker'))setEngineMenuOpen(false)};
    const onKeyDown=e=>{if(e.key==='Escape')setEngineMenuOpen(false)};
    document.addEventListener('pointerdown',onPointerDown);
    document.addEventListener('keydown',onKeyDown);
    return()=>{document.removeEventListener('pointerdown',onPointerDown);document.removeEventListener('keydown',onKeyDown)};
  },[engineMenuOpen]);

  const handleAddShortcut=sc=>{
    const updated=[...shortcuts,sc];
    setShortcuts(updated);
    persistLocal(wallpaper,updated,searchEngine,'dark');
    setNewShortcutId(sc.id);
    setTimeout(()=>setNewShortcutId(null),3000);
    showToast(`已添加「${sc.name}」`);
  };

  const handleUpdateShortcut=(id,data)=>{
    const updated=shortcuts.map(s=>s.id===id?{...s,...data}:s);
    setShortcuts(updated);
    persistLocal(wallpaper,updated,searchEngine,'dark');
    showToast(`已更新「${data.name}」`);
  };

  const handleMoveShortcut=(id,dir)=>{
    const idx=shortcuts.findIndex(s=>s.id===id);
    const target=idx+dir;
    if(idx<0||target<0||target>=shortcuts.length)return;
    const updated=[...shortcuts];
    const [item]=updated.splice(idx,1);
    updated.splice(target,0,item);
    setShortcuts(updated);
    persistLocal(wallpaper,updated,searchEngine,'dark');
  };

  const handleDeleteShortcut=id=>{
    const sc=shortcuts.find(s=>s.id===id);
    const updated=shortcuts.filter(s=>s.id!==id);
    setShortcuts(updated);
    persistLocal(wallpaper,updated,searchEngine,'dark');
    if(sc)showToast(`已删除「${sc.name}」`);
  };

  // ============ 分组 ============
  const handleDockAlwaysChange=v=>{
    setDockAlways(v);
    localStorage.setItem('qomo_dock_always',v?'1':'0');
    showToast(v?'快捷方式将始终展示':'已恢复可折叠');
  };

  const handleAddGroup=name=>{
    const g={id:generateId(),name,type:'group'};
    const updated=[...shortcuts,g];
    setShortcuts(updated);
    persistLocal(wallpaper,updated,searchEngine,'dark');
    setNewShortcutId(g.id);
    setTimeout(()=>setNewShortcutId(null),3000);
    showToast(`已创建分组「${name}」`);
  };

  const handleRenameGroup=(id,name)=>{
    const updated=shortcuts.map(s=>s.id===id?{...s,name}:s);
    setShortcuts(updated);
    persistLocal(wallpaper,updated,searchEngine,'dark');
    showToast(`分组已改名为「${name}」`);
  };

  const handleDeleteGroup=id=>{
    const g=shortcuts.find(s=>s.id===id);
    const updated=shortcuts.map(s=>{
      if(s.id===id)return null;
      if(s.groupId===id)return {...s,groupId:''};
      return s;
    }).filter(Boolean);
    setShortcuts(updated);
    persistLocal(wallpaper,updated,searchEngine,'dark');
    setOpenGroup(null);
    if(g)showToast(`已删除分组「${g.name}」，成员已移出`);
  };

  const handleRemoveFromGroup=id=>{
    const updated=shortcuts.map(s=>s.id===id?{...s,groupId:''}:s);
    setShortcuts(updated);
    persistLocal(wallpaper,updated,searchEngine,'dark');
    showToast('已移出分组');
  };

  // 设置面板拖拽：快捷方式 → 分组
  const handleMoveToGroup=(id,gId)=>{
    const item=shortcuts.find(s=>s.id===id);
    const group=shortcuts.find(s=>s.id===gId);
    if(!item||!group||item.type==='group')return;
    const updated=shortcuts.map(s=>s.id===id?{...s,groupId:gId}:s);
    setShortcuts(updated);
    persistLocal(wallpaper,updated,searchEngine,'dark');
    showToast(`「${item.name}」已移入「${group.name}」`);
  };

  const handleDockTransparentChange=v=>{
    setDockTransparent(v);
    localStorage.setItem('qomo_dock_transparent',v?'1':'0');
    showToast(v?'已隐藏快捷方式底色':'已显示快捷方式底色');
  };

  const handleShowHistoryChange=v=>{
    setShowSearchHistory(v);
    localStorage.setItem('qomo_show_history',v?'1':'0');
  };
  const applySearchRefresh=on=>{
    const el=document.querySelector('.app-container');
    if(el){el.classList.toggle('search-refresh',!!on);}
  };
  const handleSearchRefreshChange=v=>{
    setSearchRefresh(v);
    applySearchRefresh(v);
    try{localStorage.setItem('qomo_search_refresh',v?'1':'0');}catch(e){}
    showToast(v?'已开启搜索焕新视觉':'已关闭搜索焕新视觉');
  };
  const handleShowSuggestChange=v=>{
    setShowSearchSuggest(v);
    localStorage.setItem('qomo_show_suggest',v?'1':'0');
    if(!v)setShowSuggestions(false);
    showToast(v?'已开启搜索推荐':'已关闭搜索推荐');
  };
  const handleCompactSuggestionsChange=v=>{
    setCompactSuggestions(v);
    localStorage.setItem('qomo_compact_suggestions',v?'1':'0');
  };

  // 时钟字体切换
  const handleFontChange=k=>{
    setFontKey(k);
    localStorage.setItem('qomo_font',k);
    const f=FONTS.find(x=>x.key===k);
    document.documentElement.style.setProperty('--clock-font',f&&f.family?f.family+", 'Noto Serif SC', Georgia, serif":'');
    showToast(f&&f.key!=='default'?`已应用字体「${f.name}」`:'已恢复默认字体');
  };

  // 时钟字号与位置微调（px）
  const setClockVar=(name,val)=>{
    if(val)document.documentElement.style.setProperty(name,val+'px');
    else document.documentElement.style.removeProperty(name);
  };
  const handleClockSizeChange=v=>{
    const n=Number(v)||0;
    setClockSize(n);
    if(n)localStorage.setItem('qomo_clock_size',String(n));else localStorage.removeItem('qomo_clock_size');
    setClockVar('--clock-size',n);
  };
  const handleClockWeightChange=v=>{
    const n=Number(v)||500;
    setClockWeight(n);
    if(n!==500)localStorage.setItem('qomo_clock_weight',String(n));else localStorage.removeItem('qomo_clock_weight');
    document.documentElement.style.setProperty('--clock-weight',String(n));
  };
  const handleClockXChange=v=>{
    const n=Number(v)||0;
    setClockX(n);
    if(n)localStorage.setItem('qomo_clock_x',String(n));else localStorage.removeItem('qomo_clock_x');
    setClockVar('--clock-x',n);
  };
  const handleClockYChange=v=>{
    const n=Number(v)||0;
    setClockY(n);
    if(n)localStorage.setItem('qomo_clock_y',String(n));else localStorage.removeItem('qomo_clock_y');
    setClockVar('--clock-y',n);
  };

  // 时钟颜色切换
  const handleClockColorChange=k=>{
    setClockColor(k);
    localStorage.setItem('qomo_clock_color',k);
    const c=CLOCK_COLORS.find(x=>x.key===k);
    if(c&&c.value)document.documentElement.style.setProperty('--clock-color',c.value);
    else document.documentElement.style.removeProperty('--clock-color');
    showToast(c&&c.key!=='default'?'已设置时钟颜色':'已恢复默认颜色');
  };

  // 时钟颜色饱和度（%）
  const handleClockSatChange=v=>{
    const n=Number(v)||100;
    setClockSat(n);
    if(n!==100)localStorage.setItem('qomo_clock_sat',String(n));else localStorage.removeItem('qomo_clock_sat');
    document.documentElement.style.setProperty('--clock-sat',String(n/100));
  };

  // 时钟颜色透明度（%）
  const handleClockOpacityChange=v=>{
    const n=Number(v)||100;
    setClockOpacity(n);
    if(n!==100)localStorage.setItem('qomo_clock_opacity',String(n));else localStorage.removeItem('qomo_clock_opacity');
    document.documentElement.style.setProperty('--clock-opacity',String(n/100));
  };

  // 点击文件夹：内联展开/收起（文件夹原位不动，成员在右侧展开）
  const toggleGroup=g=>{
    if(openGroup===g.id){setOpenGroup(null);return}
    const el=document.getElementById('folder-'+g.id);
    if(el){groupPosRef.current=el.getBoundingClientRect().left}
    setOpenGroup(g.id);
  };

  // 展开后校正：将展开行整体平移到文件夹原位（绘制前同步执行，避免滑动动画）
  useLayoutEffect(()=>{
    const cont=document.querySelector('.shortcuts-container.group-open');
    if(!cont){
      const c=document.querySelector('.shortcuts-container');
      if(c&&c.style.transform)c.style.transform='';
      return;
    }
    if(groupPosRef.current==null)return;
    const folder=cont.querySelector('.folder-item');
    if(!folder)return;
    const fr=folder.getBoundingClientRect();
    const delta=groupPosRef.current-fr.left;
    if(Math.abs(delta)>1)cont.style.transform=`translateX(${delta}px)`;
  },[openGroup,shortcuts]);

  // 快捷方式拖拽排序（dock 仅展示未分组项，组成员收纳在文件夹中）
  const handleDragStart=(e,i)=>{
    setDragIndex(i);
    wasDragged.current=false;
    e.dataTransfer.effectAllowed='move';
    e.dataTransfer.setData('text/plain','');
  };
  const handleDragOver=(e,i)=>{
    e.preventDefault();
    if(dragIndex===null||dragIndex===i)return;
    wasDragged.current=true;
    const dock=[...dockItems];
    const [item]=dock.splice(dragIndex,1);
    dock.splice(i,0,item);
    const members=shortcuts.filter(s=>s.groupId);
    setShortcuts([...dock,...members]);
    setDragIndex(i);
  };
  const handleDragEnd=()=>{
    if(wasDragged.current){
      persistLocal(wallpaper,shortcuts,searchEngine,'dark');
    }
    setDragIndex(null);
    setDropGroupId(null);
    setTimeout(()=>{wasDragged.current=false},0);
  };

  // 拖拽快捷方式到文件夹 → 合并进组
  const handleDropToGroup=(gId)=>{
    if(dragIndex===null)return;
    const dragged=dockItems[dragIndex];
    if(!dragged||dragged.type==='group')return;
    const group=shortcuts.find(s=>s.id===gId);
    const updated=shortcuts.map(s=>s.id===dragged.id?{...s,groupId:gId}:s);
    setShortcuts(updated);
    persistLocal(wallpaper,updated,searchEngine,'dark');
    setDragIndex(null);
    setDropGroupId(null);
    wasDragged.current=false;
    if(group){
      showToast(`「${dragged.name}」已移入「${group.name}」`);
      setOpenGroup(gId);
    }
  };

  // 搜索候选词（防抖 200ms）
  const fetchSuggestions=useCallback((query)=>{
    const requestId=++suggestionRequestRef.current;
    clearTimeout(suggestTimerRef.current);
    if(!query.trim()){
      setSearchSuggestions([]);
      setShowSuggestions(showSearchHistory&&searchHistory.length>0);
      return;
    }
    suggestTimerRef.current=setTimeout(async()=>{
      try{
        const res=await fetch(`${API_BASE}/suggest?q=${encodeURIComponent(query.trim())}`);
        const data=await res.json();
        if(requestId!==suggestionRequestRef.current)return;
        setSearchSuggestions(data.suggestions||[]);
        setShowSuggestions(showSearchSuggest&&(data.suggestions||[]).length>0);
        setSuggestIndex(-1);
      }catch(e){
        if(requestId!==suggestionRequestRef.current)return;
        setSearchSuggestions([]);
        setShowSuggestions(false);
      }
    },200);
  },[showSearchSuggest]);

  useEffect(()=>{fetchSuggestionsRef.current=fetchSuggestions;},[fetchSuggestions]);

  const handleSearchInputChange=e=>{
    // 如果当前是翻译状态，用户修改输入则自动回退
    if(isTranslated){
      originalQueryRef.current='';
      setIsTranslated(false);
    }
    const val=e.target.value;
    setSearchQuery(val);
    fetchSuggestions(val);
  };

  const addSearchHistory=q=>{
    if(!q||!q.trim())return;
    setSearchHistory(prev=>{
      const next=[q.trim(),...prev.filter(x=>x!==q.trim())].slice(0,8);
      localStorage.setItem('qomo_search_history',JSON.stringify(next));
      return next;
    });
  };
  const delSearchHistory=q=>{
    setSearchHistory(prev=>{
      const next=prev.filter(x=>x!==q);
      localStorage.setItem('qomo_search_history',JSON.stringify(next));
      return next;
    });
  };
  const clearSearchHistory=()=>{
    setSearchHistory([]);
    localStorage.removeItem('qomo_search_history');
    setShowSuggestions(false);
  };
  const suggestList=searchQuery.trim()?searchSuggestions:searchHistory;

  const handleSearchInputKeyDown=e=>{
    if(!showSuggestions||suggestList.length===0){
      if(e.key==='Enter')handleSearch(e);
      return;
    }
    if(e.key==='ArrowDown'){
      e.preventDefault();
      setSuggestIndex(prev=>prev<suggestList.length-1?prev+1:0);
    }else if(e.key==='ArrowUp'){
      e.preventDefault();
      setSuggestIndex(prev=>prev>0?prev-1:suggestList.length-1);
    }else if(e.key==='Enter'){
      if(suggestIndex>=0){
        e.preventDefault();
        const sel=suggestList[suggestIndex];
        setSearchQuery(sel);
        setShowSuggestions(false);
        addSearchHistory(sel);
        window.open((SEARCH_ENGINES[searchEngine]||SEARCH_ENGINES.baidu).url+encodeURIComponent(sel),'_blank');
      }else{
        handleSearch(e);
      }
    }else if(e.key==='Escape'){
      setShowSuggestions(false);
    }
  };

  const selectSuggestion=suggestion=>{
    setSearchQuery(suggestion);
    setShowSuggestions(false);
    addSearchHistory(suggestion);
    window.open((SEARCH_ENGINES[searchEngine]||SEARCH_ENGINES.baidu).url+encodeURIComponent(suggestion),'_blank');
  };

  const hideSuggestions=()=>{
    // 复用同一个定时器，连续聚焦/失焦不会堆积状态更新
    clearTimeout(suggestCloseTimerRef.current);
    setSuggestionsClosing(true);
    suggestCloseTimerRef.current=setTimeout(()=>{
      setShowSuggestions(false);
      setSuggestionsClosing(false);
      suggestCloseTimerRef.current=null;
    },180);
  };

  const handleSearch=e=>{
    e.preventDefault();
    if(searchQuery.trim()){
      addSearchHistory(searchQuery);
      const eng=SEARCH_ENGINES[searchEngine]||SEARCH_ENGINES.baidu;
      window.open(eng.url+encodeURIComponent(searchQuery.trim()),'_blank');
    }
  };

  const bgStyle=wallpaper?.type==='image'?{backgroundImage:`url(${wallpaper.value})`}:wallpaper?.value?{background:wallpaper.value}:{};

  const resolveIcon=sc=>sc.icon||getFaviconUrl(sc.url);

  // dock 只展示未分组的快捷方式 + 分组文件夹
  const dockItems=shortcuts.filter(s=>!s.groupId);

  if(loading)return(
    <div style={{height:'100%',display:'flex',alignItems:'center',justifyContent:'center',background:'var(--bg-primary)',color:'var(--text-muted)',fontSize:'16px'}}>
      <span className="loading-spinner" style={{width:'24px',height:'24px',marginRight:'10px'}}/>加载中...
    </div>
  );

  return(
    <div className={`app-container${searchRefresh?' search-refresh':''}`}>
      <div className="wallpaper-layer" style={bgStyle}/>
      <div className="wallpaper-overlay"/>

      <div className="content-layer">
        {/* Top bar */}
        <div className="top-bar" ref={topBarRef}>
          <button className="icon-btn" onClick={()=>setShowNewspaper(true)} title="全屏画报">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="19" height="19"><path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0V8"/><path d="M18 14h-8"/><path d="M15 18h-5"/><path d="M10 6h8v4h-8V6z"/></svg>
          </button>
          <div className="top-bar-right">
          <AISearchToggle onOpen={onOpenAI}/>
          <WeatherWidget onChange={applyNameColors}/>
          <button className="icon-btn" onClick={()=>{
            // 关闭动画中点击 = 取消关闭并重新打开，避免"点了没反应"
            if(showSettings&&!settingsClosing){
              setSettingsClosing(true);
              setTimeout(()=>{setShowSettings(false);setSettingsClosing(false)},380);
            }else{
              setSettingsClosing(false);
              setShowSettings(true);
            }
          }} title="设置">
            <Icons.Settings/>
          </button>
          </div>
        </div>

        {/* Main area */}
        <div className="main-area">
          <div className="greeting">
            <Clock onChange={applyNameColors}/>
          </div>

          <div className="search-wrapper">
            <div className={`search-bar-container${compactSuggestions?' compact-suggestions':''}`}>
              <div className={`search-bar${showSuggestions?' has-suggestions':''}${engineMenuOpen?' engine-menu-open':''}`}>
                <form onSubmit={handleSearch} style={{display:'flex',alignItems:'center',gap:'14px',flex:1}}>
                  <input className="search-input" type="text" placeholder="搜索互联网..."
                    ref={searchInputRef}
                    value={searchQuery} onChange={handleSearchInputChange}
                    onKeyDown={handleSearchInputKeyDown}
                    onPointerDown={e=>{const app=e.currentTarget.closest('.app-container');if(app&&!app.classList.contains('search-prepared')){app.classList.add('search-prepared');requestAnimationFrame(()=>app.classList.remove('search-prepared'))}}}
                    onFocus={e=>{e.currentTarget.closest('.app-container')?.classList.add('search-focused');setSuggestionsClosing(false);requestAnimationFrame(()=>{if(searchQuery.trim()){if(searchSuggestions.length>0&&showSearchSuggest)setShowSuggestions(true)}else if(showSearchHistory&&searchHistory.length>0){setSuggestIndex(-1);setShowSuggestions(true)}})}}
                    onBlur={e=>{e.currentTarget.closest('.app-container')?.classList.remove('search-focused','search-prepared');hideSuggestions()}}
                    enterKeyHint="search"
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"/>
                  <button type="button" className={`translate-btn${isTranslated?' active':''}${translating?' loading':''}`}
                    onMouseDown={e=>e.preventDefault()}
                    onClick={toggleTranslate}
                    title={isTranslated?'恢复原文':`翻译为${targetLang==='ja'?'日语':'英语'}`}
                    disabled={translating}>
                    {translating?<span className="loading-spinner" style={{width:'14px',height:'14px'}}/>:<img src="icons/translate.svg" alt="翻译"/>}
                  </button>
                  <div className={`search-engine-picker${engineMenuOpen?' open':''}`}>
                    <button type="button" className="search-engine-badge" onMouseDown={e=>e.preventDefault()} onClick={()=>setEngineMenuOpen(v=>!v)} aria-haspopup="menu" aria-expanded={engineMenuOpen} title="选择搜索引擎">
                      <img className="engine-logo" src={`icons/${searchEngine==='google'?'logo-google':searchEngine==='bing'?'bing':'百度'}.svg?v=120`} alt=""/>
                      <span className="engine-name">{SEARCH_ENGINES[searchEngine]?.name||'百度'}</span>
                    </button>
                    {engineMenuOpen&&<div className="search-engine-menu" role="menu">
                      {Object.entries(SEARCH_ENGINES).map(([key,eng])=><button key={key} type="button" className={`search-engine-option${searchEngine===key?' active':''}`} role="menuitem" onMouseDown={e=>e.preventDefault()} onClick={()=>handleSearchEngineChange(key)}>
                        <img src={`icons/${key==='google'?'logo-google':key==='bing'?'bing':'百度'}.svg?v=120`} alt=""/>
                        <span>{eng.name}</span>
                        {searchEngine===key&&<svg className="search-engine-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>}
                      </button>)}
                    </div>}
                  </div>
                </form>
              </div>
              {showSuggestions&&(searchQuery.trim()?(
                searchSuggestions.length>0&&(
                <div className={`search-suggestions${suggestionsClosing?' closing':''}`} onMouseLeave={()=>setSuggestIndex(-1)}>
                  {/* 内层滚动壳：面板本身不做滚动容器，否则绝对定位的材质层 ::before 会跟着内容滚走，
                      面板下半部分就只剩裸折射（色调层与描边环整块消失） */}
                  <div className="suggestions-scroll">
                    {searchSuggestions.map((s,i)=>(
                      <div key={i}
                        className={`suggestion-item${i===suggestIndex?' active':''}`}
                        onMouseDown={e=>e.preventDefault()}
                        onClick={()=>selectSuggestion(s)}
                        onMouseEnter={()=>setSuggestIndex(i)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
                        <span className="suggestion-text">{s}</span>
                      </div>
                    ))}
                  </div>
                </div>)
              ):(
                searchHistory.length>0&&(
                <div className={`search-suggestions search-history${suggestionsClosing?' closing':''}`} onMouseLeave={()=>setSuggestIndex(-1)}>
                  <div className="suggestions-scroll">
                    {searchHistory.slice(0,5).map((h,i)=>(
                      <div key={i}
                        className={`suggestion-item${i===suggestIndex?' active':''}`}
                        onMouseDown={e=>e.preventDefault()}
                        onClick={()=>selectSuggestion(h)}
                        onMouseEnter={()=>setSuggestIndex(i)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                        <span className="suggestion-text">{h}</span>
                        <button className="history-del" onMouseDown={e=>e.preventDefault()} onClick={e=>{e.stopPropagation();delSearchHistory(h)}} title="删除">✕</button>
                      </div>
                    ))}
                    <button className="history-clear-row" onMouseDown={e=>e.preventDefault()} onClick={clearSearchHistory}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="m19 6-1 14H6L5 6"/><path d="M10 11v5M14 11v5"/></svg>
                      <span>清空搜索记录</span>
                    </button>
                  </div>
                </div>)
              ))}
            </div>
          </div>
        </div>

        {/* Shortcuts dock */}
        <div className={`shortcuts-dock-wrapper${dockAlways?' always':''}`}>
          {!dockAlways&&<button className={`dock-toggle ${!dockExpanded?'collapsed':''}`} onClick={()=>setDockExpanded(!dockExpanded)}>
            <Icons.ChevronDown/> 快捷方式 ({shortcuts.length})
          </button>}
          <div className={`shortcuts-dock ${!dockExpanded&&!dockAlways?'hidden':''}`}>
            <div className={`shortcuts-container${dragIndex!==null?' dragging':''}${dockTransparent?' transparent':''}${openGroup?' group-open':''}`}>
              {openGroup?(()=>{
                const g=dockItems.find(s=>s.id===openGroup);
                if(!g)return null;
                const members=shortcuts.filter(s=>s.groupId===g.id&&s.type!=='group');
                const gIdx=dockItems.indexOf(g);
                const before=dockItems.filter(s=>s.id!==g.id&&dockItems.indexOf(s)<gIdx);
                const after=dockItems.filter(s=>s.id!==g.id&&dockItems.indexOf(s)>gIdx);
                return (
                  <>
                    {before.map(sc=><div key={sc.id} className="shortcut-item dock-hidden" aria-hidden="true"/>)}
                    <div key={g.id} id={'folder-'+g.id} className="shortcut-item folder-item open" onClick={()=>setOpenGroup(null)}>
                      <FolderIcon items={members.slice(0,3).map(m=>resolveIcon(m))} open={true} onClick={()=>setOpenGroup(null)}/>
                      <span ref={el=>{if(el)nameElsRef.current.set(g.id,el);else nameElsRef.current.delete(g.id)}} className="shortcut-name">{g.name}</span>
                      <span className="shortcut-delete" onClick={e=>{e.preventDefault();e.stopPropagation();handleDeleteGroup(g.id)}}>
                        <Icons.XSmall/>
                      </span>
                    </div>
                    {members.map((m,idx)=>(
                      <a key={m.id} className="shortcut-item dock-member" href={m.url} target="_blank" rel="noopener noreferrer" style={{'--i':idx}} draggable={true}
                        onDragStart={e=>{e.dataTransfer.effectAllowed='move';e.dataTransfer.setData('text/plain',m.id);popDragIdRef.current=m.id}}
                        onDragEnd={()=>{if(popDragIdRef.current){handleRemoveFromGroup(popDragIdRef.current);popDragIdRef.current=null}setTimeout(()=>{popDragDoneRef.current=true},0)}}
                        onClick={e=>{if(popDragDoneRef.current){e.preventDefault();setTimeout(()=>{popDragDoneRef.current=false},0)}}}>
                        <div className="shortcut-icon-wrap">
                          <img src={resolveIcon(m)} alt="" onError={e=>{e.target.style.display='none';e.target.nextSibling.style.display='flex'}}/>
                          <div className="shortcut-icon-fallback" style={{display:'none'}}>{getInitial(m.name)}</div>
                        </div>
                        <span ref={el=>{if(el)nameElsRef.current.set(m.id,el);else nameElsRef.current.delete(m.id)}} className="shortcut-name">{m.name}</span>
                      </a>
                    ))}
                    {after.map(sc=><div key={sc.id} className="shortcut-item dock-hidden" aria-hidden="true"/>)}
                  </>
                );
              })():<>
              {dockItems.map((sc,i)=>{
                if(sc.type==='group'){
                  const members=shortcuts.filter(s=>s.groupId===sc.id&&s.type!=='group');
                  return (
                    <div key={sc.id} id={'folder-'+sc.id}
                      className={`shortcut-item folder-item${dragIndex===i?' drag-active':''}${newShortcutId===sc.id?' pop-in':''}${openGroup===sc.id?' open':''}${dropGroupId===sc.id?' drop-target':''}`}
                      draggable={true}
                      onDragStart={e=>handleDragStart(e,i)}
                      onDragOver={e=>{e.preventDefault();if(dragIndex!==null)setDropGroupId(sc.id)}}
                      onDrop={e=>{e.preventDefault();handleDropToGroup(sc.id)}}
                      onDragEnd={handleDragEnd}>
                      <FolderIcon items={members.slice(0,3).map(m=>resolveIcon(m))} open={openGroup===sc.id} onClick={e=>{if(wasDragged.current){e.preventDefault();return}toggleGroup(sc)}}/>
                      <span ref={el=>{if(el)nameElsRef.current.set(sc.id,el);else nameElsRef.current.delete(sc.id)}} className="shortcut-name">{sc.name}</span>
                      <span className="shortcut-delete" onClick={e=>{e.preventDefault();e.stopPropagation();handleDeleteGroup(sc.id)}}>
                        <Icons.XSmall/>
                      </span>
                    </div>
                  );
                }
                return (
                  <a key={sc.id} className={`shortcut-item${dragIndex===i?' drag-active':''}${newShortcutId===sc.id?' pop-in':''}`}
                    href={sc.url} target="_blank" rel="noopener noreferrer"
                    onClick={e=>{if(wasDragged.current)e.preventDefault()}}
                    draggable={true}
                    onDragStart={e=>handleDragStart(e,i)}
                    onDragOver={e=>handleDragOver(e,i)}
                    onDragEnd={handleDragEnd}>
                    <div className="shortcut-icon-wrap">
                      <img src={resolveIcon(sc)} alt="" onError={e=>{e.target.style.display='none';e.target.nextSibling.style.display='flex'}}/>
                      <div className="shortcut-icon-fallback" style={{display:'none'}}>{getInitial(sc.name)}</div>
                    </div>
                    <span ref={el=>{if(el)nameElsRef.current.set(sc.id,el);else nameElsRef.current.delete(sc.id)}} className="shortcut-name">{sc.name}</span>
                    <span className="shortcut-delete" onClick={e=>{e.preventDefault();e.stopPropagation();handleDeleteShortcut(sc.id)}}>
                      <Icons.XSmall/>
                    </span>
                  </a>
                );
              })}
              <button className="add-shortcut-btn" onClick={()=>setShowAddShortcut(true)}>
                <div className="add-shortcut-icon"><Icons.Plus/></div>
                <span className="add-shortcut-label">添加</span>
              </button>
              </>}
            </div>
          </div>
        </div>
      </div>

      {/* Overlays */}
      {showAddShortcut&&<ShortcutModal groups={shortcuts.filter(s=>s.type==='group')} onClose={()=>setShowAddShortcut(false)} onSave={handleAddShortcut}/>}
      {showNewspaper&&<NewspaperModal onClose={()=>setShowNewspaper(false)} onGoSettings={goSettingsFromPaper}/>}
      {showSettings&&<div className={`settings-backdrop${settingsClosing?' closing':''}`} onClick={()=>{
        setSettingsClosing(true);
        setTimeout(()=>{setShowSettings(false);setSettingsClosing(false)},380);
      }}/>}
      {showSettings&&(
        <SettingsPanel initialCat={settingsCat} wallpaper={wallpaper} shortcuts={shortcuts} searchEngine={searchEngine}
          closing={settingsClosing} onClose={()=>{
            setSettingsClosing(true);
            setTimeout(()=>{setShowSettings(false);setSettingsClosing(false)},380);
          }} onWallpaperChange={handleWallpaperChange}
          onSearchEngineChange={handleSearchEngineChange}
          targetLang={targetLang} onTargetLangChange={handleTargetLangChange}
          showSearchSuggest={showSearchSuggest} onShowSuggestChange={handleShowSuggestChange}
          searchRefresh={searchRefresh} onSearchRefreshChange={handleSearchRefreshChange}
          showSearchHistory={showSearchHistory} onShowHistoryChange={handleShowHistoryChange}
          compactSuggestions={compactSuggestions} onCompactSuggestionsChange={handleCompactSuggestionsChange}
          searchHistory={searchHistory} onDelSearchHistory={delSearchHistory} onClearSearchHistory={clearSearchHistory}
          onAddShortcut={handleAddShortcut} onDeleteShortcut={handleDeleteShortcut}
          onUpdateShortcut={handleUpdateShortcut} onMoveShortcut={handleMoveShortcut}
          dockAlways={dockAlways} onDockAlwaysChange={handleDockAlwaysChange}
          dockTransparent={dockTransparent} onDockTransparentChange={handleDockTransparentChange}
          onAddGroup={handleAddGroup} onRenameGroup={handleRenameGroup}
          onDeleteGroup={handleDeleteGroup} onRemoveFromGroup={handleRemoveFromGroup}
          onMoveToGroup={handleMoveToGroup}
          onBingCacheShow={applyBingCache} onBingFetch={fetchAndCacheBing}
          fontKey={fontKey} onFontChange={handleFontChange}
          clockSize={clockSize} clockX={clockX} clockY={clockY}
          onClockSizeChange={handleClockSizeChange} onClockXChange={handleClockXChange} onClockYChange={handleClockYChange}
          clockWeight={clockWeight} onClockWeightChange={handleClockWeightChange}
          clockColor={clockColor} onClockColorChange={handleClockColorChange}
          clockSat={clockSat} onClockSatChange={handleClockSatChange}
          clockOpacity={clockOpacity} onClockOpacityChange={handleClockOpacityChange}/>
      )}
      <div className={`toast ${toastMsg?'show':''}`}>{toastMsg}</div>
    </div>
  );
}

function QomoRoot(){
  const [aiMode,setAIMode]=useState(()=>new URLSearchParams(window.location.search).get('view')==='ai');
  return aiMode?<AISearch onClose={()=>setAIMode(false)}/>:<App onOpenAI={()=>setAIMode(true)}/>;
}

ReactDOM.createRoot(document.getElementById('root')).render(<QomoRoot />);
